/* Ropa personalizada sin apps · Imprimirlo (28/09)
 *
 * Cuatro pasos y ni uno más:
 *   1 · cuántas y de qué tallas   (reparto.js)
 *   2 · dónde imprimimos          (colocacion.js)
 *   3 · tu logo para cada zona    (archivo.js + arreglo-imagen.js)
 *   4 · al carrito
 *
 * PRIMERO LA ZONA, DESPUÉS EL ARCHIVO. Antes era al revés —un logo y luego
 * dónde ponerlo— y eso hacía imposible el pedido normal de empresa: logo
 * pequeño al pecho y diseño distinto a la espalda. Con este orden cada zona
 * tiene su archivo, cada archivo se dimensiona con SU proporción, y además
 * cada producto puede decidir qué zonas ofrece (metafield custom.zonas): un
 * polo solo pecho, una camiseta de despedidas solo las grandes.
 *
 * Al carrito va una línea por talla y color. Los archivos se suben UNA vez con
 * la primera línea de cada grupo y las demás reutilizan las URL que devuelve
 * Shopify. Es el mismo truco que usa el montador con los metros.
 */
(function () {
  'use strict';

  /* NÚMERO DE VERSIÓN, pequeño a pie de página, para saber si el navegador ha cogido lo último (Xavi, 07/10). Se sube en cada publicación. */
  var VERSION_TIENDA = '12.98';
  function ponerVersion() {
    try {
      var el = document.querySelector('.ver-tienda');
      if (el) {   // lo pone la página (footer.liquid): aquí se añade el del código; si no coinciden se ven los dos
        var pag = el.getAttribute('data-pagina');
        el.textContent = ' · v' + VERSION_TIENDA + (pag && pag !== VERSION_TIENDA ? ' · página v' + pag : '');
        return;
      }
      var pie = document.querySelector('footer') || document.body, p = document.createElement('p');
      p.className = 'ver-tienda'; p.textContent = 'v' + VERSION_TIENDA;
      p.style.cssText = 'margin:8px 0 0;padding:0 0 80px;text-align:center;font-size:11px;color:inherit;opacity:.85';
      pie.appendChild(p);
    } catch (e) { /* sin número */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ponerVersion); else ponerVersion();
  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function money(c) { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); }
  /* El nombre del tramo SIN su medida («Espalda 25×30» → «Espalda»): el cliente solo debe ver la medida de lo que va a imprimir, no la del tramo de precio (Xavi, 03/11/2026: «la gente se lía»). La «Zona» que viaja en el pedido conserva el nombre entero. */
  function sinMed(n) { return String(n == null ? '' : n).replace(/\s*\d.*$/, '') || String(n == null ? '' : n); }
  function fmt(n, d) { return Number(n).toLocaleString('es-ES', { minimumFractionDigits: d || 0, maximumFractionDigits: d == null ? 1 : d }); }
  /* Una promesa con tiempo máximo: lo que no es imprescindible (guardar el diseño en el navegador) no puede dejar el botón
     «Preparando…» para siempre (IndexedDB se queda esperando si otra pestaña tiene la base abierta), y lo que sí lo es (codificar el
     archivo) falla con un mensaje en vez de colgarse. */
  function conLimite(promesa, ms, mensaje) {
    var t;
    return Promise.race([promesa, new Promise(function (ok, ko) { t = setTimeout(function () { ko(new Error(mensaje || 'tiempo agotado')); }, ms); })])
      .then(function (v) { clearTimeout(t); return v; }, function (e) { clearTimeout(t); throw e; });
  }
  /* Traza en pantalla (solo con ?diag=1): cada paso de «Añadir al carrito» con la hora, para ver DÓNDE se para en un móvil concreto. */
  function T(m) {
    /* se guarda SIEMPRE (unas 120 líneas): si el pedido falla, el informe para WhatsApp (informeError) lleva lo último */
    var L = (window.__diagLineas = window.__diagLineas || []);
    L.push(((performance.now() - (window.__diagT0 || 0)) / 1000).toFixed(1) + 's ' + m);
    if (L.length > 120) L.shift();
    var b = window.__diagBox;
    if (!b) return;
    // la caja (fina, abajo, sin bloquear toques) enseña SOLO las últimas líneas (así lo último siempre se ve, sin cortes ni scroll)
    b.textContent = L.slice(-6).join('\n');
    if (window.console) console.log('TRAZA ' + m);
  }
  /* CODIFICAR EL PNG EN OTRO HILO. En el móvil de Xavi codificar en el hilo principal se quedaba esperando decenas de segundos (y con él
     los temporizadores y el repintado). En un Worker con OffscreenCanvas el PNG se codifica aparte y el botón sigue vivo; con la medida
     (pHYs) escrita dentro, igual que ImgArreglo.pngConMedida. Si el navegador no puede, se usa la vía de siempre. */
  var _hiloPng = null, _idPng = 0;
  function codificarPNG(c, mmW, nombre) {
    var vieja = function () {
      return (window.ImgArreglo && ImgArreglo.pngConMedida)
        ? ImgArreglo.pngConMedida(c, mmW, nombre)
        : new Promise(function (ok, ko) { c.toBlob(function (b) { b ? ok(new File([b], nombre, { type: 'image/png' })) : ko(new Error('png')); }, 'image/png'); });
    };
    /* VÍA DE LA PRUEBA: en el móvil de Xavi, un lienzo normal (sin willReadFrequently) codifica 5,8 MP en 149 ms (prueba del diagnóstico),
       pero el lienzo del editor y el Worker se quedaban 60 s con la página congelada. Se copia a un lienzo normal y se codifica ahí. */
    var viaPrueba = function () {
      return new Promise(function (ok, ko) {
        if (window.__diagBox) {   // control: un lienzo sintético de 1 MP, ahora, con la página en este estado
          var tb = performance.now(), cb0 = document.createElement('canvas'); cb0.width = cb0.height = 1000;
          var xb = cb0.getContext('2d'); xb.fillStyle = '#c33'; xb.fillRect(0, 0, 1000, 1000); xb.fillStyle = '#39c'; xb.arc(500, 500, 300, 0, 7); xb.fill();
          cb0.toBlob(function (bb) { T('    control 1 MP sintético: ' + Math.round(performance.now() - tb) + ' ms (' + (bb ? Math.round(bb.size / 1024) : 0) + ' KB)'); });
        }
        var t0c = performance.now(), n = document.createElement('canvas'); n.width = c.width; n.height = c.height;
        n.getContext('2d').drawImage(c, 0, 0);
        T('    png: drawImage ' + Math.round(performance.now() - t0c) + ' ms');
        T('    png: copiado a lienzo normal, toBlob…');
        n.toBlob(function (b) {
          n.width = n.height = 1;
          if (!b) return ko(new Error('png'));
          T('    png: toBlob devuelve ' + Math.round(b.size / 1024) + ' KB');
          b.arrayBuffer().then(function (ab) {
            var png = new Uint8Array(ab), ppm = Math.max(1, Math.round(c.width / (mmW / 1000))), bq = new Uint8Array(21), dv = new DataView(bq.buffer);
            var t = [], k, x = 0xFFFFFFFF, i, j;
            for (i = 0; i < 256; i++) { k = i; for (j = 0; j < 8; j++) k = k & 1 ? 0xEDB88320 ^ (k >>> 1) : k >>> 1; t[i] = k >>> 0; }
            dv.setUint32(0, 9); bq.set([112, 72, 89, 115], 4); dv.setUint32(8, ppm); dv.setUint32(12, ppm); bq[16] = 1;
            for (i = 4; i < 17; i++) x = t[(x ^ bq[i]) & 255] ^ (x >>> 8);
            dv.setUint32(17, (x ^ 0xFFFFFFFF) >>> 0);
            var out = new Uint8Array(png.length + 21);
            out.set(png.subarray(0, 33), 0); out.set(bq, 33); out.set(png.subarray(33), 54);
            ok(new File([out], nombre, { type: 'image/png' }));
          }, ko);
        }, 'image/png');
      });
    };
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
      return viaPrueba().catch(function (e) { T('    png: vía de prueba falla (' + (e && e.message) + ')'); return vieja(); });
    }
    if (!(window.Worker && window.OffscreenCanvas && window.createImageBitmap && window.URL && URL.createObjectURL)) return vieja();
    T('    png: createImageBitmap…');
    return createImageBitmap(c).then(function (bmp) {
      T('    png: bitmap listo ' + bmp.width + 'x' + bmp.height + ', al hilo');
      return new Promise(function (ok, ko) {
        try {
          if (!_hiloPng) {
            var src = "function crc(b){var t=crc.t;if(!t){t=crc.t=[];for(var n=0;n<256;n++){var k=n;for(var j=0;j<8;j++)k=k&1?0xEDB88320^(k>>>1):k>>>1;t[n]=k>>>0;}}var x=0xFFFFFFFF;for(var i=0;i<b.length;i++)x=t[(x^b[i])&255]^(x>>>8);return(x^0xFFFFFFFF)>>>0;}" +
              "self.onmessage=async function(e){var d=e.data;try{var oc=new OffscreenCanvas(d.bmp.width,d.bmp.height);oc.getContext('2d').drawImage(d.bmp,0,0);var bl=await oc.convertToBlob({type:'image/png'});var png=new Uint8Array(await bl.arrayBuffer());" +
              "var ppm=Math.max(1,Math.round(d.bmp.width/(d.mmW/1000)));var bq=new Uint8Array(21),dv=new DataView(bq.buffer);dv.setUint32(0,9);bq.set([112,72,89,115],4);dv.setUint32(8,ppm);dv.setUint32(12,ppm);bq[16]=1;dv.setUint32(17,crc(bq.subarray(4,17)));" +
              "var fin=33,out=new Uint8Array(png.length+21);out.set(png.subarray(0,fin),0);out.set(bq,fin);out.set(png.subarray(fin),fin+21);self.postMessage({id:d.id,buf:out.buffer},[out.buffer]);}catch(err){self.postMessage({id:d.id,error:String(err&&err.message||err)});}};";
            _hiloPng = new Worker(URL.createObjectURL(new Blob([src], { type: 'text/javascript' })));
          }
          var w = _hiloPng, id = ++_idPng;
          /* Varias codificaciones a la vez (el ordenador prepara dos caras en paralelo) comparten el hilo: cada una con su id,
             porque con un solo onmessage la segunda pisaba a la primera y esta se quedaba esperando hasta el tiempo máximo. */
          if (!w._pend) {
            w._pend = {};
            w.onmessage = function (ev) {
              var d = ev.data || {}, p = w._pend[d.id];
              if (!p) return;
              delete w._pend[d.id];
              T('    png: el hilo devuelve ' + (d.buf ? Math.round(d.buf.byteLength / 1024) + ' KB' : 'error'));
              if (d.buf) p.ok(new File([d.buf], p.nombre, { type: 'image/png' }));
              else p.ko(new Error(d.error || 'hilo'));
            };
            w.onerror = function () {
              var pend = w._pend || {};
              try { w.terminate(); } catch (e2) { /* ya cerrado */ }
              _hiloPng = null;
              Object.keys(pend).forEach(function (k) { pend[k].ko(new Error('hilo')); });
            };
          }
          w._pend[id] = { ok: ok, ko: ko, nombre: nombre };
          w.postMessage({ id: id, bmp: bmp, mmW: mmW }, [bmp]);
        } catch (e) { ko(e); }
      });
    }).catch(function (e) { T('    png: vía del hilo falla (' + (e && e.message) + '), uso toBlob'); return vieja(); });
  }
  function slug(s) { return String(s).toLowerCase().normalize('NFD').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function lista(a) {
    return a.length < 2 ? (a[0] || '') : a.slice(0, -1).join(', ') + ' y ' + a[a.length - 1];
  }
  /* Cómo se llama un arte para el cliente. Si es un texto, la frase que
     escribió: el nombre del fichero que generamos no le dice nada a nadie. */
  function etiqueta(d) {
    return !d ? '' : d.texto ? '«' + d.texto.texto.replace(/\n/g, ' / ') + '»' : d.name;
  }

  /* LOS PPP A LOS QUE SE VA A IMPRIMIR DE VERDAD, en un solo sitio.
   *
   * La medida entra en CENTÍMETROS, así que se divide por 2,54. Estaba
   * dividiendo por 25,4 —la constante de los milímetros, que es la que usan con
   * razón las fichas de DTF, tarjetas y pegatinas porque ahí se trabaja en
   * mm— y eso multiplicaba por diez todos los ppp. Dos consecuencias, las dos
   * silenciosas: el pedido anotaba "2968 ppp" donde había 297, y el aviso de
   * archivo flojo NUNCA saltaba, porque con un cero de más ningún archivo
   * bajaba del mínimo. Estaba en tres copias; ahora en una.
   */
  function pppDe(d, cm) {
    if (!d || !d.px || !cm) return 0;
    return (d.pxCalidad || d.px)[0] / (cm / 2.54);
  }

  /* Cuánto del dibujo se puede camuflar con la prenda antes de avisar.
     Medido con los logos de clientes de verdad: un logo de colores con fondo
     blanco sobre camiseta blanca da 0,29; uno con bastante tinta blanca, 0,60;
     un logo enteramente blanco sobre blanca, 1,00. En 0,70 solo saltan los que
     de verdad desaparecen. Avisar de más sobre la camiseta blanca, que es la
     que más se vende, sería peor que no avisar. */
  var CAMUFLAJE = 0.7;

  var seq = 0;

  /* CÓMO SE LLAMA LO QUE SE ESTÁ CONTANDO. Una taza no es una prenda, y leer
     "1 prenda · 12,00 €" en la ficha de una taza canta muchísimo. El resto de
     la ropa comparte palabra, así que solo hay que nombrar las excepciones. */
  var SUSTANTIVOS = { taza: ['taza', 'tazas'], bolsa: ['bolsa', 'bolsas'], gorra: ['gorra', 'gorras'],
    delantal: ['delantal', 'delantales'], camiseta: ['camiseta', 'camisetas'], polo: ['polo', 'polos'],
    sudadera: ['sudadera', 'sudaderas'] };

  /* LA ZONA QUE VIENE MARCADA AL ABRIR LA FICHA. Xavi: «la de delante, la
     normal, la que no es grande». Venía marcado el pecho izquierdo solo porque
     es el primero del catálogo, y el pedido típico de la web no es un bolsillo
     de empresa: es un diseño en el pecho.
     Si la prenda no ofrece esa zona —la laboral solo tiene pecho izquierdo y
     omóplatos, la taza sus caras— se queda con la primera de su lista, así que
     esto no hay que tocarlo prenda por prenda. */
  var ZONA_INICIAL = 'pecho-centrado';

  /* Las tallas SIEMPRE en orden (Xavi, 17/10/2026): el orden de las opciones en Shopify no manda (en la Express salían XL antes que L y un cliente
     se hizo un lío con las cantidades). XS, S, M, L, XL, 2XL…; las numéricas (niño en años, bebé en meses) por su número. */
  var ORDEN_TALLAS = ['xxs', 'xs', 's', 'm', 'l', 'xl', '2xl', 'xxl', '3xl', 'xxxl', '4xl', 'xxxxl', '5xl', '6xl'];
  function rangoTalla(txt) {   // null si no es una talla de ropa que se sepa ordenar (sellos, delantal «Adulto/Niño», medidas…)
    var t = String(txt).toLowerCase().replace(/\s+/g, '');
    if (t === 'xxl') t = '2xl'; else if (t === 'xxxl') t = '3xl'; else if (t === 'xxxxl') t = '4xl';
    var i = ORDEN_TALLAS.indexOf(t);
    if (i >= 0) return 5000 + i;
    if (/^\d+(-\d+)?$/.test(t)) return 1000 + parseFloat(t);                     // niño: 3-4, 9-11…
    var m = t.match(/^(\d+)(mes(es)?|m|años?|a)$/);
    if (m) return (/^m/.test(m[2]) ? 0 : 1000) + parseFloat(m[1]);                // bebé en meses, niño en años
    return null;
  }
  function ordenarTallas(lista) {
    var l = (lista || []).map(function (t, i) { return { t: t, i: i, r: rangoTalla(t) }; });
    if (l.some(function (o) { return o.r === null; })) return lista;              // si alguna no se reconoce, se respeta el orden de la tienda
    return l.sort(function (a, b) { return a.r - b.r || a.i - b.i; }).map(function (o) { return o.t; });
  }

  function Ropa(raiz) {
    this.raiz = raiz;
    this.cfg = JSON.parse($(raiz, '[data-ropa-config]').textContent);
    if (this.cfg.tallas && this.cfg.tallas.length) this.cfg.tallas = ordenarTallas(this.cfg.tallas);
    this.prenda = this.cfg.prenda || 'camiseta';
    /* La prenda con foto: se carga aparte y, en cuanto llega, se repinta. */
    var yo = this;
    if (window.Colocacion && Colocacion.fotos && this.cfg.fotos) {
      Colocacion.fotos(this.cfg.fotos, function (k) { if (k === yo.prenda && yo.resumen) yo.actualizar(); });
    }
    // bolsa y taza tienen sus propias zonas; el resto de ropa comparte lista
    this.familia = (window.Colocacion && Colocacion.POSICIONES[this.prenda]) ? this.prenda : 'ropa';
    /* El catálogo de zonas vive en colocacion.js; el producto solo dice cuáles
       admite. Lista vacía = todas. */
    this.catalogo = window.Colocacion
      ? Colocacion.zonas(this.familia, this.cfg.zonas)
      : [];
    /* OBJETOS con editor (29/09): sus zonas no están en colocacion.js, cada
       producto trae las suyas enteras (objeto-editor.liquid, zonasLibre). */
    if (this.cfg.zonasLibre && this.cfg.zonasLibre.length) this.catalogo = this.cfg.zonasLibre;
    /* colores reales del proveedor (objeto-editor.liquid, hexes): pisan al muestrario de Shopify,
       que es aproximado, para que la prenda teñida y las bolitas salgan del color de verdad */
    if (this.cfg.coloresHexObjeto && this.cfg.coloresHex) {
      for (var kh in this.cfg.coloresHexObjeto) { if (this.cfg.coloresHexObjeto[kh]) this.cfg.coloresHex[kh] = this.cfg.coloresHexObjeto[kh]; }
    }
    /* Verdes de la taza más oscuros (Xavi): el muestrario de Shopify se comparte con la ropa, así que se pisa solo aquí */
    if (this.prenda === 'taza' && this.cfg.coloresHex) {
      if (this.cfg.coloresHex['Verde']) this.cfg.coloresHex['Verde'] = '#0f8f3a';
      if (this.cfg.coloresHex['Verde Claro']) this.cfg.coloresHex['Verde Claro'] = '#4fbf6a';
    }
    /* MANGA LARGA: las mangas no se estampan (Xavi, 26/09: «la ropa de manga
       larga no se puede personalizar las mangas»). Se quitan aquí además de en
       el metafield, para que una ficha sin lista de zonas no las recupere. */
    var MANGA_LARGA = { 'manga-larga': 1, sudadera: 1, 'sudadera-lisa': 1, 'sudadera-cremallera': 1, 'sudadera-corta': 1 };
    if (MANGA_LARGA[this.prenda]) {
      this.catalogo = this.catalogo.filter(function (z) { return !/^manga-/.test(z.id); });
    }
    /* DTG 40 × 50 (14/10/2026): la camiseta 24h DTG admite el recuadro grande (cfg.zonaGrande). Las dos superficies del editor libre pasan de
       30 × 40 a 40 × 50 (la de espalda se corre a la derecha de la de pecho) y el tramo «40×50» (+5 €) entra en cfg.tramos. */
    if (this.cfg.zonaGrande) {
      this.catalogo = this.catalogo.map(function (z) {
        if (!z.libre || !z.cajas) return z;
        var n = {}; for (var k in z) n[k] = z[k];
        /* Las MANGAS (9,5 × 9,5) no crecen: solo se corren a la derecha, detrás de la espalda más ancha (60 → 80, 70 → 90). Antes pasaban a
           40 × 50 con la ventana de la espalda: el mismo dibujo salía en las tres zonas (se cobraban las dos mangas) y borrarlo de una lo borraba de todas. */
        if (/^manga-/.test(z.id)) { if (z.ventana) n.ventana = [z.ventana[0] + 20, 0]; return n; }
        n.cajas = [[40, 50]];
        if (z.ventana) n.ventana = [z.ventana[0] ? 40 : 0, 0];
        return n;
      });
    }
    /* Lo que la PRENDA no admite aunque la ficha lo marque: en la sudadera
       corta no hay lumbar (el cuerpo acaba antes) y la espalda es más baja.
       colocacion.js lo dice por prenda (sinZonas, cajasZona). */
    var pr = window.Colocacion && Colocacion.PRENDAS[this.prenda];
    if (pr && (pr.sinZonas || pr.cajasZona || pr.tercioZona)) {
      this.catalogo = this.catalogo.filter(function (z) {
        return !(pr.sinZonas && pr.sinZonas.indexOf(z.id) !== -1);
      }).map(function (z) {
        var c = pr.cajasZona && pr.cajasZona[z.id];
        var t = pr.tercioZona && pr.tercioZona[z.id];
        if (!c && t == null) return z;
        var n = {}; for (var k in z) n[k] = z[k];
        if (c) n.cajas = c;
        if (t != null) n.tercio = t;   // la altura: qué parte del logo queda por encima de la axila
        return n;
      });
    }
    /* Zonas elegidas, EN EL ORDEN EN QUE LAS HA IDO MARCANDO. La primera va
       incluida en el precio de la prenda; cada una de las siguientes es una
       zona extra que se cobra. */
    this.elegidas = this.catalogo.length ? [this.zonaInicial().id] : [];
    /* El archivo de cada zona: { zonaId: dato }. Y las excepciones por color de
       prenda: { zonaId + '·' + color: dato }. Si un logo no se ve sobre un
       color, se le pide la versión buena para ESE color en vez de arreglárselo
       nosotros: así el cliente acaba pidiendo un solo color, o los que le
       funcionan, que es justo lo que interesa. */
    this.arte = {};
    this.arteColor = {};
    /* El formulario de texto abierto, si hay alguno: { zona, colorPrenda,
       texto, fuente, tinta }. Solo puede haber uno a la vez — escribir dos
       frases al mismo tiempo no es algo que nadie haga. */
    this.form = null;
    /* Los dorsales, si la prenda los admite: { clave de fila: {nombre, numero} }.
       No van en `arte` a propósito. Un arte es UN fichero que se sube una vez y
       vale para todas las prendas; un dorsal es distinto en cada prenda y el
       archivo de corte lo saca el taller con plotter/dorsales.py. Lo único que
       comparten es el dibujo, y eso se resuelve fabricando una previa. */
    this.dorsales = {};
    this.dorTinta = (this.cfg.dorsales && this.cfg.dorsales.tinta) || 'auto';
    // sellos: una sola tinta (negra); los nombres también van en negro y no se ofrece elegir color
    if (this.cfg.tintaFija) { this.dorTinta = 'negro'; raiz.classList.add('rop--tinta'); }
    this.dorFuente = (this.cfg.dorsales && this.cfg.dorsales.fuente) || 'gruesa';
    this.colorVista = null;   // color de prenda que se está enseñando
    this.urgente = false;     // producción en 24 h
    this.busy = false;
    this.resumen = { lineas: [], unidades: 0, bruto: 0 };
    this.bind();
    this.montarVistas();
    this.montarEditorLibre();
    if (/[?&]diag=1/.test(location.search)) { var yoD = this; setTimeout(function () { yoD.diagnostico(); }, 3500); }
    this.actualizar();
  }

  /* El lienzo grande, en el hueco de la foto del producto (fuera de esta
     raíz .rop: vive en la galería, otra sección). Por ahora, una sola zona
     libre por producto (la primera del catálogo que lo sea); elegir entre
     varias es cosa de una pieza futura. */
  /* El rail (Añadir imagen/texto, Quitar fondo) lo cablea el propio
     EditorLibre.montar(), no aquí: son detalles suyos, y ropa.js no
     necesita saber qué botones tiene ni qué hace cada uno. */
  Ropa.prototype.montarEditorLibre = function () {
    if (!window.EditorLibre) return;
    var host = document.querySelector('[data-libre-editor-host]');
    var vistas = this.catalogo.filter(function (z) { return z.libre; });
    var zona = vistas[0];
    if (!host || !zona) return;
    this._zonaLibre = zona;
    /* Dos maneras de cobrar el editor:
       · taza: la superficie entera (la panorámica) es LA zona del pedido y
         el diseño compuesto va como su "logo"; se cobra un lado o la
         panorámica según dónde caiga lo puesto (zonaCobroLibre).
       · camiseta (cfg.tramos): cada cara es una zona con su archivo, y se
         cobra por el tramo de tamaño más barato en el que cabe lo puesto
         en esa cara (tramoDe). No hay superficie común. */
    this._tramos = this.cfg.tramos || null;
    if (this.cfg.serigrafia && this.cfg.serigrafia.porTec && !this.cfg.serigrafia.tramos) this.tablaPorTecnica();   // arranca con la tabla de la primera técnica
    /* impresión incluida en el precio (etiqueta `impresion-incluida`, la
       camiseta 24h DTG): los tramos se quedan como medida, pero a 0 € y sin
       variante, así la ficha pone "incluida" y no añade nada al carrito */
    if (this._tramos && this.cfg.impresionIncluida) {
      var ti = {};
      Object.keys(this._tramos).forEach(function (k) {
        ti[k] = (this._tramos[k] || []).map(function (t) { var n = {}; for (var q in t) n[q] = t[q]; if (!t.extra && !t.cobrar) { n.precio = 0; n.variante = null; } return n; });   // los tramos «extra» (DTG 40×50, +5 €) sí se cobran
      }, this);
      this._tramos = ti;
    }
    var yo0 = this;
    this._zonaSuperficie = this._tramos ? null : vistas.slice().sort(function (a, b) {
      return Colocacion.area(b)[0] - Colocacion.area(a)[0];
    })[0];
    // sin nada puesto se cobra como un lado; la zona real la decide recalcularLibre() en cada cambio
    this.elegidas = [(vistas.filter(function (z) { return z !== yo0._zonaSuperficie; })[0] || this._zonaSuperficie).id];
    // la vista arranca en el primer color del catálogo y solo cambia al pinchar otro
    if (this.cfg.casillasColor && this.cfg.colores && this.cfg.colores.length) {
      this.colorVista = this.cfg.colores[0];
      this.colorFijado = true;
    }
    var yo = this;
    if (this._tramos && this.cfg.colores && this.cfg.colores.length > 1) host.classList.add('edl__host--colores');
    this._editorLibre = EditorLibre.montar(host, {
      prenda: this.prenda, zona: zona, vistas: vistas,
      // al cambiar el diseño, la zona que se cobra puede cambiar (un lado / panorámica)
      onCambio: function () { yo.actualizar(); },
      colorHex: this.hexDe(this.colorVista) || this.hexPorDefecto(),
      colorNombre: this.colorVista || null, // objetos: foto por color (fotosLibre[vista].porColor)
      fotos: this.cfg.fotosLibre || null, // camiseta: una foto por vista
      // con tramos, una imagen nueva arranca en el tramo normal (el segundo), no ocupando media cara
      tamañoInicialCm: this.tamañoInicialLibre(),
      // los tamaños de impresión con precio (10×10, 20×25…): al redimensionar, el diseño se pega a lo que justo cabe en cada uno
      // tramos «estrictos» (pecho de la laboral): el diseño no puede pasar del tamaño del tramo mayor
      maxCmPorZona: (function (tr) {
        var out = null;
        Object.keys(tr || {}).forEach(function (k) {
          var l = tr[k] || [];
          if (!l.length || !l.every(function (t) { return t.estricto; })) return;
          var m = l.slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; })[0];
          (out = out || {})[k] = [m.w, m.h];
        });
        return out;
      })(this._tramos),
      // y esos mismos tramos con 2º pecho (`segundo`): dos cajas, una por pecho, pegadas a los lados de la zona
      cajasPorZona: (function (tr, cat) {
        var out = null;
        Object.keys(tr || {}).forEach(function (k) {
          var l = tr[k] || [], z = cat.filter(function (c) { return c.id === k; })[0];
          if (!z || !l.length || !l.every(function (t) { return t.estricto; }) || !l.some(function (t) { return t.segundo; })) return;
          var m = l.slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; })[0], ancho = Colocacion.area(z)[0];
          (out = out || {})[k] = [[0.5, 0.5, m.w, m.h], [ancho - 0.5 - m.w, 0.5, m.w, m.h]];
        });
        return out;
      })(this._tramos, this.catalogo),
      tamañosTipicosCm: (function (tr) {
        var vistos = {}, out = [];
        Object.keys(tr || {}).forEach(function (k) { (tr[k] || []).forEach(function (t) { var id = t.w + 'x' + t.h; if (!vistos[id]) { vistos[id] = 1; out.push([t.w, t.h]); } }); });
        return out;
      })(this._tramos),
      // camiseta: línea de axilas a 10 cm del borde de arriba del recuadro (30 × 40 con 1/4 por encima)
      // null = sin línea de axilas (objetos); solo si no viene nada se usa la de la camiseta
      axilaCm: this.cfg.axilaCm !== undefined ? this.cfg.axilaCm : (this._tramos ? 10 : null),
      // el botón "Dorsales" del móvil, en la vista de espalda; al pulsarlo se activa el dorsal
      vistaDorsal: (this._tramos && window.Dorsales && this.zonaDe(Dorsales.ZONA))
        ? (vistas.filter(function (z) { return z.cara === 'espalda'; })[0] || {}).id || null : null,
      onDorsal: function () { /* el botón «Lista» solo abre la ventana con la lista */ },
      dorsalTipo: this.prenda === 'camiseta' ? 'camiseta' : 'objeto',   // dónde nace el dorsal por defecto
      onCompra: function () { yo.pintarPrevia(); try { yo.pintarDetalle(); } catch (eD) { /* sin detalle */ } },
      hayCantidad: function () { return !!(yo.resumen && yo.resumen.unidades); },
      fotoFondo: this.cfg.fotoLibre || null,
      fotoMascara: this.cfg.fotoLibreMascara || null,
      fotoBlanca: this.cfg.fotoLibreBlanca || null,
      quitarBlanco: !!this.cfg.quitarBlanco,
      // difuminar bordes solo en sublimación (taza, cojín, bidón): en DTF queda mal
      difuminarBordes: !!this.cfg.sublimado,
      mascarasBorde: this.cfg.mascarasBorde || null,
      onVista: function (z) {
        yo.vistaASello(z);
        /* taza en móvil: la panorámica es baja y ancha, así que se agranda hasta llenar el ancho (y al volver a un lado, se encoge) */
        yo._vistaActual = z;
        if (yo.prenda === 'taza' && yo._editorLibre && document.documentElement.classList.contains('edl-fijo')) {
          var hh = yo._editorLibre; try { hh.redimensionar(yo.anchoEditor(document.querySelector('.rop-libre-wrap .edl__host') || document.body)); } catch (eV) { /* se queda como está */ }
        }
      },
      alComprar: function () { return yo.irACompra(); },   // móvil: la compra va en otra página (ver irACompra)
      tintaFija: this.cfg.tintaFija || null,
      sinSemitono: this.cfg.imprime === 'midocean' || !!this.cfg.serigrafia,   // MidOcean (serigrafía con tramos): sin semitono; en Roly/JHK (DTF) sí
      tecnicas: this._tecnicasConMinimo(),   // técnicas de impresión del proveedor (límite de colores del logo)
      pppMin: this.cfg.pppMin || undefined,   // gran formato (lonas): resolución mínima propia
      margenCm: this.cfg.tintaFija ? 0 : undefined,   // sellos: toda la zona del modelo es imprimible // sellos: una sola tinta (el diseño se pasa a ese color)
      ancho: this.anchoEditor(host)
    });
    this.montarGuardarCargar(host);
    /* Ropa con editor: las bolitas de color también sobre la prenda, en el
       aire que queda a su derecha (Xavi: "alrededor de la camiseta caben
       opciones"). Cambian el color de la fila de cantidades y la vista. */
    if ((this._tramos || this.prenda === 'taza') && this.cfg.colores && this.cfg.colores.length > 1) {
      var edl = host.querySelector('.edl');
      if (edl) {
        /* Los colores, UNA bolita por gama (Xavi, 06/10: «pica en el azul y salen los azules»): la bolita enseña el color elegido de su
           gama; al pulsarla se abre al lado un recuadro con sus tonos. Una gama con un solo tono lo elige directo. */
        var tira = document.createElement('div');
        var fams = this.gamasColor(this.cfg.colores);
        /* Si TODOS los colores caben en la columna, cada uno va en su bolita, sin agrupar por gamas (Xavi, 24/10/2026: «cuando caben los colores
           en pantalla ponlos todos»). La columna arranca ~54 px bajo la barra y deja ~90 px a la barra de abajo; cada bolita ocupa ~34 px.
           Con más colores de los que caben se mantiene el agrupado por gamas de siempre. */
        // al montar, el editor aún no tiene su alto final (en móvil se abre a pantalla completa): se cuenta con el alto de la ventana
        var altoEd = Math.max(edl.getBoundingClientRect().height || 0, (window.innerHeight || 0) * 0.9);
        if (altoEd && this.cfg.colores.length * 34 + 40 <= altoEd - 54 - 90) {
          fams = [].concat.apply([], fams.map(function (f) { return f.colores; })).map(function (c) { return { nombre: c, colores: [c] }; });
        }
        tira.className = 'rop-libre-colores rop-libre-colores--1';
        var totalCol = this.cfg.colores.length;
        // «20 colores» arriba y el número de tonos de cada gama en su bolita: que se vea que hay mucho más que siete colores
        tira.innerHTML = '<div class="rop-libre-colores__cab"><b>' + totalCol + '</b> colores</div>' + fams.map(function (f, fi) {
          return '<div class="rop-libre-colores__f" data-fam="' + fi + '">' +
            '<button type="button" class="rop-libre-colores__b rop-libre-colores__fb" data-fam-btn="' + fi + '" title="' + esc(f.nombre) + '" aria-label="' + esc(f.nombre) + '" aria-expanded="false" style="background:' + esc(yo.hexDe(f.colores[0]) || '#e9e9ee') + '">' + (f.colores.length > 1 ? '<span class="rop-libre-colores__n">' + f.colores.length + '</span>' : '') + '</button>' +
            (f.colores.length > 1 ? '<div class="rop-libre-colores__fly" hidden><span class="rop-libre-colores__t">' + esc(f.nombre) + '</span>' + f.colores.map(function (c) {
              return '<button type="button" class="rop-libre-colores__b" data-color-vista="' + esc(c) + '" title="' + esc(c) + '" aria-label="' + esc(c) + '" style="background:' + esc(yo.hexDe(c) || '#e9e9ee') + '"></button>';
            }).join('') + '</div>' : '') + '</div>';
        }).join('');
        var cerrarGamas = function () {
          Array.prototype.forEach.call(tira.querySelectorAll('.rop-libre-colores__fly'), function (x) { x.hidden = true; });
          Array.prototype.forEach.call(tira.querySelectorAll('[data-fam-btn]'), function (x) { x.setAttribute('aria-expanded', 'false'); });
        };
        var elegir = function (c) {
          if (yo.rep && yo.rep.unColor && yo.rep.elegirColor) yo.rep.elegirColor(c);
          else { yo.colorFijado = true; yo.colorVista = c; yo.actualizar(); }
        };
        tira.addEventListener('click', function (e) {
          var b = e.target.closest && e.target.closest('[data-color-vista]');
          if (b) { cerrarGamas(); elegir(b.dataset.colorVista); return; }
          var fb = e.target.closest && e.target.closest('[data-fam-btn]');
          if (!fb) return;
          var fam = fams[+fb.dataset.famBtn], fly = fb.parentNode.querySelector('.rop-libre-colores__fly');
          if (!fly) { cerrarGamas(); elegir(fam.colores[0]); return; }
          var abierta = !fly.hidden;
          cerrarGamas();
          if (!abierta) { fly.hidden = false; fb.setAttribute('aria-expanded', 'true'); }
        });
        document.addEventListener('click', function (e) { if (!tira.contains(e.target)) cerrarGamas(); });
        this._gamasColor = fams;
        var barraV = host.querySelector('.edl__vistas');
        host.appendChild(tira);   // fuera del lienzo: en móvil ocupa su propia columna a la derecha
        this._tiraColores = tira;
      }
    }
    /* El hueco cambia de tamaño después de montar (la página termina de
       repartirse, o el cliente cambia la ventana): el editor se ajusta al
       ancho real sin perder lo puesto. */
    var self = this, temporizador = null;
    var ajustar = function () {
      if (self._editorLibre) self._editorLibre.redimensionar(self.anchoEditor(host));
      self.encajarColumna(host);
    };
    window.addEventListener('load', ajustar);
    // objetos: en cuanto se sabe lo alta que es la foto, se reajusta el ancho para que quepa en pantalla
    var fl = this.cfg.fotosLibre, fPrimera = fl && fl[zona.id];
    if ((this.cfg.zonasLibre || this.cfg.fotosLibre) && fPrimera && fPrimera.fondo) {
      var imAsp = new Image();
      imAsp.onload = function () { if (imAsp.naturalWidth) { self._aspectoFoto = imAsp.naturalHeight / imAsp.naturalWidth; ajustar(); } };
      imAsp.src = fPrimera.fondo;
    }
    window.addEventListener('resize', function () {
      clearTimeout(temporizador); temporizador = setTimeout(ajustar, 150);
    });
    setTimeout(ajustar, 0);
    // en la ficha con editor, fuera la burbuja de WhatsApp (tapaba el botón de comprar)
    if (EditorLibre.sinWhatsapp) EditorLibre.sinWhatsapp();
    // ¿venimos de "Editar diseño" del carrito? se recupera todo
    var esta = this;
    setTimeout(function () { esta.cargarEdicion(); esta.cargarCompra(); if (esta.esSello() && !esta.resumen.unidades) esta.vistaASello(zona); }, 0);
  };

  /* Gamas de color: agrupa los colores de la prenda por tono (por el hex del muestrario) para que el cliente elija primero la gama y
     luego el tono. Devuelve [{ nombre, colores: [nombres] }] en el orden de la paleta. */
  Ropa.prototype.gamasColor = function (colores) {
    var self = this, grupos = [], idx = {};
    function gama(hex) {
      var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || ''); if (!m) return 'Otros';
      var r = parseInt(m[1], 16) / 255, g = parseInt(m[2], 16) / 255, b = parseInt(m[3], 16) / 255;
      var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn, sat = d ? d / (1 - Math.abs(2 * l - 1)) : 0, h = 0;
      if (d) { h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; h = (h * 60 + 360) % 360; }
      if (l > 0.84 && sat < 0.45) return 'Blancos y cremas';
      if (sat < 0.12) return 'Negros y grises';
      if (h < 15 || h >= 340) return 'Rojos y granates';
      if (h < 62) return 'Naranjas y amarillos';
      if (h < 165) return 'Verdes';
      if (h < 255) return 'Azules';
      return 'Rosas y morados';
    }
    var orden = ['Blancos y cremas', 'Negros y grises', 'Azules', 'Verdes', 'Rojos y granates', 'Naranjas y amarillos', 'Rosas y morados', 'Otros'];
    (colores || []).forEach(function (c) {
      var n = gama(self.hexDe(c));
      if (!(n in idx)) { idx[n] = grupos.length; grupos.push({ nombre: n, colores: [] }); }
      grupos[idx[n]].colores.push(c);
    });
    return grupos.sort(function (a, b) { return orden.indexOf(a.nombre) - orden.indexOf(b.nombre); });
  };
  // la bolita de cada gama enseña el color elegido si es de su gama; el tono elegido lleva el aro
  Ropa.prototype.pintarTiraColores = function (cv) {
    if (!this._tiraColores || !this._gamasColor) return;
    var self = this, tira = this._tiraColores;
    Array.prototype.forEach.call(tira.querySelectorAll('[data-color-vista]'), function (b) { b.classList.toggle('is-sel', b.dataset.colorVista === cv); });
    this._gamasColor.forEach(function (f, fi) {
      var fb = tira.querySelector('[data-fam-btn="' + fi + '"]'), esta = f.colores.indexOf(cv) >= 0;
      if (!fb) return;
      var hx = self.hexDe(esta ? cv : f.colores[0]) || '#e9e9ee', mm = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hx);
      fb.style.background = hx;
      // el número de tonos va dentro de la bolita: blanco sobre colores oscuros, negro sobre claros
      var n = fb.querySelector('.rop-libre-colores__n');
      if (n && mm) n.style.color = (0.299 * parseInt(mm[1], 16) + 0.587 * parseInt(mm[2], 16) + 0.114 * parseInt(mm[3], 16)) / 255 > 0.6 ? '#111' : '#fff';
      fb.classList.toggle('is-sel', esta);
    });
  };

  /* PC: la columna de compra fluye con la página. Se probó encajarla a la
     altura del editor con scroll propio (29/09) y Xavi lo descartó: "no me
     gusta el editor dentro de una caja, sale ese scroll repetido". */
  Ropa.prototype.encajarColumna = function () {
    var info = document.querySelector('.product--libre .product__info-wrapper');
    if (info) { info.style.maxHeight = ''; info.style.overflowY = ''; }
  };

  /* El lienzo crece con la columna: el ancho del hueco (o, si aún no está
     repartido, el de la columna de la foto menos el rail), entre 420 y
     980 px. */
  Ropa.prototype.anchoEditor = function (host) {
    /* taza en móvil: las bolitas de color flotan a la derecha y tapaban el producto (Xavi, 02/10): se reserva una columna a la derecha */
    var conDots = (this.prenda === 'taza' || this._tramos) && this.cfg.colores && this.cfg.colores.length > 1 &&
      window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    /* columna reservada a la derecha para las bolitas (Xavi, 06/10: «los colores no pueden estar encima del área»):
       una columna de 36 px hasta 12 colores; con más, dos columnas (58 px) */
    /* 06/10 (Xavi: «optimiza mejor el espacio para móvil»): las bolitas ya no ocupan una columna a la derecha, que encogía la prenda;
       van en una tira bajo la prenda (ver editor-libre.css), y la prenda usa todo el ancho. */
    var reserva = conDots ? 36 : 0;   // una sola columna: una bolita por gama
    host.classList.toggle('con-colores-der', !!conDots);
    host.style.paddingRight = conDots ? reserva + 'px' : '';
    var w = host.clientWidth - reserva;
    if (!w || w < 100) {
      var col = host.closest('.product__media-wrapper');
      w = col ? col.clientWidth - 150 - 12 : 620;
    }
    /* y que la taza entera quepa en pantalla con la barra de vistas: la
       foto es casi cuadrada (0,94 de alto por ancho), así que el ancho se
       limita también por la altura de la ventana menos cabecera y vistas */
    /* objetos (29/09, Xavi: "en escritorio se va de tamaño"): la foto del
       bidón es alta (1,5 de alto por ancho) y con 0,88 salía de 1.100 px; se
       usa el aspecto real de la foto en cuanto carga (_aspectoFoto) */
    var enMovil = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    // en el móvil la camiseta también usa el aspecto real de su foto (1,2 de alto por ancho): que quepa con las vistas y la tira de colores
    /* camisetas (Xavi, 22/10: «que la camiseta no se vea tan grande y así se vean las vistas de debajo»): también en el PC se usa el aspecto
       real de su foto (más alta que ancha); con el 0,88 de siempre la prenda salía de 730 px y las vistas (espalda, mangas) quedaban bajo el pliegue */
    var aspecto = ((this.cfg.zonasLibre || enMovil || (this.cfg.fotosLibre && this.prenda !== 'taza')) && this._aspectoFoto) || 0.88;
    if (this.prenda === 'taza' && enMovil && this._vistaActual && /panoram/.test(this._vistaActual.id || '')) aspecto = 0.62;   // la panorámica es ancha y baja
    /* lo que queda de pantalla por debajo de donde empieza el editor (la
       cabecera de la web, con el menú, mide lo que mida), menos la tira de
       vistas y el aire; con 200 px fijos las vistas de la taza se salían
       (Xavi, 29/09: "la taza se puede poner más arriba para que entren") */
    var tope = host.getBoundingClientRect().top + (window.pageYOffset || 0);
    if (!(tope > 0 && tope < 400)) tope = 200;
    // con una sola vista no hay tira de miniaturas debajo: se reserva solo el aire
    var nVistas = this.catalogo.filter(function (z) { return z.libre; }).length;
    // móvil con la tira de círculos de colores debajo (unas tres filas): también se reserva su alto
    // móvil: la barra de herramientas ocupa la primera franja del editor
    var tiraColores = window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 48 : 0;
    var hueco = Math.max(300, (window.innerHeight || 900) - tope - (nVistas > 1 ? 110 : 30) - tiraColores);
    /* taza en móvil con la línea fija (editor-libre.css): el producto tiene una altura fija encima de la línea; que la taza entera quepa ahí */
    if (this.prenda === 'taza' && enMovil && document.documentElement.classList.contains('edl-fijo') && host.clientHeight > 150) {
      hueco = Math.max(200, host.clientHeight - 38 - (nVistas > 1 ? 74 : 8));
    }
    var porAlto = hueco / aspecto;
    /* nunca más ancho que el hueco (en el móvil el mínimo de 420 hacía que
       el CSS encogiera el lienzo en ancho pero no en alto: taza aplastada) */
    var minimo = Math.min(420, w - 8);
    return Math.round(Math.min(760, porAlto, Math.max(minimo, w - 8)));
  };

  Ropa.prototype.zonaInicial = function () {
    var pref = this.catalogo.filter(function (z) { return z.id === ZONA_INICIAL; })[0];
    return pref || this.catalogo[0];
  };

  /* ---------- la vista de la prenda ----------
   *
   * El panel que enseña la prenda con los logos puestos, en el color elegido y
   * a la escala real. Va en DOS sitios y manda el CSS cuál se ve:
   *
   *   - en PC, en la columna de la foto, pegado al scroll. Ese espacio estaba
   *     muerto: una foto fija de un tío con una camiseta que no es la suya.
   *   - en móvil no hay dos columnas, así que va justo encima del botón, que
   *     es el último empujón antes de pagar.
   *
   * La FOTO manda hasta que hay algo que enseñar. El de la foto es lo que vende
   * en los tres primeros segundos y es lo que sale en Google; en cuanto el
   * cliente sube un logo, el panel la sustituye y ya no vuelve en esa visita.
   */
  Ropa.prototype.montarVistas = function () {
    this.vistas = $$(this.raiz, '[data-vista]');
    /* La columna de la foto no es un bloque de la plantilla, así que no se
       puede poner ahí desde Liquid: hay que buscarla. Si el tema cambia y no
       aparece, no pasa nada — se queda solo la vista de dentro de la ficha. */
    var col = document.querySelector('.product__media-wrapper, .product__media-gallery');
    if (!col) return;
    var v = document.createElement('div');
    v.className = 'rop-vista rop-vista--media';
    v.setAttribute('data-vista', '');
    v.hidden = true;
    col.insertBefore(v, col.firstChild);
    this.galeria = col;
    this.vistas.push(v);
  };

  Ropa.prototype.pintarVista = function () {
    if (!this.vistas || !this.vistas.length || !window.Colocacion) return;
    /* Con editor libre la simulación sobra: el cliente ya ve su diseño sobre
       la foto. Al añadir al carrito se colaba el dibujo plano encima del
       editor (Xavi, 28/09). */
    if (this._editorLibre) { this.vistas.forEach(function (v) { v.hidden = true; v.innerHTML = ""; }); return; }
    var self = this, color = this.colorVista;
    var hex = this.hexDe(color) || this.hexPorDefecto();
    // solo las zonas que YA tienen archivo: enseñar recuadros vacíos aquí no aporta
    var conArte = this.zonas().filter(function (z) { return !!self.artePara(z.id, color); });

    /* SE AGRUPA POR CARA. Antes salía un dibujo por zona y parecían camisetas
       distintas: el que pedía pecho y espalda veía dos prendas y contaba dos.
       Es una prenda por delante y otra por detrás, con todo lo suyo puesto. */
    var caras = [];
    conArte.forEach(function (z) {
      /* Una cara es cualquier vista distinta de la prenda, no solo delante y
         espalda: la taza tiene lado izquierdo, lado derecho y panorámica. Cada
         cara es un dibujo; meterlas todas en "delante" apilaba los logos en la
         misma taza uno encima de otro. */
      var cara = z.cara || 'delante';
      var g = caras.filter(function (x) { return x.cara === cara; })[0];
      if (!g) { g = { cara: cara, zonas: [] }; caras.push(g); }
      g.zonas.push(z);
    });

    /* Mientras no haya ningún logo, la foto del producto se queda. */
    var hay = conArte.length > 0;
    if (this.galeria) this.galeria.classList.toggle('rop-galeria-oculta', hay);

    this.vistas.forEach(function (v) {
      v.hidden = !hay;
      if (!hay) { v.innerHTML = ''; return; }
      var firma = conArte.map(function (z) {
        var d = self.artePara(z.id, color);
        return z.id + ':' + (d._id || '') + ':' + (d.arreglos || []).length;
      }).join('|') + '|' + hex;
      if (v.dataset.firma !== firma) {
        v.innerHTML = '<div class="rop-vista__g">' + caras.map(function (g) {
          return '<figure class="rop-vista__p"><canvas data-vp="' + esc(g.cara) + '"></canvas>' +
            '<figcaption>' + esc(Colocacion.caraNombre(g.cara)) +
            '<span data-vp-cm="' + esc(g.cara) + '"></span>' +
            '</figcaption></figure>';
        }).join('') + '</div>' +
        /* Es un dibujo, no una foto: sirve para el TAMAÑO y la COLOCACIÓN, que
           es lo que el cliente necesita decidir aquí. Decirlo evita la
           reclamación de "en la web se veía de otra manera". */
        '<p class="rop-vista__n">Esto es una simulación para que veas el tamaño ' +
        'y dónde cae el logo. El resultado final puede ser algo diferente.</p>';
        v.dataset.firma = firma;
      }
      /* El dibujo se adapta al ancho que haya: en la columna de la foto puede
         salir grande, y en el móvil se encoge solo. */
      var hueco = (v.clientWidth || 320) - 28 - (caras.length - 1) * 14;
      var ancho = Math.max(140, Math.min(340, Math.floor(hueco / caras.length)));
      caras.forEach(function (g) {
        var lienzo = v.querySelector('[data-vp="' + g.cara + '"]');
        if (!lienzo) return;
        var artes = g.zonas.map(function (z) { return self.artePara(z.id, color).thumb; });
        var pxs = g.zonas.map(function (z) { return self.artePara(z.id, color).px; });
        var res = Colocacion.varias(lienzo, self.prenda, g.zonas,
          { ancho: ancho, color: hex, arte: artes, px: pxs });
        /* Lupa al pasar por encima. No amplía el dibujo pequeño —se vería
           borroso—: vuelve a dibujar la misma prenda en grande y enseña un
           trozo. Solo se dibuja si alguien se acerca a mirar. */
        if (window.Lupa) {
          Lupa.enganchar(lienzo, function () {
            var big = document.createElement('canvas');
            Colocacion.varias(big, self.prenda, g.zonas,
              { ancho: 1100, color: hex, arte: artes, px: pxs });
            return big;
          });
        }
        var cm = v.querySelector('[data-vp-cm="' + g.cara + '"]');
        // una línea por impresión: qué zona y a qué medida sale
        if (cm) {
          cm.innerHTML = g.zonas.map(function (z, i) {
            return res[i] ? esc(z.nombre) + ' ' + fmt(res[i][0], 1) + ' × ' +
              fmt(res[i][1], 1) + ' cm' : '';
          }).filter(Boolean).join('<br>');
        }
      });
    });
  };

  /* ---------- zonas ---------- */
  Ropa.prototype.zonaDe = function (id) {
    return this.catalogo.filter(function (z) { return z.id === id; })[0] || null;
  };
  // los objetos de zona elegidos, en orden de elección
  Ropa.prototype.zonas = function () {
    var self = this;
    return this.elegidas.map(function (id) { return self.zonaDe(id); })
      .filter(function (z) { return !!z; });
  };

  /* ---------- dorsales ----------
     El dorsal es una zona más para elegirla y para dibujarla, y una cosa aparte
     para todo lo demás: no lleva archivo, no se cobra como zona extra y va en su
     propia línea de pedido con su escalera de precio. */
  Ropa.prototype.esDorsal = function (id) {
    return !!(window.Dorsales && id === Dorsales.ZONA);
  };
  Ropa.prototype.hayDorsal = function () {
    if (this._tramos || this._editorLibre) { var ed0 = this._editorLibre; return !!(ed0 && ed0.hayDorsal && ed0.hayDorsal()); }
    var self = this;
    return this.elegidas.some(function (id) { return self.esDorsal(id); });
  };
  /* Las zonas que se pagan como impresión de logo: la primera va incluida en la
     prenda y las demás son zonas extra. El dorsal NO entra en esa cuenta —ya se
     cobra a 12,95/9,95/6,95— y tampoco gasta la que va incluida: si alguien pide
     dorsal y un logo al pecho, el logo sigue siendo el que viene con la prenda. */
  Ropa.prototype.zonasPago = function () {
    var self = this;
    return this.elegidas.filter(function (id) { return !self.esDorsal(id); });
  };
  // con editor libre el dorsal se cobra como una impresión más (por tamaño), sin tramos propios
  Ropa.prototype.cfgDor = function () { return (this._tramos || this._editorLibre) ? null : (this.cfg.dorsales || null); };

  // las filas de dorsales que toca enseñar, una por prenda pedida
  Ropa.prototype.dorFilas = function () {
    if (!window.Dorsales) return [];
    var fs = Dorsales.filas(this.resumen.lineas || []);
    Dorsales.limpiar(this.dorsales, fs);
    return fs;
  };
  /* Los dorsales escritos, cada uno YA con el color de letra que le toca. En
     automático depende del color de SU prenda, así que se resuelve aquí, que es
     el único sitio que sabe qué hex tiene cada color de la tienda. */
  Ropa.prototype.dorValidos = function () {
    if (!window.Dorsales) return [];
    var self = this;
    return Dorsales.validos(this.dorsales, this.dorFilas()).map(function (d) {
      d.tinta = Dorsales.tintaPara(self.dorTinta, self.hexDe(d.color)).id;
      return d;
    });
  };
  // el color de letra que se está enseñando en la previa
  Ropa.prototype.dorHex = function () {
    return Dorsales.tintaPara(this.dorTinta, this.hexDe(this.colorVista)).hex;
  };
  Ropa.prototype.dorBanda = function () {
    if (this._tramos || this._editorLibre) return null;   // con editor libre no hay precio de dorsal aparte
    var n = this.dorValidos().length;
    return (window.Dorsales && n) ? Dorsales.banda(this.cfgDor(), n) : null;
  };
  Ropa.prototype.dorTotal = function () {
    var b = this.dorBanda();
    return b ? b.precio * this.dorValidos().length : 0;
  };

  /* La previa del dorsal, con la forma de un arte para que la vista, el paso 2 y
     el mockup no tengan que enterarse de nada. Lleva `dorsal: true` y NO lleva
     `file`: quien sube archivos al carrito se salta estas. Se enseña el PRIMER
     dorsal escrito, que es el que da la medida; los demás son iguales de alto. */
  Ropa.prototype.dorArte = function () {
    if (!window.Dorsales) return null;
    var lista = this.dorValidos();
    if (!lista.length) return null;
    var d = lista[0];
    /* La firma lleva TODA la lista, no solo el primero: el alto es el que le
       cabe al peor apellido del pedido, así que escribir un nombre largo en la
       última fila cambia el dibujo de la primera. */
    var hex = this.dorHex();
    var firma = lista.map(function (x) { return x.nombre + x.numero; }).join(',') +
      '|' + hex + '|' + this.dorFuente;
    if (this._dorCache && this._dorCache._firma === firma) return this._dorCache;
    var r = Dorsales.pinta(d, hex, this.dorFuente,
      Dorsales.alturas(lista, this.dorFuente));
    if (!r) return null;
    this._dorCache = {
      _id: 'dorsal-' + firma, _firma: firma, dorsal: true,
      name: 'dorsal-' + (d.numero || '') + '.pdf',
      thumb: r.lienzo, px: [r.lienzo.width, r.lienzo.height]
    };
    return this._dorCache;
  };

  // lo que impide seguir por culpa de los dorsales, o null si van bien
  Ropa.prototype.faltaDorsal = function () {
    if (!this.hayDorsal() || !window.Dorsales) return null;
    return Dorsales.falta(this.dorsales, this.dorFilas()) ||
      (this.dorInvisible() ? 'Cambia el color de la letra del dorsal' : null);
  };

  /* Si la letra y la prenda son casi del mismo tono, el dorsal no se ve. Aquí
     no hay archivo que analizar como en los logos, así que se compara el brillo,
     que es lo que decide de verdad si se lee desde lejos. En automático no puede
     pasar: cada prenda lleva el color que contrasta con ella. */
  Ropa.prototype.dorInvisible = function () {
    if (!window.Dorsales || !this.hayDorsal() || !this.dorValidos().length) return null;
    if (this.dorTinta === 'auto') return null;
    var self = this, bt = Dorsales.brillo(Dorsales.tintaDe(this.dorTinta).hex);
    if (bt == null) return null;
    var malos = this.coloresElegidos().filter(function (c) {
      var bp = Dorsales.brillo(self.hexDe(c));
      return bp != null && Math.abs(bp - bt) < 0.22;
    });
    return malos.length ? malos : null;
  };

  // técnicas del editor con su mínimo de unidades (primer tramo de precio) para mostrarlo en el botón
  Ropa.prototype._tecnicasConMinimo = function () {
    var ts = this.cfg.tecnicas, s = this.cfg.serigrafia;
    if (!ts) return null;
    return ts.map(function (t) {
      var tr = s && s.porTec && s.porTec[t.id], m = tr && tr.length ? tr[0].min : 0, c = {};
      for (var k in t) c[k] = t[k];
      if (m > 1) c.minUds = m;
      var mx = s && s.max && s.max[t.id];
      if (mx) c.maxUds = mx;
      return c;
    });
  };
  Ropa.prototype.maxTecnica = function (id) {
    var s = this.cfg.serigrafia;
    return (s && s.max && s.max[id]) || 0;
  };
  Ropa.prototype.minTecnica = function (id) {
    var s = this.cfg.serigrafia, tr = s && s.porTec && s.porTec[id];
    return tr && tr.length && tr[0].min > 1 ? tr[0].min : 0;
  };
  // ¿vale esta técnica para esta cantidad? (mínimo = primer tramo; máximo = cfg.serigrafia.max[id])
  Ropa.prototype.tecnicaValeParaUds = function (id, uds) {
    var s = this.cfg.serigrafia, t = s && s.porTec && s.porTec[id];
    if (!t || !t.length) return true;
    var max = (s.max && s.max[id]) || Infinity;
    return uds >= t[0].min && uds <= max;
  };
  // mensaje si ninguna técnica sirve para esta cantidad (no debería pasar: el todo color vale desde 1 ud)
  Ropa.prototype.tecnicaMala = function (uds) {
    var s = this.cfg.serigrafia, ed = this._editorLibre;
    if (!s || !s.porTec || !ed || !ed.tecnicaInfo) return '';
    var info = ed.tecnicaInfo(), id = info && info.id;
    if (!id || this.tecnicaValeParaUds(id, uds)) return '';
    var t = s.porTec[id], mx = this.maxTecnica(id);
    return uds < t[0].min ? 'Esta impresión empieza en ' + t[0].min + ' uds'
      : (mx && uds > mx) ? 'Esta impresión llega hasta ' + mx + ' uds' : '';
  };
  /* Si la técnica elegida (serigrafía) tiene un mínimo y el cliente lleva menos, NO se cambia sola: pasado un momento sin tocar la cantidad sale un aviso
     que le explica el mínimo y le deja elegir (pasar a todo color o subir la cantidad). Una vez por técnica y cantidad. */
  Ropa.prototype.ajustaTecnicaPorCantidad = function (uds) {
    var s = this.cfg.serigrafia, ed = this._editorLibre, self = this;
    if (!uds || !s || !s.porTec || !ed || !ed.tecnicaInfo || !ed.fijarTecnica) return;
    var info = ed.tecnicaInfo(), id = info && info.id;
    clearTimeout(this._tmTecAviso);
    if (!id || this.tecnicaValeParaUds(id, uds)) return;
    var otro = Object.keys(s.porTec).filter(function (k) { return this.tecnicaValeParaUds(k, uds); }, this)[0];
    var clave = id + ':' + uds;
    if (!otro || this._tecPreguntada === clave) return;
    this._tmTecAviso = setTimeout(function () {
      var i2 = ed.tecnicaInfo(), uds2 = (self.resumen && self.resumen.unidades) || 0;
      if (!i2 || i2.id !== id || self.tecnicaValeParaUds(id, uds2) || document.querySelector('.rop-tecaviso')) return;
      self._tecPreguntada = id + ':' + uds2;
      var min = s.porTec[id][0].min, mx = self.maxTecnica(id), pasado = !!(mx && uds2 > mx);
      var tOtro = (self.cfg.tecnicas || []).filter(function (t) { return t.id === otro; })[0];
      /* el nombre de la otra técnica sale de la propia ficha (tampografía, láser…); «serigrafía a 1 color» solo si no se sabe */
      var nombreOtro = otro === 'tdt' ? 'todo color' : (tOtro && tOtro.nombre ? String(tOtro.nombre).charAt(0).toLowerCase() + String(tOtro.nombre).slice(1) : 'serigrafía a 1 color'), minOtro = self.minTecnica(otro) || 1;
      var d = document.createElement('div');
      d.className = 'rop-tecaviso';
      d.innerHTML = '<div class="rop-tecaviso__caja" role="dialog" aria-modal="true"><p><strong>La ' + (i2.nombre || 'serigrafía').toLowerCase() +
        (pasado ? ' llega hasta ' + mx : ' tiene un mínimo de ' + min) + ' ' + self.sust(2) + '.</strong></p>' +
        '<p>Ahora llevas ' + uds2 + '. ' + (pasado ? 'Puedes bajar la cantidad a ' + mx + ' o menos, o imprimirlas a ' : 'Puedes subir la cantidad a ' + min + ' o más, o imprimirlas a ') + nombreOtro + ' desde ' + minOtro + (minOtro === 1 ? ' ud' : ' uds') + '.</p>' +
        '<button type="button" class="rop-tecaviso__si">Imprimir a ' + nombreOtro + '</button>' +
        '<button type="button" class="rop-tecaviso__no">' + (pasado ? 'Cambiar la cantidad' : 'Subir a ' + min + ' ' + self.sust(2)) + '</button></div>';
      document.body.appendChild(d);
      var cerrar = function () { if (d.parentNode) d.parentNode.removeChild(d); };
      d.querySelector('.rop-tecaviso__si').addEventListener('click', function () {
        cerrar();
        self._ajustandoTec = true;
        try { ed.fijarTecnica(otro); } finally { self._ajustandoTec = false; }
        if (self.actualizar) self.actualizar();
      });
      d.querySelector('.rop-tecaviso__no').addEventListener('click', function () {
        cerrar();
        if (pasado) return;   // se queda con la técnica y cambia la cantidad a mano
        // sube la cantidad hasta el mínimo: suma lo que falta en la primera casilla de cantidad
        var r = self.rep, f = r && r.filas && r.filas[0], t = f && f.campos && Object.keys(f.campos)[0], dif = min - ((self.resumen && self.resumen.unidades) || 0);
        if (f && t != null && dif > 0) r.sumar(f.color, t, dif);
      });
    }, 1200);
  };

  /* Tablas de precio por técnica (botellas, 08/10): cfg.serigrafia.porTec = {"tdt":[tramos],"seri1":[tramos]}. El resto del código lee
     cfg.serigrafia.tramos, así que se deja ahí la tabla de la técnica elegida en la primera zona con diseño (o la primera técnica). */
  Ropa.prototype.tablaPorTecnica = function () {
    var s = this.cfg.serigrafia;
    if (!s || !s.porTec) return;
    var ed = this._editorLibre, tz = ed && ed.tecnicasPorZona ? ed.tecnicasPorZona() : [], id = tz.length ? tz[0].id : null;
    if (!id && ed && ed.tecnicaInfo) { var ti = ed.tecnicaInfo(); id = ti && ti.id; }
    var t = (id && s.porTec[id]) || s.porTec[Object.keys(s.porTec)[0]];
    if (t) s.tramos = t;
    /* el precio base lo traen las líneas (precio de la variante de Shopify, el mismo para las dos técnicas): se sustituye por el del primer
       tramo de la técnica elegida; el descuento por cantidad ya se calcula respecto a ese primer tramo (_escalones) */
    var res = this.resumen;
    if (t && res && res.unidades) res.bruto = res.unidades * t[0].precio;
  };
  /* ---------- escalones ---------- */
  /* Serigrafía por tramos de diseño (cfg.serigrafia): los tramos son precios por unidad; se expresan como el porcentaje
     que baja el precio respecto al del primer tramo, para que el resto de la ficha (que trabaja con escalones) los entienda. */
  Ropa.prototype._escalones = function () {
    var s = this.cfg.serigrafia;
    if (s && s.tramos && s.tramos.length > 1) {
      var base = s.tramos[0].precio;
      return s.tramos.slice(1).map(function (t) { return [t.min, Math.round((1 - t.precio / base) * 1e6) / 1e4]; });
    }
    return this.cfg.escalones || [];
  };
  Ropa.prototype.tramoSerigrafia = function (n) {
    var s = this.cfg.serigrafia, t = null;
    if (!s || !s.tramos) return null;
    s.tramos.forEach(function (x) { if (n >= x.min) t = x; });
    return t;
  };
  // precio y variante de un tramo según las zonas de impresión (1 = la primera, incluida; cada una más suma el extra del tramo)
  /* Cada color de cada zona es una PANTALLA de serigrafía (un montaje). La primera va incluida en el precio base; cada pantalla
     de más suma el extra del tramo. Una zona con 3 colores son 3 pantallas, y una zona nueva de 1 color, una más. */
  Ropa.prototype.pantallas = function () {
    var ed = this._editorLibre, tz = ed && ed.tecnicasPorZona ? ed.tecnicasPorZona() : [];
    if (tz.length) return tz.reduce(function (n, t) { return n + (t.pantallas || t.usados || 1); }, 0);   // todo color (transfer digital): cuenta como las pantallas que indique la técnica
    return Math.max(1, this.zonasPago().length);
  };
  Ropa.prototype.maxPantallas = function () {
    var vz = ((this.cfg.serigrafia || {}).tramos || [{}])[0].vz;
    return vz ? vz.length : 1;
  };
  Ropa.prototype.zonasSer = function () { return Math.max(1, Math.min(this.pantallas(), this.maxPantallas())); };
  /* Zonas con diseño (máx. 3 online: es lo que cubren las variantes de precio), para cobrar la zona extra: una zona de más cuesta más
     que un color de más (lleva su propio montaje de impresión). Vale también para el precio por color del tramo. */
  Ropa.prototype.zonasDis = function () {
    var ed = this._editorLibre, tz = ed && ed.tecnicasPorZona ? ed.tecnicasPorZona() : [];
    return Math.max(1, Math.min(tz.length || this.zonasPago().length || 1, this.zonasSer(), 3));
  };
  /* Precio por prenda de un tramo: base + (pantallas − 1) × extra del color + (zonas − 1) × suplemento de zona. El suplemento solo
     existe si el tramo trae `vzz` (variantes por pantallas y zonas); sin él se cobra como antes. */
  Ropa.prototype.precioSer = function (t, z, zz) {
    zz = zz == null ? this.zonasDis() : zz;
    return t.precio + (z - 1) * (t.extra || 0) + (t.vzz ? Math.max(0, zz - 1) * (t.extraZona || 0) : 0);
  };
  Ropa.prototype.descuento = function (uds) {
    var mejor = 0;
    this._escalones().forEach(function (e) {
      if (uds >= e[0] && e[1] > mejor) mejor = e[1];
    });
    return mejor;
  };
  Ropa.prototype.siguienteEscalon = function (uds) {
    var sig = null;
    this._escalones().forEach(function (e) {
      if (uds < e[0] && (!sig || e[0] < sig[0])) sig = e;
    });
    return sig;
  };

  /* Zona extra: precio POR PRENDA según cuántas prendas lleve. No es un
     descuento de Shopify a propósito — si lo fuera, 1 prenda + 1 zona serían
     2 unidades en el carrito y le saltaría el descuento de la prenda. */
  Ropa.prototype.bandaZona = function (uds) {
    var ser = this.cfg.serigrafia;
    if (ser && ser.tramos) {   // serigrafía por tramos: el extra por zona del tramo en que cae (o del primero si aún no llega al mínimo)
      var ts = this.tramoSerigrafia(uds) || ser.tramos[0];
      return ts && ts.extra ? { precio: ts.extra, serig: true } : null;
    }
    var ze = this.cfg.zonaExtra || {};
    /* Una prenda puede tener su propia tarifa y saltarse la escalera: en la
       taza la segunda cara es 1 € fijo, porque la escalera de 5 € de la ropa
       costaba más que la propia taza. */
    var bandas = (ze.porPrenda && ze.porPrenda[this.prenda]) || ze.bandas || [];
    for (var i = 0; i < bandas.length; i++) {
      var b = bandas[i];
      if (uds >= b.desde && (b.hasta == null || uds <= b.hasta)) return b;
    }
    return null;
  };

  // lo que suman las zonas extra: todas las de pago menos la primera
  Ropa.prototype.extras = function (uds) {
    /* serigrafía por tramos: cada zona de más suma el «extra» de SU tramo (no hay línea aparte: va en el precio de la línea) */
    var ser = this.cfg.serigrafia, trs = ser && this.tramoSerigrafia(uds), nz = this.cfg.serigrafia ? Math.max(0, this.pantallas() - 1) : 0;
    if (trs && trs.extra) {
      // por prenda: lo que suman los colores de más y, si hay más de una zona, el suplemento de zona de ese tramo
      var ud = nz ? trs.extra * nz + (trs.vzz ? Math.max(0, this.zonasDis() - 1) * (trs.extraZona || 0) : 0) : 0;
      return nz ? { banda: { precio: ud, serig: true }, zonas: nz, ud: ud, total: ud * uds } : { banda: null, zonas: 0, total: 0 };
    }
    var b = this.bandaZona(uds), n = Math.max(0, this.zonasPago().length - 1);
    return (b && n) ? { banda: b, zonas: n, total: b.precio * n * uds }
                    : { banda: b, zonas: n, total: 0 };
  };

  /* La variante que se añade al carrito para un tramo. Casi siempre es una sola; la laboral de 150 g (sin huecos para más
     descuentos automáticos en Shopify) trae una variante POR BANDA de cantidad con el recargo ya descontado
     (`bandas`: [{desde, variante}…]), y se elige la de las unidades que lleva el pedido. El precio de lista (`precio`) no cambia:
     la ficha lo enseña con el descuento por cantidad, que coincide con el de la variante de la banda. */
  Ropa.prototype.varianteDeBanda = function (tramo) {
    if (!tramo) return null;
    if (!tramo.bandas || !tramo.bandas.length) return tramo.variante || null;
    var uds = (this.resumen && this.resumen.unidades) || 0, v = tramo.bandas[0].variante;
    tramo.bandas.forEach(function (b) { if (uds >= b.desde) v = b.variante; });
    return v;
  };

  /* Los tramos «estrictos» (el pecho de la laboral: solo 10 × 10) no se pueden pasar: lo que sobra no se cobraría. Devuelve el
     aviso para el cliente si algo se pasa (o es una imagen de fondo entera), o '' si todo cabe. */
  Ropa.prototype.excesoTramo = function () {
    var self = this, aviso = '';
    if (!this._tramos || !this._editorLibre) return '';
    this.catalogo.filter(function (z) { return z.libre; }).forEach(function (z) {
      var lista = (self._tramos || {})[z.id];
      if (aviso || !lista || !lista.length || !lista.every(function (t) { return t.estricto; })) return;
      var oc = self._editorLibre.ocupadoEn && self._editorLibre.ocupadoEn(z);
      if (!oc) return;
      var mayor = lista.slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; })[0];
      if (oc.fondo || oc.w > mayor.w + 0.15 || oc.h > mayor.h + 0.15) {
        aviso = 'En el ' + String(z.nombre || z.id).toLowerCase() + ' de esta camiseta el diseño puede medir hasta ' + mayor.w + ' × ' + mayor.h + ' cm. Redúcelo para poder pedirla.';
      }
    });
    return aviso;
  };

  /* RECARGOS DE ZONA: lo que cuesta elegir una zona concreta, sea la primera o
     no. Es otra cosa que la zona extra, que se cobra por ser la segunda.
     La panorámica de la taza vale 2 € aunque sea lo único que se pida: es una
     plancha que da la vuelta entera, no una cara más. */
  Ropa.prototype.recargos = function () {
    var tabla = this.cfg.recargos || {}, self = this;
    /* Con precio por tramo (camiseta): un recargo por cara usada, el del
       tramo en que cabe lo puesto; el que va incluido (pecho 10×10) sale
       a 0 y sin variante, para que la ficha lo diga y el carrito no lo cobre. */
    if (this._tramos) {
      var lista = [];
      this.elegidas.forEach(function (id) {
        var z = self.zonaDe(id), r = z && self.tramoDe(z);
        if (!r) return;
        lista.push({ zona: id, nombre: self.nombreTramo(z, r), precio: r.tramo.precio || 0,
                     variante: self.varianteDeBanda(r.tramo), tramo: r.tramo, ocupado: r.ocupado });
        /* con dos cajas (los dos pechos de la laboral) un logo en cada una: el segundo se cobra aparte (`segundo` del tramo) */
        var sg = r.tramo.segundo;
        if (sg && r.ocupado && r.ocupado.cajas > 1) {
          lista.push({ zona: id, nombre: sg.nombre, precio: sg.precio || 0, variante: self.varianteDeBanda(sg), tramo: sg, ocupado: null });
        }
      });
      return lista;
    }
    return this.elegidas.map(function (id) {
      var x = tabla[id];
      if (!x || !x.precio) return null;
      var z = self.zonaDe(id);
      return { zona: id, nombre: (z && z.nombre) || x.nombre || '',
               precio: x.precio, variante: x.id };
    }).filter(Boolean);
  };
  /* Con tramos (camiseta) la impresión lleva el MISMO descuento por cantidad
     que la prenda: siete descuentos automáticos "Impresión camiseta · desde N"
     sobre el producto de impresión (28/09, Xavi: "así no entrará volumen").
     Se redondea por línea, como hace Shopify. */
  Ropa.prototype.totalRecargos = function (uds) {
    var desc = this._tramos ? this.descuento(uds) : 0;
    return this.recargos().reduce(function (n, x) { return n + Math.round(x.precio * uds * (1 - desc / 100)); }, 0);
  };

  /* ---------- colores de la prenda ---------- */
  Ropa.prototype.hexDe = function (nombre) {
    return (this.cfg.coloresHex || {})[nombre] || '';
  };
  /* El gris '#e9e9ee' de toda la vida vale para una prenda cualquiera, pero
     hay prendas con un solo color de verdad (la bolsa, crema) que declaran
     su `colorPorDefecto` en colocacion.js: sin eso, un producto sin opción
     de color (como la bolsa, Title/Default Title) salía siempre gris. */
  Ropa.prototype.hexPorDefecto = function () {
    var p = window.Colocacion && Colocacion.PRENDAS && Colocacion.PRENDAS[this.prenda];
    return (p && p.colorPorDefecto) || '#e9e9ee';
  };

  // los colores que ha pedido, sin repetir y en el orden en que los puso
  Ropa.prototype.coloresElegidos = function () {
    var out = [];
    (this.resumen.lineas || []).forEach(function (l) {
      if (out.indexOf(l.color) === -1) out.push(l.color);
    });
    return out;
  };

  /* El archivo que le toca a una zona sobre un color de prenda: el propio de
     ese color si lo hay, y si no el general de la zona. */
  Ropa.prototype.artePara = function (zonaId, color) {
    // el dorsal no tiene archivo: lo que hay es una previa que se fabrica sola
    if (this.esDorsal(zonaId)) return this.dorArte();
    return (color && this.arteColor[zonaId + '·' + color]) || this.arte[zonaId] || null;
  };

  // todos los archivos distintos que hay en la ficha, para poder reutilizarlos
  Ropa.prototype.archivos = function () {
    var out = [], self = this;
    this.elegidas.forEach(function (id) {
      var d = self.arte[id];
      if (d && out.indexOf(d) === -1) out.push(d);
    });
    Object.keys(this.arteColor).forEach(function (k) {
      var d = self.arteColor[k];
      if (d && out.indexOf(d) === -1) out.push(d);
    });
    return out;
  };

  /* EL COLOR SOBRE EL QUE SE IMPRIME DE VERDAD. En una camiseta roja es el
     rojo; en una taza «roja» el cuerpo es blanco y lo rojo son el asa y el
     interior, así que medir el camuflaje contra el rojo diría tonterías —y al
     revés, dejaría pasar un logo blanco sobre cerámica blanca, que es el caso
     que de verdad no se ve. Lo declara la propia forma en colocacion.js. */
  Ropa.prototype.hexImpresion = function (nombre) {
    var f = window.Colocacion && Colocacion.prendaDe(this.prenda);
    if (f && f.fondoImpresion) return f.fondoImpresion;
    return this.hexDe(nombre);
  };

  /* Cuánto se camufla un archivo sobre un color. Se guarda en el propio dato
     porque leer los píxeles en cada repintado sería tirar el tiempo. */
  Ropa.prototype.riesgo = function (dato, color) {
    var hex = this.hexImpresion(color);
    if (!dato || !hex || !window.Archivo || !Archivo.camuflaje) return 0;
    if (!dato._cam) dato._cam = {};
    if (dato._cam[hex] == null) dato._cam[hex] = Archivo.camuflaje(dato, hex);
    return dato._cam[hex];
  };

  /* Los pares zona+color en los que el logo se pierde y aún no hay uno propio.
     Es una matriz porque ahora cada zona lleva su archivo: puede fallar el de
     la espalda sobre negro y estar perfecto el del pecho. */
  Ropa.prototype.sinResolver = function () {
    var self = this, out = [];
    this.elegidas.forEach(function (id) {
      // el dorsal se comprueba por brillo, no por píxeles: ver dorInvisible()
      if (self.esDorsal(id)) return;
      self.coloresElegidos().forEach(function (c) {
        var d = self.artePara(id, c);
        if (d && self.riesgo(d, c) >= CAMUFLAJE) out.push({ zona: id, color: c });
      });
    });
    return out;
  };

  /* Zonas elegidas que todavía no tienen archivo. El dorsal no cuenta: lo que le
     falta a un dorsal no es un logo, son nombres, y eso lo dice dorsales.js con
     su propio aviso. */
  Ropa.prototype.zonasSinArte = function () {
    var self = this;
    return this.elegidas.filter(function (id) {
      var z = self.zonaDe(id);
      // en una zona libre "hay logo" cuando el editor tiene algo puesto
      if (z && z.libre) return !(self._editorLibre && self._editorLibre.hayDiseño());
      return !self.esDorsal(id) && !self.arte[id];
    });
  };

  /* QUÉ ZONA SE COBRA en un producto con editor (Xavi): la panorámica solo
     si hay imagen o color de fondo, o si hay objetos en los dos lados (o
     algo pisa la parte de atrás); si todo está en un lado, ese lado.
     Izquierda + derecha cuesta lo mismo que la panorámica. */
  Ropa.prototype.zonaCobroLibre = function () {
    var ed = this._editorLibre, sup = this._zonaSuperficie;
    if (!ed || !sup) return null;
    var lados = this.catalogo.filter(function (z) { return z.libre && z !== sup; });
    if (!lados.length) return sup;
    var els = ed.elementos(), pos = ed.posicionesCm(), usa = {}, centro = false, fondo = false;
    els.forEach(function (e, i) {
      if (!e.visible || e.ejemplo) return;
      if (e.fondo) { fondo = true; return; }
      var q = pos[i]; if (!q) return;
      var x0 = q.cx - q.w / 2, x1 = q.cx + q.w / 2, dentro = false;
      lados.forEach(function (z) {
        var v = z.ventana || [0, 0], a = Colocacion.area(z);
        if (x1 > v[0] + 0.05 && x0 < v[0] + a[0] - 0.05) usa[z.id] = true;
        if (x0 >= v[0] - 0.05 && x1 <= v[0] + a[0] + 0.05) dentro = true;
      });
      if (!dentro) centro = true; // pisa la parte de atrás o cruza de un lado a otro
    });
    var usados = lados.filter(function (z) { return usa[z.id]; });
    if (fondo || centro || usados.length > 1) return sup;
    return usados[0] || lados[0];
  };

  /* En la prenda BLANCA el blanco del diseño no se imprime, y en la NEGRA el
     negro (Xavi): cada una lleva su archivo con ese color transparente. Devuelve
     [{ colores: [nombres pedidos], sufijo, fn(lienzo) }] para los que haya en el pedido. */
  Ropa.prototype.sinFondoLibre = function () {
    var ed = this._editorLibre, cols = this.coloresElegidos();
    if (!this._tramos || !ed || !ed.quitarBlanco || !ed.quitarNegro) return [];
    return [
      { test: /^blanc/i, sufijo: '-sin-blanco', fn: function (c) { ed.quitarBlanco(c, 236); } },
      { test: /^negr/i, sufijo: '-sin-negro', fn: function (c) {
        // el fundido bueno (arreglo-imagen.js: alfa = lo que el negro no apaga); si no hay negro que fundir, el umbral
        var r = null;
        try { r = window.ImgArreglo && ImgArreglo.fundirNegro ? ImgArreglo.fundirNegro(c) : null; } catch (e) { r = null; }
        if (r && r.ok) { var x = c.getContext('2d'); x.clearRect(0, 0, c.width, c.height); x.drawImage(r.lienzo, 0, 0); }
        else ed.quitarNegro(c, 24);
      } }
    ].map(function (v) {
      return { colores: cols.filter(function (col) { return v.test.test(col); }), sufijo: v.sufijo, fn: v.fn };
    }).filter(function (v) { return v.colores.length; });
  };
  /* Como copiaLienzo, pero `fn` (que recorre todos los píxeles) solo trabaja sobre `caja` ({x,y,w,h} en px): el resto del lienzo, vacío,
     se copia tal cual. En una ventana de 28 × 40 cm con un logo de 14 cm eso es una cuarta parte del trabajo. */
  Ropa.prototype.copiaLienzoCaja = function (c, fn, caja) {
    var cb = document.createElement('canvas'); cb.width = c.width; cb.height = c.height;
    cb.getContext('2d', { willReadFrequently: true }).drawImage(c, 0, 0);
    if (!caja) { fn(cb); return cb; }
    var x = Math.max(0, Math.floor(caja.x)), y = Math.max(0, Math.floor(caja.y));
    var w = Math.min(c.width - x, Math.ceil(caja.w)), h = Math.min(c.height - y, Math.ceil(caja.h));
    if (w < 1 || h < 1) return cb;
    var sub = document.createElement('canvas'); sub.width = w; sub.height = h;
    sub.getContext('2d', { willReadFrequently: true }).drawImage(cb, x, y, w, h, 0, 0, w, h);
    fn(sub);
    var cx = cb.getContext('2d'); cx.clearRect(x, y, w, h); cx.drawImage(sub, x, y);
    return cb;
  };
  Ropa.prototype.copiaLienzo = function (c, fn) {
    var cb = document.createElement('canvas'); cb.width = c.width; cb.height = c.height;
    cb.getContext('2d').drawImage(c, 0, 0); fn(cb); return cb;
  };

  /* La previa del dorsal sobre la vista de espalda del editor, como capa
     externa (no es del diseño: se corta aparte). Con la regla de siempre:
     caja de 30 × 34 y el borde de arriba a 1/4 del alto por encima de la
     línea de axilas, que está a 10 cm del borde de arriba del recuadro. */
  Ropa.prototype.pintarDorsalLibre = function () {
    var ed = this._editorLibre;
    if (!ed || !ed.setDorsal || !window.Dorsales) return;
    this._dorsalLibre = !!(ed.hayDorsal && ed.hayDorsal());
    if (!this._dorsalLibre) return;
    // el texto de los objetos del editor: la primera fila escrita (o un ejemplo); la letra y el color, los del dorsal
    var d = (this.dorValidos()[0]) || {}, f = Dorsales.fuenteDe(this.dorFuente);
    ed.setDorsal({ nombre: d.nombre || '', numero: d.numero || '', fontFamily: f.css, color: this.dorHex(), peso: String(f.peso || '400') });
  };

  /* El precio de una sola prenda del color de la vista con lo que hay puesto:
     la variante de ese color (la primera talla que haya) más los recargos de
     impresión por unidad. Solo con tramos (ropa con editor); null si no. */
  Ropa.prototype.precioUnaLibre = function () {
    if (!this._editorLibre || !this.cfg.variantes || !this.cfg.variantes.length) return null;
    var cv = this.colorVista, vs = this.cfg.variantes;
    var v = vs.filter(function (x) { return x.color === cv && x.disponible; })[0] || vs.filter(function (x) { return x.color === cv; })[0] || vs[0];
    if (!v) return null;
    return v.precio + this.totalRecargos(1);
  };

  // el tamaño con el que arranca una imagen nueva: el segundo tramo de la primera cara (20 × 25), si hay tramos
  Ropa.prototype.tamañoInicialLibre = function () {
    if (!this._tramos) return null;
    var primera = this.catalogo.filter(function (z) { return z.libre; })[0];
    var lista = primera && this._tramos[primera.id];
    if (!lista || !lista.length) return null;
    var orden = lista.slice().sort(function (a, b) { return (a.precio - b.precio) || (a.w * a.h - b.w * b.h); });
    var t = orden[Math.min(1, orden.length - 1)];
    return [t.w, t.h];
  };

  /* El nombre de lo que se cobra en una cara: el del tramo, salvo el 10 × 10
     del pecho puesto a un lado, que es el pecho izquierdo o derecho de toda
     la vida (dx ±12,5 cm; en la foto el izquierdo del que la lleva cae a la
     derecha). Solo cambia el nombre: el precio es el del tramo. */
  Ropa.prototype.nombreTramo = function (z, r) {
    if (!r || !r.tramo) return '';
    var oc = r.ocupado;
    if (r.tramo.id === '10x10' && z.cara !== 'espalda' && oc && !oc.fondo && oc.x != null) {
      var dx = oc.x + oc.w / 2 - Colocacion.area(z)[0] / 2;
      if (dx >= 6) return 'Pecho izquierdo 10×10';
      if (dx <= -6) return 'Pecho derecho 10×10';
    }
    return r.tramo.nombre;
  };

  /* QUÉ TRAMO SE COBRA en una cara con precio por tamaño (camiseta): el más
     barato en el que cabe la caja envolvente de lo puesto en esa cara (una
     tira de 25 × 12 cae en el 27×15, no en el 25×30); con fondo de color o
     imagen, el tramo grande entero. Sin nada en la cara, null: no se cobra
     ni se imprime. Los tramos y sus precios vienen de ropa.liquid. */
  Ropa.prototype.tramoDe = function (z) {
    var ed = this._editorLibre, lista = (this._tramos || {})[z.id];
    if (!ed || !ed.ocupadoEn || !lista || !lista.length) return null;
    var oc = ed.ocupadoEn(z);
    if (!oc) return null;
    var porPrecio = lista.slice().sort(function (a, b) { return (a.precio - b.precio) || (a.w * a.h - b.w * b.h); });
    var mayor = lista.slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; })[0];
    /* POR SUPERFICIE, no por encaje (Xavi, 29/09: "¿no es exagerado?", con
       un "Julio" de 28 × 6 que saltaba al 30×40): lo que cuenta en la mesa
       de DTF es lo que ocupa. El tramo más barato cuya área llega a la de
       la caja del diseño, siempre que quepa en el recuadro grande. */
    var area = oc.w * oc.h;
    var t = oc.fondo ? null : porPrecio.filter(function (t) {
      return (oc.w <= t.w + 0.05 && oc.h <= t.h + 0.05) || area <= t.w * t.h + 0.5;
    })[0];
    return { tramo: t || mayor, ocupado: oc };
  };
  /* Las zonas elegidas de un producto con editor las decide lo que hay
     puesto, no el cliente: con tramos, las caras que llevan algo (o la
     primera, para que la ficha pida algo); en la taza, un lado o la panorámica. */
  Ropa.prototype.recalcularLibre = function () {
    var self = this;
    if (!this._editorLibre) return;
    this.pintarDorsalLibre();   // el nombre de la lista en el dorsal del editor, también en la taza (sin tramos)
    if (this._tramos) {
      var libres = this.catalogo.filter(function (z) { return z.libre; });
      var usadas = libres.filter(function (z) { return !!self.tramoDe(z); });
      this.elegidas = (usadas.length ? usadas : libres.slice(0, 1)).map(function (z) { return z.id; });
      this.pintarDorsalLibre();
      /* Una previa pequeña de cada cara usada, para el aviso de camuflaje
         (texto negro sobre camiseta negra) mientras se diseña: el archivo de
         verdad lo pone prepararLibre al añadir al carrito. */
      var ed = this._editorLibre;
      // en las blancas el blanco no se imprime, ni el negro en las negras: la previa para el aviso va sin él
      var variantes = this.sinFondoLibre();
      Object.keys(this.arteColor).forEach(function (k) { if (self.arteColor[k] && self.arteColor[k].previa) delete self.arteColor[k]; });
      libres.forEach(function (z) {
        // una cara solo con dorsal no lleva archivo de diseño ni aviso de resolución: el dorsal se corta aparte
        if (usadas.indexOf(z) === -1 || (ed.tieneDiseñoEn && !ed.tieneDiseñoEn(z))) { delete self.arte[z.id]; return; }
        var v = z.ventana || [0, 0], a = Colocacion.area(z);
        var c = ed.componer(12, { x: v[0], w: a[0] }, true);
        self.arte[z.id] = { thumb: c, px: [c.width, c.height], libre: true, previa: true, _id: 'previa-' + z.id };
        variantes.forEach(function (v) {
          var pb = { thumb: self.copiaLienzo(c, v.fn), px: [c.width, c.height], libre: true, previa: true, _id: 'previa' + v.sufijo + '-' + z.id };
          v.colores.forEach(function (col) { self.arteColor[z.id + '·' + col] = pb; });
        });
      });
      return;
    }
    var z = this.zonaCobroLibre();
    if (z) this.elegidas = [z.id];
  };

  /* El diseño del editor, compuesto a 300 ppp, como archivo de la zona que
     se cobra. En la taza el archivo es SIEMPRE la panorámica completa
     (20 × 9,5), se cobre lo que se cobre: es justo lo que Xavi monta para
     imprimir. En la camiseta, un archivo por cara usada, cada uno con su
     ventana entera (30 × 40) para que la posición en la prenda no se pierda. */
  /* La firma de lo que cambia el archivo que se manda: diseño, colores del pedido, caras y dorsales. */
  Ropa.prototype.firmaLibre = function () {
    var ed = this._editorLibre;
    if (!ed || !ed.firma) return '';
    return ed.firma() + '|' + (this.coloresElegidos ? this.coloresElegidos().join(',') : '') + '|' + this.elegidas.join(',') + '|' +
      (this.cfg.quitarBlanco ? 1 : 0) + '|' + (this.hayDorsal() ? 1 : 0);
  };
  // lo ya preparado (archivos, id del diseño, originales) se pone en uso
  Ropa.prototype.aplicarPrep = function (c) {
    var self = this;
    Object.keys(this.arteColor).forEach(function (k) { if (self.arteColor[k] && self.arteColor[k].libre) delete self.arteColor[k]; });
    Object.keys(c.arte).forEach(function (k) { self.arte[k] = c.arte[k]; });
    Object.keys(c.arteColor).forEach(function (k) { self.arteColor[k] = c.arteColor[k]; });
    this._idDiseño = c.idDiseno; this._extrasLibre = c.extras;
  };
  /* PREPARAR ANTES DE QUE LO PIDAN (Xavi: «¿no hay cosas que se pueden procesar antes de darle al botón?»). Cuando el pedido está listo
     para comprar (diseño puesto, cantidades, nada que falte) y el cliente deja de tocar un momento, el archivo se prepara en segundo
     plano y se guarda con la firma del diseño. Al pulsar «Añadir», si la firma sigue igual no hay que esperar: sube directo. */
  Ropa.prototype.precalentar = function () {
    var self = this, ed = this._editorLibre;
    if (!ed || this.busy || this._enVuelo || this._prepEnCurso || !ed.firma) return;
    /* Preparar por adelantado gasta memoria: en un móvil justo de RAM (o que no dice cuánta tiene) es mejor esperar al botón que
       arriesgar que Chrome mate la pestaña con el diseño sin comprar. Con 4 GB o más, en cambio, es lo que evita que el cliente espere. */
    var tact = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    // en el móvil NO se anticipa: la anticipada congela el hilo (hueco de 10-22 s en la traza del 06/10) justo cuando el cliente pulsa
    if (tact) return;
    if (!this.resumen.lineas.length || (ed.tieneDiseño && !ed.tieneDiseño())) return;
    if (this._cachePrep && this._cachePrep.firma === this.firmaLibre()) return;
    this._genPrep = (this._genPrep || 0) + 1;
    this._prepEnCurso = this.prepararLibre({ precalentar: true, gen: this._genPrep }).catch(function () { return false; }).then(function () { self._prepEnCurso = null; });
  };
  Ropa.prototype.prepararLibre = async function (opts) {
    opts = opts || {};
    var ed = this._editorLibre, self = this;
    if (!ed) return false;
    T('prepararLibre: entra');
    this.recalcularLibre();
    T('prepararLibre: recalcularLibre hecho');
    var firma = this.firmaLibre(), prod = { arte: {}, arteColor: {} };
    T('prepararLibre ' + (opts.precalentar ? '(ANTICIPADA)' : '(real)'));
    if (!opts.precalentar) {
      // si hay una preparación en marcha se espera a que acabe; si lo preparado sigue valiendo, no hay nada más que hacer
      if (this._prepEnCurso) {
        // se espera un poco a la anticipada (si va casi lista, ahorra todo); si tarda, se cancela y se prepara a la vez, sin pelearse por la CPU
        try { await conLimite(this._prepEnCurso, 4000, 'espera'); } catch (e0) { this._genPrep = (this._genPrep || 0) + 1; T('anticipada cancelada por lenta'); }
      }
      if (this._cachePrep && this._cachePrep.firma === this.firmaLibre()) { this.aplicarPrep(this._cachePrep); return true; }
    }
    var trabajos; // [{ z, recorte, area }]
    if (this._tramos) {
      trabajos = this.zonas().filter(function (z) { return z.libre && self.tramoDe(z) && (!ed.tieneDiseñoEn || ed.tieneDiseñoEn(z)); }).map(function (z) {
        var v = z.ventana || [0, 0], a = Colocacion.area(z);
        return { z: z, recorte: { x: v[0], w: a[0] }, area: a };
      });
    } else {
      var zc = this.zonaCobroLibre();
      trabajos = zc && (!ed.tieneDiseño || ed.tieneDiseño()) ? [{ z: zc, recorte: null, area: Colocacion.area(this._zonaSuperficie) }] : [];
    }
    /* Las caras que solo llevan dorsal (nombre y número por prenda) no tienen archivo de diseño: van
       con un arte «dorsal» sin archivo, como el dorsal de siempre, y el taller saca lo suyo del JSON. */
    var hechas = trabajos.map(function (t) { return t.z.id; });
    var soloDorsal = this.hayDorsal() ? this.zonas().filter(function (z) {
      return z.libre && hechas.indexOf(z.id) === -1 && (self._tramos ? self.tramoDe(z) : z === self.zonaCobroLibre());
    }) : [];
    soloDorsal.forEach(function (z) {
      var c0 = document.createElement('canvas'); c0.width = c0.height = 4;
      prod.arte[z.id] = { dorsal: true, name: 'dorsal-' + z.id, _id: 'dorsal-' + z.id, thumb: c0, px: [4, 4] };
    });
    T('caras a preparar: ' + trabajos.map(function (t) { return t.z.id + ' ' + t.area.join('x') + 'cm'; }).join(' + ') + (this._prepEnCurso ? ' · hay una anticipada en marcha' : ''));
    if (!trabajos.length) {   // solo dorsales: no hay archivo de diseño que preparar
      if (!opts.precalentar) Object.keys(prod.arte).forEach(function (k) { self.arte[k] = prod.arte[k]; });
      return this.hayDorsal();
    }
    try {
      /* Las caras se preparan de dos en dos: componer es rápido, pero codificar el PNG (muy grande: la ventana entera de la cara)
         es lo que más tarda, y dos codificaciones a la vez se reparten entre núcleos. Más de dos a la vez agota la memoria del móvil. */
      var extrasRapido = [];   // proyecto + piezas del modo rápido
      var btnPrep = $(this.raiz, '[data-add]');
      var tactil_ = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
      var hacerZona = async function (i) {
        // el botón dice en qué cara va (con varias, el cliente ve que avanza)
        if (window.Cargando && i > 0) await Cargando.pinta();   // que el botón se repinte entre cara y cara
        var tx = btnPrep && btnPrep.querySelector('[data-crg-txt]');
        if (tx && trabajos.length > 1) tx.textContent = 'Preparando ' + (trabajos[i].z.nombre || 'la cara').toLowerCase() + ' (' + (i + 1) + ' de ' + trabajos.length + ')…';
        var tr = trabajos[i], z = tr.z, area = tr.area, recorte = tr.recorte;
        if (opts.precalentar && opts.gen !== self._genPrep) throw new Error('cancelada');
        T('cara ' + (i + 1) + '/' + trabajos.length + ' empieza');
        /* El archivo a 300 ppp de un cojín de 30 × 30 cm son 3.543 px: aunque el cliente suba una foto de
           500 KB, el PNG sale de 4 MB. Con dos caras, más fotos originales y mockup, el envío al carrito
           pasa del límite de Shopify y falla con un 413 («No se ha podido añadir al carrito», Xavi,
           05/10/2026). Se intenta a 300 ppp y, si el archivo pasa de su parte del presupuesto, se rehace
           a 240, 200 y 150 ppp (nunca por debajo: a 150 ppp una foto de móvil se sigue viendo nítida). */
        var PRESUPUESTO_MB = Math.max(1, Math.min(3, 3 / trabajos.length));
        /* Se compone a la resolución que tiene lo puesto (no a 300 ppp por defecto: una ilustración de 1.250 px en 27 cm solo tiene ~120)
           y nunca pasando de ~12 megapíxeles (el móvil se queda sin memoria y tarda segundos de más). Si el archivo pasa de su parte
           del presupuesto se baja a las resoluciones de siempre. */
        var fuente = ed.ppcmFuente ? ed.ppcmFuente(recorte) : Infinity;
        var tactil0 = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
        /* Xavi (06/10): «con 150 o 200 ppp me vale; que no estemos metiendo tanta calidad». Máximo 200 ppp (78,7 px/cm): el archivo pesa y tarda
           menos, y la impresión es la misma. Si el archivo pasa del presupuesto baja a 150 ppp. */
        /* en el móvil, 150 ppp (59 px/cm) como máximo: codificar un PNG de 5 MP tarda minutos en un móvil lento */
        var inicio = isFinite(fuente) ? Math.min(tactil0 ? 59.06 : 78.74, Math.max(tactil0 ? 45 : 59.06, fuente * (tactil0 ? 1.0 : 1.15))) : (tactil0 ? 59.06 : 78.74);
        // en el móvil el tope baja a ~5 megapíxeles: con 12 MP (y las copias que hace el navegador) la pestaña se queda sin memoria y Chrome la mata («¡Vaya! Se ha producido un error al mostrar esta página», Xavi, 06/10)
        var tactil = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches), topeMP = tactil ? 3e6 : 12e6;
        if (area[0] * area[1] * inicio * inicio > topeMP) inicio = Math.sqrt(topeMP / (area[0] * area[1]));
        var ppcmOk = [inicio].concat([59.06].filter(function (v) { return v < inicio * 0.85; })), c = null, archivoOk = null;
        /* En la camiseta BLANCA o NEGRA el archivo que se usa es el de «sin blanco» / «sin negro»; si todos los colores del pedido
           tienen el suyo, el archivo base (con blancos) no se usa y se ahorra codificarlo (lo más lento del envío). */
        var variantesZ = self.sinFondoLibre(), colsPed = self.coloresElegidos ? self.coloresElegidos() : [];
        var soloVariantes = variantesZ.length > 0 && colsPed.length > 0 && colsPed.every(function (col) {
          return variantesZ.some(function (v) { return v.colores.indexOf(col) >= 0; });
        });
        if (soloVariantes) {
          c = ed.componer(ppcmOk[0], recorte, true);
          if (self.cfg.quitarBlanco && ed.quitarBlanco) ed.quitarBlanco(c);
        } else {
          /* Si el navegador no puede con ese tamaño (lienzo que no se crea, PNG que no sale, memoria) se baja la resolución y se
             vuelve a intentar, en vez de dar el pedido por perdido: primero 150 ppp, y como último recurso 115 y 76 ppp. Por
             peso (archivo grande) no se baja de 150 ppp. */
          var traza = self._trazaPrep = [];
          var lista = ppcmOk.concat([59.06, 45, 30].filter(function (v) { return v < ppcmOk[ppcmOk.length - 1] * 0.9; })), fallo = null;
          for (var q = 0; q < lista.length; q++) {
            var tIni = performance.now();
            if (opts.precalentar && opts.gen !== self._genPrep) throw new Error('cancelada');
            try {
              c = ed.componer(lista[q], recorte, true);
              traza.push(Math.round(lista[q] * 2.54) + 'ppp ' + c.width + 'x' + c.height + ' comp ' + Math.round(performance.now() - tIni) + 'ms'); T('  lienzo ' + c.width + 'x' + c.height + ' (' + (c.width * c.height / 1e6).toFixed(1) + ' MP) compuesto en ' + Math.round(performance.now() - tIni) + ' ms');
              if (!c || !c.width || !c.getContext('2d')) throw new Error('lienzo');
              // sublimación: el blanco del diseño no se imprime, fuera del archivo
              T('  quitando blanco…');
              if (self.cfg.quitarBlanco && ed.quitarBlanco) ed.quitarBlanco(c);
              T('  blanco quitado; codificando PNG…');
              archivoOk = await conLimite(codificarPNG(c, area[0] * 10, 'prueba.png'), (tactil0 ? [9000, 7000, 6000, 6000] : [40000, 30000, 30000, 30000])[Math.min(q, 3)], 'codificar');
              fallo = null; traza.push('ok ' + Math.round(performance.now() - tIni) + 'ms ' + Math.round(archivoOk.size / 1024) + 'KB'); T('  PNG listo: ' + Math.round(archivoOk.size / 1024) + ' KB a los ' + Math.round(performance.now() - tIni) + ' ms');
            } catch (e1) {
              fallo = e1; archivoOk = null; traza.push((e1 && e1.message) + ' ' + Math.round(performance.now() - tIni) + 'ms'); T('  FALLO ' + (e1 && e1.message) + ' a los ' + Math.round(performance.now() - tIni) + ' ms');
              if (window.console) console.warn('Archivo a ' + Math.round(lista[q] * 2.54) + ' ppp no ha podido prepararse (' + (e1 && e1.message) + '), se baja la resolución');
              if (c) { c.width = c.height = 1; }
              await (window.Cargando ? Cargando.pinta() : Promise.resolve());   // que el navegador respire y libere memoria
              continue;
            }
            if (archivoOk.size <= PRESUPUESTO_MB * 1048576 || lista[q] <= 59.06) break;
          }
          if (!archivoOk) throw fallo || new Error('codificar');
        }
        var nombre = 'diseno-' + self.prenda + (trabajos.length > 1 || self._tramos ? '-' + slug(z.nombre) : '') +
          '-' + String(area[0]).replace('.', '_') + 'x' + String(area[1]).replace('.', '_') + 'cm.png';
        var archivo = async function (lienzo, nom) {
          return await conLimite(codificarPNG(lienzo, area[0] * 10, nom), 40000, 'codificar');
        };
        T('  cara ' + (i + 1) + ': archivo base hecho, miniatura y variantes');
        var thumb = ed.componer(12, recorte, true);
        /* Los arreglos hechos en el editor, para el albarán: el negro fundido
           lleva el semitono del taller (como en el editor viejo). */
        var NOTAS_ARR = { negro: 'negro fundido en la web — TRAMAR puntos45 en taller', blanco: 'fondo blanco quitado en la web', filtro: 'FILTRO DE IA aplicado a la foto en la web (el archivo ya es el dibujo)', fondoia: 'fondo quitado con IA en la web' };
        var arreglos = (ed.arreglos ? ed.arreglos() : []).map(function (k) { return NOTAS_ARR[k] || k; });
        // y lo que el cliente ha dejado: un fondo blanco o negro sobre prenda de otro color, para verlo en el albarán
        (ed.fondosPendientes ? ed.fondosPendientes() : []).forEach(function (k) { arreglos.push('OJO: fondo ' + k + ' SIN quitar (el cliente lo dejó)'); });
        if (!soloVariantes) prod.arte[z.id] = {
          file: new File([archivoOk], nombre, { type: 'image/png' }), name: nombre, px: [c.width, c.height], thumb: thumb,
          transparente: true, arreglos: i === 0 ? arreglos : [], libre: true, _id: 'libre-' + Date.now()
        };
        /* Camiseta BLANCA (Xavi): el blanco del diseño no se imprime, que un
           escudo en JPG no lleve su rectángulo blanco. Es un archivo aparte
           para las líneas blancas (arteColor); las de color llevan el diseño
           tal cual, con sus blancos. */
        var variantes = variantesZ;
        for (var j = 0; j < variantes.length; j++) {
          var cmCaja = ed.cajaContenido ? ed.cajaContenido(recorte) : null, ppcmC = c.width / (area[0]), caja = null;
          if (cmCaja) { var mg = 1.5; caja = { x: (cmCaja.x0 - recorte.x - mg) * ppcmC, y: (cmCaja.y0 - mg) * ppcmC, w: (cmCaja.x1 - cmCaja.x0 + 2 * mg) * ppcmC, h: (cmCaja.y1 - cmCaja.y0 + 2 * mg) * ppcmC }; }
          var v = variantes[j], cb = self.copiaLienzoCaja(c, v.fn, caja);
          var nb = nombre.replace(/\.png$/, v.sufijo + '.png');
          var dato = { file: await archivo(cb, nb), name: nb, px: [cb.width, cb.height], thumb: self.copiaLienzo(thumb, v.fn),
                       transparente: true, arreglos: i === 0 ? arreglos : [], libre: true, _id: 'libre' + v.sufijo + '-' + Date.now() };
          cb.width = cb.height = 1;   // se libera la memoria del lienzo grande en cuanto está codificado
          v.colores.forEach(function (col) { prod.arteColor[z.id + '·' + col] = dato; });
          if (soloVariantes && j === 0) prod.arte[z.id] = dato;   // el «base» de la cara es el de la primera variante (la previa de recalcularLibre no lleva archivo)
        }
        c.width = c.height = 1;
        T('cara ' + (i + 1) + ' terminada');
      };
      var cola = trabajos.map(function (t, ix) { return ix; });
      var lanzar = async function () { while (cola.length) await hacerZona(cola.shift()); };
      // de dos en dos en ordenador; de una en una en el móvil (la memoria manda más que la prisa)
      /* MODO RÁPIDO (móvil, 2 o más caras; en serigrafía —la hace MidOcean con el archivo que monta el panel— también con 1 sola cara, cliente 07/10: «preparar: codificar»): en los móviles de Xavi y de una clienta (06/10) el navegador se congela 30-60 s al pulsar
         «Añadir» con 2 caras, sin que sea código lento (trazas con ?diag=1). Aquí no se compone ni se codifica nada: el pedido entra
         al instante con los originales del cliente y la vista previa de cada cara, marcado «SIN ARCHIVO» para prepararlo en el taller.
         ?completo=1 en la dirección fuerza el camino de siempre. */
      /* 07/10: el modo rápido deja de ser el de siempre en el móvil (Xavi: «tal vez todo el problema era el repintado», que ya está arreglado): el pedido lleva
         el archivo montado como en el ordenador. Solo se usa si la preparación completa falla (reintento automático) o con ?rapido=1. */
      var rapido = !opts.precalentar && (this._forzarRapido || /[?&]rapido=1/.test(location.search)) && !/[?&]completo=1/.test(location.search);
      if (rapido) {
        T('MODO RÁPIDO: sin componer ni codificar');
        var variantesR = self.sinFondoLibre();
        trabajos.forEach(function (tr) {
          var prev = self.arte[tr.z.id] || {};
          var cR = prev.thumb || document.createElement('canvas');
          var ent = { dorsal: true, sinArchivo: true, name: 'sin-archivo-' + tr.z.id, _id: 'rapido-' + tr.z.id + '-' + Date.now(), thumb: cR, px: prev.px || [cR.width || 4, cR.height || 4], libre: true };
          prod.arte[tr.z.id] = ent;
          variantesR.forEach(function (v) { v.colores.forEach(function (col) { prod.arteColor[tr.z.id + '·' + col] = ent; }); });
        });
        /* el proyecto: la colocación de todo y las imágenes tal cual se ven, para que el panel monte el archivo (sin canvas aquí) */
        try {
          var pr = await conLimite(ed.proyecto(), 8000, 'proyecto');
          pr.datos.caras = trabajos.map(function (tr) {
            return { id: tr.z.id, nombre: tr.z.nombre || tr.z.id, archivo: self.nombreProp(tr.z), x0: tr.recorte ? tr.recorte.x : 0, w: tr.area[0], h: tr.area[1] };
          });
          pr.datos.quitarBlanco = !!self.cfg.quitarBlanco;
          pr.datos.variantes = self.sinFondoLibre().map(function (v) { return { tipo: v.sufijo.indexOf('blanco') >= 0 ? 'blanco' : 'negro', colores: v.colores }; });
          pr.datos.prenda = self.prenda; pr.datos.ppp = 200;
          pr.piezas.forEach(function (p) {
            var ext = /png/i.test(p.blob.type) ? 'png' : /webp/i.test(p.blob.type) ? 'webp' : 'jpg';
            pr.datos.elementos.forEach(function (e) { if (e.pieza === p.n) e.pieza = '_Pieza ' + p.n; });
            extrasRapido.push({ k: '_Pieza ' + p.n, file: new File([p.blob], 'pieza-' + p.n + '.' + ext, { type: p.blob.type || 'image/png' }), name: 'pieza-' + p.n + '.' + ext });
          });
          extrasRapido.unshift({ k: '_Proyecto', file: new File([JSON.stringify(pr.datos)], 'proyecto.json', { type: 'application/json' }), name: 'proyecto.json' });
          T('proyecto listo: ' + pr.datos.elementos.length + ' elementos, ' + pr.piezas.length + ' imágenes');
        } catch (eP) { T('proyecto falla: ' + (eP && eP.message)); if (window.console) console.warn('proyecto', eP); }
      } else
      await Promise.all(tactil_ ? [lanzar()] : [lanzar(), lanzar()]);
      /* El diseño se guarda en el navegador (IndexedDB) con un id que viaja
         en la línea como _diseño: desde el carrito, "Editar diseño" vuelve
         aquí con ?editar=id y lo recupera. Cada vez que se añade se crea un
         id nuevo; si se estaba editando, las líneas del id viejo se quitan
         del carrito al terminar (ver alCarrito). */
      T('caras listas; guardando diseño en el navegador');
      var idDiseno = 'd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var guardarDiseno = async function () {
        try {
          var est = await conLimite(ed.estado(), 8000, 'estado');
          est.notas = (($(self.raiz, '[data-notas]') || {}).value || '');
          est.colorVista = self.colorVista || null;
          await conLimite(Diseños.guardar(idDiseno, est), 5000, 'guardado');
        } catch (e) { /* sin guardado no hay edición, pero el pedido sigue */ }
      };
      /* modo rápido: guardar el diseño en el navegador tardaba 30 s en el móvil de Xavi (06/10, log 14:09). Se hace DESPUÉS de añadir al carrito. */
      if (rapido) { self._diferido = guardarDiseno; T('guardado del diseño: después de añadir'); }
      else await guardarDiseno();
      // los originales del cliente, por si acaso (Xavi): Original 1, Original 2…
      var extras = ed.originales().map(function (f, i) {
        return { k: '_Original ' + (i + 1), file: f, name: f.name || ('original-' + (i + 1)) };
      });
      /* collage con muchas fotos: originales + piezas pasan del límite de la petición (413). Si pesa de más, los originales se quedan
         fuera (las piezas ya llevan lo que se imprime) y se deja constancia en el pedido. */
      if (extrasRapido.length) {
        /* sin originales en el modo rápido: pesan 3-10 MB cada uno y el móvil tarda en leerlos y subirlos; las piezas (≤ 2400 px) llevan lo que se imprime */
        extras = [{ k: '_Nota originales', file: new File(['originales no enviados (modo rápido): las piezas llevan el diseño'], 'nota.txt', { type: 'text/plain' }), name: 'nota.txt' }];
        var kb = function (a) { return a.reduce(function (n, x) { return n + ((x.file && x.file.size) || 0); }, 0); };
        if (kb(extras) + kb(extrasRapido) > 9 * 1048576) { T('pesa de más: se omiten los originales'); extras = [{ k: '_Nota originales', file: new File(['originales omitidos por tamaño: las piezas llevan el diseño'], 'nota.txt', { type: 'text/plain' }), name: 'nota.txt' }]; }
      }
      if (!extrasRapido.length) {
        /* modo normal: archivos montados + originales de móvil (3-10 MB cada uno) pasan fácil del límite de la petición; si pesa de más, fuera los originales */
        var pesoArte = 0; Object.keys(prod.arte).forEach(function (k) { pesoArte += (prod.arte[k].file && prod.arte[k].file.size) || 0; });
        Object.keys(prod.arteColor).forEach(function (k) { var d = prod.arteColor[k]; if (d && d.file && d !== prod.arte[k.split('·')[0]]) pesoArte += d.file.size || 0; });
        var pesoOri = extras.reduce(function (n, x) { return n + ((x.file && x.file.size) || 0); }, 0);
        if (pesoArte + pesoOri > 12 * 1048576 && pesoOri) {
          T('pedido de ' + Math.round((pesoArte + pesoOri) / 1048576) + ' MB: sin los originales');
          extras = [{ k: '_Nota originales', file: new File(['originales no enviados por tamaño del pedido'], 'nota.txt', { type: 'text/plain' }), name: 'nota.txt' }];
        }
      }
      extras = extras.concat(extrasRapido);
      T('diseño guardado y originales listos');
      var paquete = { firma: firma, arte: prod.arte, arteColor: prod.arteColor, idDiseno: idDiseno, extras: extras };
      var sigue = firma === this.firmaLibre();   // ¿el cliente ha seguido tocando mientras tanto?
      // el diseño guardado de una preparación anterior que ya no vale se quita del navegador
      var viejo = this._cachePrep && this._cachePrep.idDiseno;
      if (opts.precalentar) {
        if (sigue) { this._cachePrep = paquete; if (viejo) Diseños.borrar(viejo).catch(function () {}); }
        else Diseños.borrar(idDiseno).catch(function () {});
        return true;
      }
      this._cachePrep = sigue ? paquete : null;
      this.aplicarPrep(paquete);
      if (viejo && viejo !== idDiseno) Diseños.borrar(viejo).catch(function () {});
      return true;
    } catch (e) {
      if (window.console) console.error('prepararLibre', e);
      if (!opts.precalentar) this.informeError('preparar: ' + String((e && e.message) || 'error').slice(0, 60));
      if (!opts.precalentar) this.flash('No se ha podido preparar el diseño (' + String((e && e.message) || 'error').slice(0, 40) + (this._trazaPrep && this._trazaPrep.length ? ' · ' + this._trazaPrep.join(' / ') : '') + '). Vuelve a intentarlo.');
      return false;
    }
  };

  /* La palabra en singular o en plural, según toque. */
  Ropa.prototype.sust = function (n) {
    var s = this.cfg.sustantivo || SUSTANTIVOS[this.prenda] || SUSTANTIVOS[this.familia] || ['prenda', 'prendas'];
    return s[n === 1 ? 0 : 1];
  };
  // "Un bloc" / "Una taza": el género lo dice el tercer elemento del sustantivo (objeto-editor.liquid, 'm')
  Ropa.prototype.masculino = function () {
    var s = this.cfg.sustantivo;
    return !!(s && s[2] === 'm');
  };

  // ¿este producto tiene tallas? Una taza o una bolsa solo tienen color
  Ropa.prototype.hayTallas = function () {
    return !!(this.cfg.tallas && this.cfg.tallas.length);
  };

  Ropa.prototype.bind = function () {
    var self = this, r = this.raiz;

    if (window.Reparto) {
      this.rep = Reparto.crear($(r, '[data-rep]'), {
        tallas: this.cfg.tallas, colores: this.cfg.colores, variantes: this.cfg.variantes,
        hex: this.cfg.coloresHex,
        casillasColor: !!this.cfg.casillasColor,
        // ropa con editor: un solo color por pedido, el que se ve (Xavi)
        unColor: !!this.cfg.tramos,
        // primero cuántas en total y luego las tallas (Xavi, 13/10)
        totalPrimero: false,   // 14/10 (Xavi: «¿y si quitamos total y colores?»): sin cuadro de total; para recuperarlo: !!this.cfg.tramos && this.hayTallas()
        nombre: function (n) { return self.sust(n); },
        /* Con casillas por color, la vista cambia al PINCHAR un color, no al
           poner cantidades (Xavi). El color queda fijado hasta el siguiente clic. */
        alElegirColor: function (c) { self.colorFijado = true; self.colorVista = c; self.actualizar(); },
        alCambiar: function (res) { self.resumen = res; self.sincroSello(res); self.actualizar(); }
      });
    }

    // paso 2 · marcar y desmarcar zonas
    $(r, '[data-zonas-lista]').addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-zona-id]');
      if (!b) return;
      var id = b.dataset.zonaId, i = self.elegidas.indexOf(id);
      if (i >= 0) {
        // no se puede quedar sin ninguna: la prenda lleva una impresión sí o sí
        if (self.elegidas.length === 1) return;
        self.elegidas.splice(i, 1);
      } else {
        /* Las zonas que se pisan se desmarcan solas: un "delante grande" ocupa
           el sitio del pecho centrado, y tenerlos los dos marcados no
           significa nada en el taller. La tabla vive en colocacion.js. */
        /* Y EL LOGO SE VA CON ELLA (Xavi, 26/09): si tenía el logo subido en el
           pecho y pasa a «delante grande», el logo pasa a la zona nueva y sale
           al tamaño de esa zona, en vez de obligarle a subirlo otra vez. La
           medida la saca la propia zona al pintar, así que basta con moverlo. */
        var movido = null;
        (window.Colocacion ? Colocacion.choca(id) : []).forEach(function (otra) {
          var k = self.elegidas.indexOf(otra);
          if (k >= 0) self.elegidas.splice(k, 1);
          var d = self.arte[otra];
          if (d && !d.dorsal && !self.arte[id] && !movido) {
            self.arte[id] = d;
            delete self.arte[otra];
            Object.keys(self.arteColor).forEach(function (clave) {
              if (clave.indexOf(otra + '·') === 0) {
                self.arteColor[id + clave.slice(otra.length)] = self.arteColor[clave];
                delete self.arteColor[clave];
              }
            });
            movido = otra;
          }
        });
        self.elegidas.push(id);
        if (movido && window.Colocacion) {
          var zn = self.zonaDe(id), dn = self.arte[id];
          var m = (zn && dn && dn.px) ? Colocacion.medida(zn, dn.px) : null;
          if (zn && m) self.flash('Hemos pasado tu logo a ' + zn.nombre.toLowerCase() + ': ahora sale a ' +
            fmt(m[0], 1) + ' × ' + fmt(m[1], 1) + ' cm.');
        }
      }
      self.actualizar();
    });

    var cols = $(r, '[data-colores]');
    if (cols) cols.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-color]');
      if (!b) return;
      self.colorVista = b.dataset.color;
      self.actualizar();
    });

    /* paso 3 · una caja por zona. Todo cuelga de un solo oyente porque las
       cajas se repintan enteras cada vez que cambia algo. */
    var artes = $(r, '[data-artes]'), input = $(r, '[data-file]');
    /* Los clics y lo tecleado se escuchan en la raíz, no solo en la caja de
       artes: con editor (camiseta) la tabla del dorsal va en su propia caja
       del paso 1. Cada rama mira su selector, así que no pisa nada. */
    r.addEventListener('click', function (e) {
      var t = e.target;
      // con editor: activar o quitar el dorsal (nombre y número en la espalda)
      var anadir = t.closest && t.closest('[data-dor-anadir]');
      if (anadir && self.rep && self.rep.sumar) { self.rep.sumar(self.dorColorLibre(), self.dorTallaNueva(), 1); return; }
      var quitar = t.closest && t.closest('[data-dor-quitar]');
      if (quitar && self.rep && self.rep.sumar) {
        var kq = quitar.dataset.dorQuitar, pq = kq.split('|');
        delete self.dorsales[kq];
        self.rep.sumar(pq[0], pq[1], -1);
        return;
      }
      if (!artes.contains(t) && !(t.closest && t.closest('[data-dor-libre]'))) return;
      var t = e.target;
      var pedir = t.closest && t.closest('[data-pide]');
      if (pedir) {
        self._destino = { zona: pedir.dataset.pide, color: pedir.dataset.pideColor || null };
        input.click();
        return;
      }
      var mismo = t.closest && t.closest('[data-mismo]');
      if (mismo) {
        var d = self.archivos()[Number(mismo.dataset.mismo)];
        if (d) { self.poner(d, mismo.dataset.mismoZona, mismo.dataset.mismoColor || null); }
        return;
      }
      var quita = t.closest && t.closest('[data-quita]');
      if (quita) {
        var c = quita.dataset.quitaColor;
        if (c) delete self.arteColor[quita.dataset.quita + '·' + c];
        else delete self.arte[quita.dataset.quita];
        self.actualizar();
        return;
      }
      var fix = t.closest && t.closest('[data-fix]');
      if (fix) {
        if (fix.dataset.fix === 'deshacer') self.deshacer(fix.dataset.fixZona, fix.dataset.fixColor || null);
        else self.arreglar(fix.dataset.fix, fix.dataset.fixZona, fix.dataset.fixColor || null);
        return;
      }

      /* El dorsal: el color de la letra y la tipografía. Las dos repintan la
         caja entera, y da igual — aquí no hay nada escrito a medias, son
         botones. Lo que no puede repintar es teclear, y eso va más abajo. */
      var tin = t.closest && t.closest('[data-dor-tinta]');
      if (tin) { self.dorTinta = tin.dataset.dorTinta; self._dorCache = null; self.actualizar(); return; }
      var ltr = t.closest && t.closest('[data-dor-fuente]');
      if (ltr) { self.dorFuente = ltr.dataset.dorFuente; self._dorCache = null; self.actualizar(); return; }

      /* El texto. Abrir el formulario repinta la caja; cambiar de fuente o de
         color NO, solo refresca la previa: si repintara, el cliente perdería
         lo que está escribiendo a media frase. */
      var pideT = t.closest && t.closest('[data-texto]');
      if (pideT) { self.abrirTexto(pideT.dataset.texto, pideT.dataset.textoColor || null); return; }
      if (self.form) {
        var fu = t.closest && t.closest('[data-texto-fuente]');
        if (fu) { self.form.fuente = fu.dataset.textoFuente; self.refrescarTexto(); return; }
        var ti = t.closest && t.closest('[data-texto-tinta]');
        if (ti) { self.form.tinta = ti.dataset.textoTinta; self.refrescarTexto(); return; }
        if (t.closest('[data-texto-ok]')) { self.ponerTexto(); return; }
        if (t.closest('[data-texto-no]')) { self.form = null; self.actualizar(); return; }
      }
    });

    /* Escribir en el campo del texto no repinta nada: solo se redibuja la
       previa, que es un canvas suelto. Así no se pierde el cursor. */
    r.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-dor-talla]');
      if (sel) self.dorCambiarTalla(sel.dataset.dorTalla, sel.value);
    });
    r.addEventListener('input', function (e) {
      if (!e.target.matches) return;
      if (!artes.contains(e.target) && !(e.target.closest && e.target.closest('[data-dor-libre]'))) return;
      /* Los dorsales tampoco repintan la tabla: son doce casillas y perder el
         cursor a la tercera sería insufrible. Se normaliza lo escrito en la
         propia casilla (mayúsculas, dos cifras) y se actualiza todo lo de
         alrededor —precio, previa, botón— sin tocar la tabla. */
      var kn = e.target.getAttribute('data-dor-nombre');
      var kx = e.target.getAttribute('data-dor-numero');
      if ((kn || kx) && window.Dorsales) {
        var clave = kn || kx;
        var d = self.dorsales[clave] || (self.dorsales[clave] = { nombre: '', numero: '' });
        var limpio = kn ? Dorsales.normNombre(e.target.value) : Dorsales.normNumero(e.target.value);
        if (e.target.value !== limpio) {
          var pos = e.target.selectionStart;
          e.target.value = limpio;
          try { e.target.setSelectionRange(pos, pos); } catch (err) { /* da igual */ }
        }
        if (kn) d.nombre = limpio; else d.numero = limpio;
        self._dorCache = null;
        self.quieto(function () { self.actualizar(); });
        return;
      }
      if (!self.form) return;
      if (e.target.matches('[data-texto-campo]')) { self.form.texto = e.target.value; self.refrescarTexto(); }
      else if (e.target.matches('[data-texto-color]')) { self.form.tinta = e.target.value; self.refrescarTexto(); }
    });

    // arrastrar sobre una caja concreta
    ['dragenter', 'dragover'].forEach(function (ev) {
      artes.addEventListener(ev, function (e) {
        var d = e.target.closest && e.target.closest('[data-pide]');
        if (!d) return;
        e.preventDefault(); d.classList.add('is-over');
      });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      artes.addEventListener(ev, function (e) {
        var d = e.target.closest && e.target.closest('[data-pide]');
        if (d) d.classList.remove('is-over');
      });
    });
    artes.addEventListener('drop', function (e) {
      var d = e.target.closest && e.target.closest('[data-pide]');
      if (!d) return;
      e.preventDefault();
      self.cargar(e.dataTransfer.files[0], d.dataset.pide, d.dataset.pideColor || null);
    });

    input.addEventListener('change', function () {
      var d = self._destino || {};
      self._destino = null;
      if (d.zona) self.cargar(input.files[0], d.zona, d.color);
      input.value = '';
    });

    /* Escribir una indicación cambia el pie: si nos escribe, le escribimos. */
    var notas = $(r, '[data-notas]');
    if (notas) notas.addEventListener('input', function () {
      clearTimeout(self._tn);
      self._tn = setTimeout(function () { self.actualizar(); }, 300);
    });

    var urg = $(r, '[data-urgente]');
    if (urg) urg.addEventListener('change', function (e) {
      if (!e.target.matches('[data-urg]')) return;
      self.urgente = e.target.checked;
      self.actualizar();
    });

    $(r, '[data-add]').addEventListener('click', function () { self.alCarrito(); });
    /* Respuesta inmediata: al soltar el dedo el botón ya enseña la rueda, ANTES del clic. En el móvil el navegador se queda unos segundos sin pintar
       justo tras el clic (trazas del 06/10) y sin esto el cliente tocaba un botón que no reaccionaba. Si no llega el clic (era un gesto), se deshace. */
    (function () {
      var b0 = $(r, '[data-add]'), prev = null, t = null;
      b0.addEventListener('pointerup', function () {
        if (b0.disabled || self.busy || self._enVuelo || !window.Cargando || b0.hasAttribute('data-crg')) return;
        prev = b0.innerHTML;
        b0.innerHTML = '<span class="crg-int"><span class="crg-rueda" aria-hidden="true"></span><span data-crg-txt>Preparando tu diseño…</span></span>';
        clearTimeout(t);
        t = setTimeout(function () { if (!self._enVuelo && !b0.hasAttribute('data-crg') && prev != null) b0.innerHTML = prev; prev = null; }, 900);
      });
    })();
    var wa = $(r, '[data-presupuesto-wa]');
    if (wa) wa.addEventListener('click', function () { self.presupuestoWhatsapp(); });
  };

  /* Hace algo dejando el paso 3 QUIETO. Lo usan las casillas de los dorsales:
     todo lo demás se recalcula, pero la tabla que está tocando el cliente no se
     rehace. Es la misma idea que el formulario de texto, generalizada. */
  Ropa.prototype.quieto = function (fn) {
    this._quieto = true;
    try { fn(); } finally { this._quieto = false; }
  };

  /* ---------- producción urgente ----------
     Las reglas viven en urgente.js: cambian a menudo y no tienen por qué
     mover este fichero. Aquí solo queda el cableado. */
  Ropa.prototype.cfgUrg = function () { return this.cfg.urgente || null; };

  Ropa.prototype.cabeUrgente = function () {
    return !!window.Urgente &&
      Urgente.cabe(this.cfgUrg(), this.resumen.unidades, this.coloresElegidos());
  };

  Ropa.prototype.pintarUrgente = function () {
    if (!window.Urgente) return;
    var sigue = Urgente.pintar($(this.raiz, '[data-urgente]'), this.cfgUrg(),
      this.resumen.unidades, this.coloresElegidos(), this.urgente);
    // si deja de caber (añade un color raro, o pasa del tope) se desmarca sola
    if (!sigue) this.urgente = false;
  };

  /* ---------- archivos ---------- */
  Ropa.prototype.poner = function (dato, zonaId, color) {
    if (color) { this.arteColor[zonaId + '·' + color] = dato; this.colorVista = color; }
    else this.arte[zonaId] = dato;
    this.actualizar();
  };

  Ropa.prototype.cargar = async function (file, zonaId, color, extra) {
    if (!file || !zonaId) return;
    if (file.size > this.cfg.maxFileMb * 1048576) {
      return this.flash(file.name + ': pesa más de ' + this.cfg.maxFileMb + ' MB.');
    }
    var destapar = function () {};
    var caja = $(this.raiz, '[data-caja="' + zonaId + '"]');
    if (window.Cargando && caja) {
      destapar = Cargando.velo(caja, extra ? 'Aplicando el arreglo…' : 'Leyendo el logo…',
        extra ? null : 'Comprobamos resolución y fondo');
      await Cargando.pinta();
    }
    try {
      var dato = await Archivo.leer(file, extra);
    } catch (e) {
      destapar();
      return this.flash(file.name + ': ' + (e.message || 'no se ha podido leer.'));
    }
    destapar();
    dato._id = 'a' + (++seq);
    this.poner(dato, zonaId, color);
  };

  /* Un arreglo (quitar fondo, afinar bordes) es del ARCHIVO, no de la zona: si
     el mismo logo está puesto en el pecho y en la espalda, se arregla en las
     dos. Por eso se sustituyen todas las referencias al dato viejo. */
  Ropa.prototype.sustituir = function (viejo, nuevo) {
    var self = this;
    Object.keys(this.arte).forEach(function (k) {
      if (self.arte[k] === viejo) self.arte[k] = nuevo;
    });
    Object.keys(this.arteColor).forEach(function (k) {
      if (self.arteColor[k] === viejo) self.arteColor[k] = nuevo;
    });
  };

  Ropa.prototype.deshacer = function (zonaId, color) {
    var d = this.artePara(zonaId, color);
    if (!d || !d.anterior) return;
    var n = Archivo.deshacer(d);
    n._id = d._id;
    this.sustituir(d, n);
    this.actualizar();
  };

  Ropa.prototype.arreglar = async function (tipo, zonaId, color) {
    var d = this.artePara(zonaId, color);
    if (this.ocupado || !d) return;
    var btn = $(this.raiz, '[data-fix="' + tipo + '"][data-fix-zona="' + zonaId + '"]');
    var texto = btn ? btn.textContent : '';
    this.ocupado = true;
    var soltar = function () { if (btn) { btn.disabled = false; btn.textContent = texto; } };
    if (window.Cargando && btn) {
      Cargando.ocupar(btn, tipo === 'fondo' ? 'Quitando el fondo…' : tipo === 'negro' ? 'Aplicando el semitono…' : 'Afinando…');
      soltar = function () { Cargando.libre(btn, texto); };
      await Cargando.pinta();
    }
    try {
      var zA = this.zonaDe(zonaId);
      var mmA = (zA && d.px && window.Colocacion) ? Colocacion.medida(zA, d.px)[0] * 10 : 0;
      var r = await Archivo.arreglar(d, tipo, this.cfg.maxFileMb, mmA);
      if (!r) { this.ocupado = false; soltar(); return; }
      if (!r.ok) {
        this.ocupado = false; soltar();
        return this.flash(tipo === 'fondo'
          ? 'No hemos encontrado un fondo liso que quitar. Súbelo tal cual y lo recortamos nosotros.'
          : 'Ese archivo ya tiene tamaño de sobra, no hace falta afinarlo.');
      }
      r.dato._id = d._id;
      this.sustituir(d, r.dato);
    } catch (e) {
      this.flash('No hemos podido arreglar la imagen. Súbela tal cual y ya la miramos nosotros.');
    }
    this.ocupado = false; soltar();
    this.actualizar();
  };

  /* ---------- pintar ---------- */
  /* SELLOS: un solo producto con los modelos como tallas. La pestaña del editor (cada una con la zona de su modelo)
     y la cantidad por talla van de la mano: pinchar una pestaña deja 1 unidad de ese modelo (y quita las demás),
     y poner unidades a un modelo lleva el editor a su pestaña. El precio sale solo de la talla. */
  Ropa.prototype.esSello = function () { return !!(this.cfg.tintaFija && this.cfg.tallas && this.cfg.tallas.length && this.rep); };
  // sellos: la pestaña ya elige el modelo, así que de la rejilla de cantidades solo se deja la casilla del modelo elegido
  Ropa.prototype.mostrarSoloModelo = function (talla) {
    var f = this.rep && this.rep.filas && this.rep.filas[0];
    if (!f || !f.campos) return;
    Object.keys(f.campos).forEach(function (t) {
      var caja = f.campos[t].parentNode;
      if (caja) caja.style.display = (t === talla) ? '' : 'none';
    });
    var cont = f.campos[talla] && f.campos[talla].parentNode && f.campos[talla].parentNode.parentNode;
    if (cont) cont.classList.add('rep-tallas--una');
  };
  Ropa.prototype.vistaASello = function (z) {
    if (!this.esSello() || !z || this._sincSello) return;
    var talla = z.nombre, rep = this.rep;
    if (this.cfg.tallas.indexOf(talla) === -1) return;
    this._sincSello = true;
    var previo = rep.cantidad('', talla) || rep.cantidad(this.colorVista || '', talla);
    this.cfg.tallas.forEach(function (t) { if (t !== talla) rep.poner(this.colorVista || '', t, 0); }, this);
    rep.poner(this.colorVista || '', talla, previo > 0 ? previo : 1);
    this._sincSello = false;
    this.mostrarSoloModelo(talla);
  };
  Ropa.prototype.sincroSello = function (res) {
    if (!this.esSello() || this._sincSello || !this._editorLibre || !res || !res.lineas || res.lineas.length !== 1) return;
    var talla = res.lineas[0].talla;
    var vistas = this.catalogo.filter(function (z) { return z.libre && z.nombre === talla; });
    var actual = this._editorLibre.vista && this._editorLibre.vista();
    if (vistas.length && (!actual || actual.id !== vistas[0].id)) { this._sincSello = true; this._editorLibre.cambiarVista(vistas[0].id); this._sincSello = false; }
    this.mostrarSoloModelo(talla);
  };

  /* «Llévate más por menos» (serigrafía por tramos de diseño): la tabla de tramos con el actual resaltado y cuánto falta para el
     siguiente. Se inserta justo encima del reparto de tallas. */
  Ropa.prototype.pintarTramosSerigrafia = function (uds) {
    var s = this.cfg.serigrafia;
    if (!s || !s.tramos || !s.tramos.length) return;
    /* 08/10 (Xavi): en «Cantidad» solo la cantidad. El precio y el siguiente tramo van en una sola línea (pintarResumen) y el total, en el botón. */
    if (this._cajaTramos) this._cajaTramos.hidden = true;
    return;
    var caja = this._cajaTramos;
    if (!caja) {
      var rep = $(this.raiz, '[data-rep]');
      if (!rep || !rep.parentNode) return;
      caja = this._cajaTramos = document.createElement('div');
      caja.className = 'rop-tramos';
      rep.parentNode.insertBefore(caja, rep);
    }
    var tr = s.tramos, base = tr[0].precio, actual = this.tramoSerigrafia(uds), sig = null, nz = this.zonasSer(), self = this;
    tr.forEach(function (t) { if (uds < t.min && !sig) sig = t; });
    var html = '<div class="rop-tramos__cab"><b>Llévate más por menos</b><span>' + 'IVA incluido</span></div><div class="rop-tramos__lista">';
    tr.forEach(function (t, i) {
      var pct = i ? Math.round((1 - t.precio / base) * 100) : 0, pz = self.precioSer(t, nz), ult = i === tr.length - 1;
      var rango = ult ? t.min + '+ uds' : t.min + ' a ' + (tr[i + 1].min - 1) + ' uds';
      var on = actual && actual.min === t.min;
      html += '<div class="rop-tramos__f' + (on ? ' is-on' : '') + '">' +
        '<span class="rop-tramos__q">' + rango + '</span>' +
        '<span class="rop-tramos__p">' + money(pz) + ' <small>/ ud</small></span>' +
        '<span class="rop-tramos__d">' + (pct ? '−' + pct + ' %' : '') + (ult ? '<em>Mejor precio</em>' : '') + '</span></div>';
    });
    html += '</div>';
    var pista;
    if (!uds) pista = 'Pedido mínimo: ' + tr[0].min + ' ' + this.sust(2) + ' del mismo diseño.';
    else if (uds < tr[0].min) pista = 'Pedido mínimo: ' + tr[0].min + ' ' + this.sust(2) + ' (llevas ' + uds + ').';
    else if (sig) pista = 'Llevas <b>' + uds + '</b> a ' + money(this.precioSer(actual, nz)) + ' cada una. Con <b>' + (sig.min - uds) + ' más</b> pasas a <b>' + money(this.precioSer(sig, nz)) + '</b>' +
      ' (ahorras ' + money(this.precioSer(actual, nz) - this.precioSer(sig, nz)) + ' por ' + this.sust(1) + ').';
    else pista = '¡Tienes el mejor precio! ' + uds + ' a ' + money(this.precioSer(actual, nz)) + ' cada una.';
    if (actual && actual.extra) pista += actual.vzz && actual.extraZona
      ? ' Cada color extra suma <b>' + money(actual.extra) + '</b> por ' + this.sust(1) + '; una zona extra (espalda, pecho, mangas) suma <b>' + money(actual.extra + actual.extraZona) + '</b> con su primer color.'
      : ' Cada color extra, o cada zona extra (espalda, pecho, mangas), suma <b>' + money(actual.extra) + '</b> por ' + this.sust(1) + ' en tu tramo.';
    html += '<p class="rop-tramos__pista">' + pista + '</p>' +
      '<p class="rop-tramos__nota">El tramo se calcula con las unidades de <b>cada diseño</b>, sumando todas las tallas y colores. ¿Más de ' + tr[tr.length - 1].min +
      '? <a href="https://wa.me/34934358257?text=' + encodeURIComponent('Hola, quiero un presupuesto de camisetas Regent con serigrafía para más de ' + tr[tr.length - 1].min + ' unidades') + '" target="_blank" rel="noopener">Pídenos presupuesto</a>.</p>';
    caja.innerHTML = html;
  };

  /* «¿Cómo se imprime?»: las técnicas de la zona que se ve, en la columna de la compra, antes de la cantidad (Xavi, 06/10:
     «en botón la gente no lo verá»). Es el mismo cambio que el panel «Impresión» del editor. */
  Ropa.prototype.pintarTecnica = function () {
    var caja = $(this.raiz, '[data-tecnica]'), ed = this._editorLibre, info = ed && ed.tecnicasLista ? ed.tecnicasLista() : null;
    if (!caja) return;
    if (!info || !info.lista || info.lista.length < 2) { caja.hidden = true; return; }
    var act = info.lista.filter(function (t) { return t.id === info.actual; })[0] || info.lista[0], self = this;
    // colores de la zona (serigrafía multicolor): cuántos lleva, el máximo y lo que suma cada color de más en el tramo de ahora
    var col = act.colores > 1 && ed.coloresZona ? ed.coloresZona() : null;
    var foto = ed.hayFotoSerigrafia ? ed.hayFotoSerigrafia() : false;
    var ser = this.cfg.serigrafia, tr = ser && ser.tramos ? (this.tramoSerigrafia(this.resumen.unidades || 0) || ser.tramos[0]) : null;
    var extra = tr && tr.extra ? tr.extra : 0;
    var firma = info.zona + '|' + info.actual + '|' + (col ? col.n + '/' + col.max + (col.negro ? 'n' : '') + (col.compartido ? 'c' : '') : '') + '|' + (foto ? 'f' : '') + '|' + extra;
    if (caja.getAttribute('data-firma') === firma && !caja.hidden) return;
    caja.setAttribute('data-firma', firma);
    var tdt = info.lista.filter(function (t) { return !t.colores; })[0];
    var desc = act.desc || (act.colores === 1 ? 'Un solo color de tinta.' : act.colores ? 'Colores planos, sin degradados.' : 'A todo color, con degradados o fotos.');
    caja.innerHTML = '<p class="rop-tec__t">¿Cómo se imprime?' + (info.zona ? ' <span>· ' + esc(info.zona) + '</span>' : '') + '</p>' +
      '<div class="rop-tec__f">' + info.lista.map(function (t) {
        return '<button type="button" class="rop-tec__b' + (t.id === act.id ? ' is-on' : '') + '" data-tec-id="' + esc(t.id) + '" aria-pressed="' + (t.id === act.id ? 'true' : 'false') + '">' + esc(t.nombre) + (self.minTecnica(t.id) ? '<small class="rop-tec__min">mínimo ' + self.minTecnica(t.id) + ' uds</small>' : '') + (self.maxTecnica(t.id) ? '<small class="rop-tec__min">hasta ' + self.maxTecnica(t.id) + ' uds</small>' : '') + '</button>';
      }).join('') + '</div>' +
      '<p class="rop-tec__d">' + esc(desc) + '</p>' +
      (col ? '<div class="rop-tec__col"><span>Colores</span>' +
        '<button type="button" class="rop-tec__m" data-tec-col="-1" aria-label="Un color menos"' + (col.n <= 2 ? ' disabled' : '') + '>−</button>' +
        '<b>' + col.n + '</b>' +
        '<button type="button" class="rop-tec__m" data-tec-col="1" aria-label="Un color más"' + (col.n >= col.max ? ' disabled' : '') + '>+</button></div>' +
        '<p class="rop-tec__d">Recomendamos hasta ' + col.rec + ' colores' + (extra ? ': cada color de más suma <b>' + money(extra) + '</b> por ' + this.sust(1) : '') +
        (col.n > col.rec ? '. <b>Llevas ' + col.n + '</b>, con más pantallas y más caro' : '') + '. Hasta ' + col.max + ' colores.</p>' : '') +
      (col && col.compartido ? '<p class="rop-tec__d">Todo lo de esta zona se imprime a la vez: los diseños comparten colores (y pantallas).</p>' : '') +
      (col && col.negro ? '<p class="rop-tec__d">El negro del diseño no se imprime: se aprovecha el color de la camiseta (y no cuenta como color).</p>' : '') +
      (foto ? '<p class="rop-tec__aviso">Es una foto o tiene muchos tonos: en serigrafía se simplifica a ' + (col ? col.n : 'pocos') + ' colores planos (míralo en la vista previa).' +
        (tdt ? ' Para verla tal cual, elige <a href="#" data-tec-id="' + esc(tdt.id) + '">' + esc(tdt.nombre) + '</a>.' : '') + '</p>' : '') +
      (act.colores ? '<button type="button" class="rop-tec__c" data-tec-colores>🎨 ' + (act.colores > 1 ? 'Ver y cambiar los colores del logo' : 'Elegir el color de la tinta') + '</button>' : '');
    caja.hidden = false;
    var bc = $(caja, '[data-tec-colores]');
    if (bc) bc.addEventListener('click', function () { var e = self._editorLibre; if (!e) return; if (e.cerrarCapas) e.cerrarCapas(); e.abrirImpresion(); });
    $$(caja, '[data-tec-id]').forEach(function (b) {
      b.addEventListener('click', function (ev) { ev.preventDefault(); if (self._editorLibre && self._editorLibre.fijarTecnica) self._editorLibre.fijarTecnica(b.getAttribute('data-tec-id')); });
    });
    $$(caja, '[data-tec-col]').forEach(function (b) {
      b.addEventListener('click', function () { var c2 = self._editorLibre && self._editorLibre.coloresZona && self._editorLibre.coloresZona(); if (c2) self._editorLibre.fijarColores(c2.n + parseInt(b.getAttribute('data-tec-col'), 10)); });
    });
  };

  Ropa.prototype.actualizar = function () {
    var r = this.raiz, res = this.resumen;
    var udsReales = res.unidades;
    /* CON UN TOTAL ELEGIDO, PRECIOS Y DESCUENTO SON LOS DEL TOTAL (Xavi, 14/10: «me lía»): si pide 100 y lleva 15 repartidas, el tramo, la barra
       y la tarjeta hablan de 100, no de 15 (la compra no se deja hasta repartirlas todas, así que es el precio final). */
    var pendT = (this.rep && this.rep.pendiente) ? this.rep.pendiente() : 0;
    if (pendT > 0) {
      var puT = udsReales ? res.bruto / udsReales : (function (self) {
        var cv = self.colorVista, vs = self.cfg.variantes || [];
        var v = vs.filter(function (x) { return x.color === cv && x.disponible; })[0] || vs.filter(function (x) { return x.color === cv; })[0] || vs[0];
        return v ? v.precio : 0;
      })(this);
      res = { lineas: res.lineas, unidades: udsReales + pendT, bruto: Math.round(res.bruto + pendT * puT) };
    }
    var uds = res.unidades;
    this.ajustaTecnicaPorCantidad(udsReales);
    this.tablaPorTecnica();
    this.pintarTecnica();
    // con editor, las zonas y las previas dependen de lo puesto Y de los colores pedidos
    if (this._editorLibre) this.recalcularLibre();
    this.pintarTramosSerigrafia(uds);   // después de recalcular: la tabla depende de cuántas zonas llevan diseño
    // con entrega urgente el aviso «Borrosa» del editor usa el mismo umbral que bloquea el botón
    if (this._editorLibre && this._editorLibre.setPppMin) this._editorLibre.setPppMin(this.urgente ? (this.cfg.pppPrueba || 80) : 70);
    var ex = this.extras(uds);
    this.pintarUrgente();
    // la urgencia va por tramos de cantidad; el tramo lo decide urgente.js
    var bUrg = (this.urgente && this.cabeUrgente() && window.Urgente)
      ? Urgente.banda(this.cfgUrg(), uds) : null;
    var urg = bUrg ? bUrg.precio : 0;
    var desc = this.descuento(uds);

    /* EL PRECIO QUE SE ENSEÑA ES EL QUE SE PAGA, con el descuento ya restado.
       Antes se enseñaba el bruto y debajo un aviso de "te corresponde un 25 %
       que se aplica en el carrito": el cliente hace la resta de cabeza igual,
       y mientras tanto el número grande es uno que no va a pagar nadie.

       Lo aplica Shopify con un descuento automático por tramo sobre la
       colección "Ropa personalizada · descuento por cantidad". Si esos
       descuentos se tocan en el admin, hay que tocar `escalones` en la
       configuración de la ficha, o esto miente.

       El redondeo se hace sobre el TOTAL de las prendas, como lo hace Shopify,
       para no bailar un céntimo con el carrito.

       Las zonas extra y la urgencia quedan fuera a propósito: no están en esa
       colección, así que Shopify tampoco se las descuenta. */
    var ahorro = desc ? Math.round(res.bruto * desc / 100) : 0;
    var prendas = res.bruto - ahorro;
    var dor = this.dorTotal();
    var bruto = prendas + ex.total + this.totalRecargos(uds) + dor + urg;

    var cuenta = $(r, '[data-cuenta]');
    if (cuenta) {
      // en el paso 1 se cuentan PRENDAS: meter aquí las zonas extra confunde
      cuenta.innerHTML = uds
        ? '<b>' + uds + ' ' + this.sust(uds) + '</b> · ' +
          (ahorro ? '<s class="rop-muted">' + money(res.bruto) + '</s> ' + money(prendas)
                  : money(res.bruto))
        : (this.hayTallas() ? 'Escribe cuántas quieres de cada talla.'
                            : 'Escribe cuántas quieres.');
      /* móvil con editor: el botón "Comprar" de la barra lleva el total en
         cuanto hay cantidades (antes solo el precio unitario, y el total
         no se veía hasta tener el diseño puesto) */
      var etq = document.querySelector('[data-libre-comprar-texto]');
      /* Sin cantidades, el precio que se enseña es el de UNA prenda del color
         de la vista con la impresión que lleva puesta, y cambia según se
         diseña (Xavi: "el precio del carro no cambia según vas diseñando").
         Con cantidades, el total. */
      var unaUd = this.precioUnaLibre();
      if (etq) {
        var unit = document.querySelector('.product .price-item');
        etq.textContent = uds ? money(bruto) : (unaUd != null ? money(unaUd) : (unit ? unit.textContent.trim() : ''));
      }
      /* Con editor, el precio verde de la ficha es el TOTAL en cuanto hay
         cantidades (Xavi), y la línea de debajo pasa a unidades y precio
         por taza; sin cantidades vuelve al precio unitario de Shopify. */
      if (this.cfg.casillasColor) {
        var verde = document.querySelector('.product--libre .price-item--regular');
        if (verde) {
          if (!verde.dataset.unitario) verde.dataset.unitario = verde.textContent.trim();
          verde.textContent = uds ? money(bruto) : (unaUd != null ? money(unaUd) : verde.dataset.unitario);
        }
        if (cuenta && uds) {
          /* Antes salía la media (total / unidades) y, como la blanca vale
             menos que las de color, cada taza de color que se añadía subía
             "el precio por taza" (Xavi: "cuantas más tazas añado, más cara").
             Ahora, un precio por cada grupo de colores que valga distinto,
             y la impresión aparte, que es igual para todas. */
          var porPrecio = {}, orden = [];
          res.lineas.forEach(function (l) {
            if (!porPrecio[l.precio]) { porPrecio[l.precio] = []; orden.push(l.precio); }
            if (l.color && porPrecio[l.precio].indexOf(l.color) === -1) porPrecio[l.precio].push(l.color);
          });
          /* Corto, que mareaba (Xavi): "blanca" y "color" en vez de la lista
             de colores, precio por unidad ya con el descuento, y la 2ª cara
             como un "+". El porcentaje y el ahorro van en la caja de abajo. */
          var esBlanco = function (c) { return /^blanc/i.test(c); };
          var otros = orden.filter(function (pr) { return !porPrecio[pr].every(esBlanco); });
          var partes = orden.map(function (pr) {
            var cols = porPrecio[pr], nombre;
            if (orden.length === 1) nombre = '';
            else if (cols.every(esBlanco)) nombre = 'blanca';
            else if (otros.length === 1) nombre = 'color';
            else nombre = cols.map(function (c) { return c.toLowerCase(); }).join(', ');
            var ud = Math.round(pr * (1 - desc / 100));
            return (nombre ? nombre + ' ' : '') + money(ud);
          });
          var extraUd = uds ? (bruto - prendas) / uds : 0;
          cuenta.innerHTML = '<b>' + uds + ' ' + this.sust(uds) + '</b> · ' + partes.join(' · ') +
            (orden.length > 1 ? '' : ' por ' + this.sust(1)) +
            (extraUd > 0 ? (this._tramos ? ' · impresión +' : ' · 2ª cara +') + money(extraUd) : '');
        }
      }
    }
    var sig = this.siguienteEscalon(uds);
    var pista = $(r, '[data-escalon]');
    if (pista) {
      /* Mensajes que empujan al siguiente tramo, con el precio al que
         saldría cada unidad (Xavi: "añade 2 tazas más y te saldrán a X €").
         El precio por unidad del tramo siguiente sale de la media de lo que
         lleva ahora (blancas y de color mezcladas) con ese descuento. */
      /* Dos líneas y ya (Xavi: "15 % de descuento conseguido / Añade 2
         tazas más para un 20 %"). */
      var partes = [];
      if (desc) partes.push('<b>' + Math.round(desc) + ' % de descuento</b> conseguido');
      if (sig && uds > 0) {
        var faltan = sig[0] - uds;
        partes.push('Añade <b>' + faltan + ' ' + this.sust(faltan) + ' más</b> para un <b>' + Math.round(sig[1]) + ' %</b>');
      }
      pista.innerHTML = partes.join('<br>');
      pista.hidden = !partes.length;
    }

    this.pintarBloqueo(udsReales);
    this.pintarGuia();
    this.pintarColores();
    this.pintarZonas();
    this.pintarArtes();
    this.pintarVista();
    if (this._editorLibre) {
      this._editorLibre.setColor(this.hexDe(this.colorVista) || this.hexPorDefecto(), this.colorVista || null);
      if (this._tiraColores) {
        var cv = this.colorVista;
        this.pintarTiraColores(cv);
      }
    }

    /* Lo que se cobra aparte, en una línea por concepto: las zonas de más y
       los recargos de zona, que son cosas distintas y se suman. */
    var zonas = $(r, '[data-zonas-precio]');
    if (zonas) {
      var uno = this.sust(1), partes = [];
      if (ex.zonas && ex.banda && ex.banda.serig && uds) {
        partes.push(ex.zonas + (ex.zonas === 1 ? ' color o zona extra' : ' colores o zonas extra') + ', <b>+' + money(ex.banda.precio) + ' por ' + uno + '</b> · ' + money(ex.total));
      } else if (ex.zonas && ex.banda && uds) {
        partes.push(ex.zonas === 1
          ? 'La segunda zona son <b>' + money(ex.banda.precio) + ' por ' + uno + '</b> · ' + money(ex.total)
          : ex.zonas + ' zonas más, a <b>' + money(ex.banda.precio) + ' por ' + uno + '</b> cada una · ' + money(ex.total));
      } else if (ex.zonas && !this._tramos) {
        partes.push('Las zonas a partir de la primera se cobran aparte.');
      }
      var descImp = this._tramos ? desc : 0;
      this.recargos().forEach(function (x) {
        // con tramos: lo que ocupa el diseño en esa cara, para que se entienda el tramo
        var oc = x.ocupado && !x.ocupado.fondo
          ? ' <span class="rop-muted">(' + fmt(x.ocupado.w, 1) + ' × ' + fmt(x.ocupado.h, 1) + ' cm)</span>' : '';
        // la impresión con el mismo descuento por cantidad que la prenda
        var ud = descImp ? Math.round(x.precio * (1 - descImp / 100)) : x.precio;
        partes.push(esc(sinMed(x.nombre)) + oc + ': ' + (x.precio
          ? (descImp ? '<s class="rop-muted">' + money(x.precio) + '</s> ' : '') + '<b>' + money(ud) + ' por ' + uno + '</b>' +
            (uds ? ' · ' + money(Math.round(x.precio * uds * (1 - descImp / 100))) : '')
          : '<b>incluido</b>'));
      });
      /* Los dorsales se cuentan por DORSALES, no por prendas: en un equipo de
         quince puede haber doce con nombre y tres sin nada. */
      var bd = this.dorBanda(), nd = this.dorValidos().length;
      if (bd && nd) {
        partes.push(nd + (nd === 1 ? ' dorsal' : ' dorsales') + ', a <b>' +
          money(bd.precio) + ' cada uno</b> · ' + money(bd.precio * nd));
      }
      zonas.innerHTML = partes.join('<br>');
      zonas.hidden = !partes.length;
    }

    // la tarjeta del precio va después de las tres líneas de texto, para poder apartarlas
    this.pintarResumen(uds, desc, res, prendas, bruto, sig);
    // si cambia algo después de preparar el envío, el enlace de pago ya no vale: se prepara otra vez
    if (this._enlacePago && !this.busy && this._firmaEnlace !== this.firmaPedido()) {
      this._enlacePago = null; this._firmaEnlace = null; this._presuGuardado = false;
      var bwa = $(r, '[data-presupuesto-wa]');
      if (bwa) { bwa.textContent = 'Enviar el presupuesto a alguien'; bwa.classList.remove('is-listo'); }
    }
    this.pintarBotonesPresupuesto();   // «Editar presupuesto» / «Actualizar este presupuesto» según haya cambios
    var prod = document.querySelector('.product--libre.is-compra:not(.is-solo-tallas)');
    /* La previa solo se repinta si ha cambiado algo de verdad (diseño o color). Antes se repintaba en cada actualización, y pintarla cambia de
       vista una a una, lo que provoca otra actualización: con 2 caras se quedaba repintando sin parar y el panel de compra iba a trompicones. */
    if (prod && !this._pintandoPrevia) {
      var fp = this.firmaPrevia();
      if (fp !== this._firmaPrevia) this.pintarPrevia();
    }

    // el botón
    var btn = $(r, '[data-add]');
    if (!this.busy && window.Cargando) Cargando.libre(btn);
    /* Si el logo no se ve en algún color, no se deja pasar: mandarle diez
       camisetas donde no se lee nada es una devolución segura. Tiene dos
       salidas, subir el logo bueno para ese color o quitar el color del pedido. */
    var self = this;
    var faltanArte = this.zonasSinArte();
    var malos = this.sinResolver();
    /* Si lo que se camufla es un texto, el botón no puede pedir un logo: lo que
       falta ahí es cambiarle la tinta. */
    var soloTexto = malos.length > 0 && malos.every(function (m) {
      var d = self.artePara(m.zona, m.color);
      return !!(d && d.texto);
    });
    // con editor, lo que se camufla se arregla en el propio editor: otro color de letra o de imagen
    var enEditor = malos.length > 0 && malos.every(function (m) {
      var d = self.artePara(m.zona, m.color);
      return !!(d && d.libre);
    });
    var perdidos = lista(malos.map(function (m) { return m.color; })
      .filter(function (c, i, a) { return a.indexOf(c) === i; }));
    /* Pedido mínimo y múltiplo del producto (metacampos custom.pedido_minimo / pedido_multiplo): Shopify no los
       impone sin catálogo B2B, así que se piden aquí y también en la ficha y el carrito. */
    var pMin = parseInt(this.cfg.pedidoMin, 10) || 1, pMul = parseInt(this.cfg.pedidoMultiplo, 10) || 1;
    var falta = !uds ? (pMin > 1 ? 'Pedido mínimo: ' + pMin + ' ' + this.sust(2)
                        : 'Indica ' + (this.masculino() ? 'cuántos ' : 'cuántas ') + this.sust(2) + ' quieres')
      : uds < pMin ? 'Pedido mínimo: ' + pMin + ' ' + this.sust(2) + ' (llevas ' + uds + ')'
      : this.tecnicaMala(uds) ? this.tecnicaMala(uds)
      : (pMul > 1 && (uds - pMin) % pMul) ? 'Se piden de ' + pMul + ' en ' + pMul + ' a partir de ' + pMin
      : !this.elegidas.length ? 'Elige dónde imprimimos'
      : faltanArte.length ? ((this.zonaDe(faltanArte[0]) || {}).libre
          ? 'Pon una imagen o un texto en ' + (this.masculino() ? 'el ' : 'la ') + this.sust(1)
          : faltanArte.length === 1
          ? 'Falta el logo de ' + (this.zonaDe(faltanArte[0]) || {}).nombre
          : 'Faltan ' + faltanArte.length + ' logos')
      : malos.length ? (enEditor ? 'El diseño no se ve en ' + perdidos + ': cámbiale el color'
          : soloTexto ? 'Cambia la tinta para ' + perdidos
          : 'Falta el logo para ' + perdidos)
      /* Lo que le falta a un dorsal lo dice dorsales.js con el caso delante:
         "Ponle el número a GARCIA" se arregla solo; "revisa los dorsales", no. */
      : this.faltaDorsal()
      /* En urgente NO se deja pasar un archivo justo de resolución. Un pedido
         de 24 h con un logo pixelado no da tiempo a rehacerlo: o sale mal, o
         no sale. Mejor que lo arregle antes de pagar. */
      || ((this.urgente && this.floja()) ? 'Para mañana necesitamos un archivo mejor'
      : null);
    btn.disabled = !!falta || this.busy;
    if (!this.busy) btn.textContent = falta || ('Añadir al carrito · ' + money(bruto));
    // el presupuesto por WhatsApp va a la par (Xavi, 29/09): sin diseño o sin cantidades, tampoco
    var bwa2 = $(r, '[data-presupuesto-wa]');
    if (bwa2) bwa2.disabled = !!falta || this.busy;
    // listo para comprar: cuando el cliente deja de tocar, se va preparando el archivo (ver precalentar)
    clearTimeout(this._tPrep);
    if (this._editorLibre && !falta && !this.busy) {
      this._tPrep = setTimeout(function () {
        if (window.requestIdleCallback) window.requestIdleCallback(function () { self.precalentar(); }, { timeout: 5000 });
        else self.precalentar();
      }, 1500);
    }

    var pie = $(r, '[data-pie]');
    if (pie) {
      var motivo = falta ? null : this.motivoPrueba();
      /* El plazo NO se dice aquí: lo dice entrega.js con una fecha concreta,
         arriba del todo. Antes este pie prometía "sale de taller en 24/48 h"
         y un pedido normal tarda 2-3 días en montarse, o sea que prometía de
         menos y quedaba mal por escrito. */
      pie.textContent = falta ? falta + '.'
        : this.urgente ? 'Entra hoy en máquina y sale en la recogida de esta tarde.'
        : motivo ? 'Te escribimos antes de imprimir: ' + motivo + '.'
        : 'Lo que ves es lo que se imprime.';
    }
  };

  /* LA VISTA PREVIA DE LO QUE COMPRA, arriba del panel de compra del móvil:
     la prenda del color elegido con el diseño, una foto por cara usada,
     sacada del editor (mockup). Se pinta al abrir "Comprar" y al cambiar
     algo con el panel abierto. */
  /* Los colores que de verdad se piden (los que tienen unidades), en el orden de las líneas. */
  Ropa.prototype.coloresPedido = function () {
    var cs = [];
    ((this.resumen && this.resumen.lineas) || []).forEach(function (l) { if (l.uds > 0 && l.color && cs.indexOf(l.color) === -1) cs.push(l.color); });
    return cs;
  };
  /* EL RESUMEN DE LO ELEGIDO (panel «Comprar», solo lectura): por color, sus tallas y unidades; la impresión de cada zona, si es urgente
     y las notas. Todo eso se cambia en «Cantidad» e «Impresión»; aquí solo se comprueba y se compra. */
  Ropa.prototype.pintarDetalle = function () {
    var caja = $(this.raiz, '[data-detalle]'), ed = this._editorLibre, self = this, res = this.resumen;
    if (!caja) return;
    if (!res || !res.unidades) { caja.hidden = true; caja.innerHTML = ''; return; }
    var porColor = {}, orden = [];
    (res.lineas || []).forEach(function (l) {
      var k = l.color || '';
      if (!porColor[k]) { porColor[k] = []; orden.push(k); }
      porColor[k].push(l);
    });
    var html = '<p class="rop-det__t">Tu pedido</p>';
    orden.forEach(function (c) {
      var ls = porColor[c], tot = ls.reduce(function (n, l) { return n + l.uds; }, 0);
      var tallas = ls.filter(function (l) { return l.talla; }).map(function (l) { return esc(l.talla) + ' × ' + l.uds; }).join(' · ');
      html += '<div class="rop-det__f"><i style="background:' + esc(self.hexDe(c) || '#e9e9ee') + '"></i><span>' + (c ? '<b>' + esc(c) + '</b>' : '') +
        (tallas ? (c ? ' · ' : '') + tallas : '') + '</span><b class="rop-det__n">' + tot + ' ud</b></div>';
    });
    var tz = ed && ed.tecnicasPorZona ? ed.tecnicasPorZona() : [];
    if (tz.length) {
      html += '<p class="rop-det__d"><b>Impresión:</b> ' + tz.map(function (t) { return (tz.length > 1 ? esc(t.zona) + ': ' : '') + esc(t.nombre); }).join(' · ') + '</p>';
    }
    if (this.urgente) html += '<p class="rop-det__d"><b>Entrega urgente</b> (24 h)</p>';
    var notas = ((($(this.raiz, '[data-notas]') || {}).value) || '').trim();
    if (notas) html += '<p class="rop-det__d"><b>Notas:</b> ' + esc(notas) + '</p>';
    caja.innerHTML = html;
    caja.hidden = false;
  };
  Ropa.prototype.firmaPrevia = function () {
    var ed = this._editorLibre;
    try { return (this.colorVista || '') + '|' + (this.coloresPedido()[0] || '') + '|' + (ed && ed.firma ? ed.firma() : ''); } catch (e) { return String(Date.now()); }
  };
  Ropa.prototype.pintarPrevia = function () {
    var caja = $(this.raiz, '[data-compra-previa]'), ed = this._editorLibre;
    if (!caja || !ed || !ed.mockup || !(this._tramos || this.prenda === 'taza')) return;
    this._firmaPrevia = this.firmaPrevia();
    this._pintandoPrevia = true;
    try { this._pintarPreviaInterno(caja, ed); } finally { this._pintandoPrevia = false; }
  };
  Ropa.prototype._pintarPreviaInterno = function (caja, ed) {
    var self = this, antes = ed.vista().id, fotos = [];
    /* La previa enseña lo que se compra: si lo que se está mirando es otro color que el de las unidades
       puestas (miró el rojo y pidió el marino), se pinta con el pedido y luego se devuelve la vista. */
    var cp = this.coloresPedido()[0], cv = this.colorVista, cambiado = false;
    if (cp && cv && cp !== cv && ed.setColor) {
      try { ed.setColor(this.hexDe(cp) || this.hexPorDefecto(), cp); cambiado = true; } catch (e0) { /* nada */ }
    }
    try {
      /* taza: sus vistas no son «zonas elegidas»; se enseñan el lado izquierdo y el derecho (la panorámica es la hoja plana, no se parece a la taza) */
      var vistasPrevia = this.prenda === 'taza' ? this.catalogo.filter(function (z) { return z.libre && !/panoram/.test(z.id || ''); }) : this.zonas().filter(function (z) { return z.libre; });
      vistasPrevia.forEach(function (z) {
        ed.cambiarVista(z.id);
        var m = ed.mockup(420);
        if (m) fotos.push({ nombre: z.nombre, c: m });
      });
      ed.cambiarVista(antes);
    } catch (e) { try { ed.cambiarVista(antes); } catch (e2) { /* nada */ } }
    if (cambiado) { try { ed.setColor(this.hexDe(cv) || this.hexPorDefecto(), cv); } catch (e3) { /* nada */ } }
    caja.innerHTML = '';
    if (!fotos.length || !ed.hayDiseño()) { caja.hidden = true; return; }
    fotos.forEach(function (f) {
      var fig = document.createElement('figure'); fig.className = 'rop-previa__f';
      fig.appendChild(f.c);
      var cap = document.createElement('figcaption'); cap.textContent = f.nombre; fig.appendChild(cap);
      caja.appendChild(fig);
    });
    var nota = document.createElement('p'); nota.className = 'rop-previa__n';
    nota.textContent = 'Así se imprime. Toca "Seguir editando" si quieres cambiar algo.';
    caja.appendChild(nota);
    caja.hidden = false;
  };

  /* ENVIAR EL PRESUPUESTO A OTRA PERSONA (Xavi, 29/09: "que la persona se
     lo pueda mandar a otra"): el que decide en el club o en la empresa no
     siempre es el que diseña. Se comparte la foto del diseño y el
     presupuesto (prenda, color, tallas, impresión, precio por unidad y
     total) por la hoja de compartir del móvil, y él elige a quién; si el
     navegador no deja compartir archivos, por WhatsApp solo el texto. */
  /* El enlace a la landing del presupuesto: el resumen viaja dentro del enlace (JSON en
     base64url), sin guardar nada en ningún sitio. null si algo falla. */
  Ropa.prototype.enlaceLanding = function (texto) {
    try {
      var lineas = String(texto).split('\n');
      var pr = lineas.filter(function (l) { return /^Precio:/.test(l); })[0] || '';
      var l = lineas.slice(1).filter(function (x) { return !/^Precio:|^Ya está preparado|^Diseñado en/.test(x); });
      var datos = { n: this.nombreProducto(), l: l, pr: pr.replace(/^Precio:\s*/, ''), i: this._mockupUrl || '', u: this._enlacePago };
      var bytes = new TextEncoder().encode(JSON.stringify(datos)), bin = '';
      for (var k = 0; k < bytes.length; k++) bin += String.fromCharCode(bytes[k]);
      var b64 = btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return location.origin + raiz + 'pages/presupuesto?d=' + b64;
    } catch (e) { return null; }
  };
  /* El resumen viaja DENTRO del carrito (atributo _presupuesto) y el mensaje lleva solo el
     enlace corto del carrito. La tarjeta la pinta snippets/presupuesto-carrito.liquid. Si el
     guardado falla, se usa la landing larga de siempre (enlaceLanding). */
  Ropa.prototype.guardarPresupuesto = async function () {
    this._presuGuardado = false;
    var lineas = this.textoPresupuesto().split('\n');
    var pr = lineas.filter(function (l) { return /^Precio:/.test(l); })[0] || '';
    var l = lineas.slice(1).filter(function (x) { return !/^Precio:|^Ya está preparado|^Diseñado en/.test(x); });
    var datos = { n: this.nombreProducto(), l: l, pr: pr.replace(/^Precio:\s*/, ''), i: this._mockupUrl || '' };
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var r = await fetch(raiz + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _presupuesto: JSON.stringify(datos) } })
    });
    this._presuGuardado = !!r.ok;
  };
  Ropa.prototype.textoPresupuesto = function () {
    this.tablaPorTecnica();
    var res = this.resumen, uds = res.unidades, desc = this.descuento(uds);
    var ahorro = desc ? Math.round(res.bruto * desc / 100) : 0;
    var ex = this.extras(uds);
    var prendas = res.bruto - ahorro, bruto = prendas + ex.total + this.totalRecargos(uds) + this.dorTotal();
    var tallas = {};
    (res.lineas || []).forEach(function (l) { var k = l.color + (l.talla ? ' ' + l.talla : ''); tallas[k] = (tallas[k] || 0) + l.uds; });
    var lineas = ['Presupuesto de Imprimirlo · ' + this.nombreProducto()];
    lineas.push('· ' + (uds || 1) + ' ' + this.sust(uds || 1) + (!uds && this.colorVista ? ' en ' + this.colorVista : ''));   // con cantidades, el color ya va en cada línea de tallas
    Object.keys(tallas).forEach(function (k) { lineas.push('   ' + k + ': ' + tallas[k]); });
    this.recargos().forEach(function (x) {
      var medida = x.ocupado && !x.ocupado.fondo ? ' (' + fmt(x.ocupado.w, 1) + ' × ' + fmt(x.ocupado.h, 1) + ' cm)' : '';
      lineas.push('· Impresión ' + sinMed(x.nombre).toLowerCase() + medida);
    });
    // la taza: la segunda cara se cobra como zona extra
    if (ex.zonas && ex.banda) lineas.push('· ' + (ex.banda.serig ? (ex.zonas === 1 ? 'Un color o zona extra' : ex.zonas + ' colores o zonas extra') : ex.zonas === 1 ? 'Segunda cara' : ex.zonas + ' caras más') + ' (' + money(ex.banda.precio) + ' por ' + this.sust(1) + ')');
    var nd = this.dorValidos().length;
    if (nd) lineas.push('· ' + nd + ' dorsal' + (nd === 1 ? '' : 'es') + ' (nombre y número)');
    if (this._enlacePago && this._totalCarrito != null) bruto = this._totalCarrito;
    if (uds) {
      lineas.push('Precio: ' + money(Math.round(bruto / uds)) + ' por ' + this.sust(1) + ', ' + money(bruto) + ' en total' + (desc ? ' (con el ' + desc + ' % por cantidad)' : '') + ', IVA incluido');
    } else {
      var u = this.precioUnaLibre();
      if (u != null) lineas.push('Precio: ' + money(u) + ' por ' + this.sust(1) + ', IVA incluido');
    }
    if (!this._enlacePago) lineas.push('Diseñado en ' + location.href.split('?')[0]);
    return lineas.join('\n');
  };
  /* El enlace de pago del carrito de Shopify (/cart/c/<token>): quien lo abre
     en otro móvil ve el pedido entero, con el diseño ya subido, y puede
     pagarlo. Así el que decide no tiene que rehacer nada (Xavi, 29/09). */
  Ropa.prototype.enlaceCarrito = async function () {
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var cart = await (await fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    if (!cart || !cart.token || !cart.item_count) return null;
    // el total que se va a pagar de verdad, para que el mensaje diga el mismo número
    this._totalCarrito = cart.total_price;
    // la foto del montaje que subió el carrito (propiedad _Mockup de alguna línea), para la landing del presupuesto
    this._mockupUrl = null;
    (cart.items || []).some(function (it) { var u = it.properties && it.properties._Mockup; if (u) { this._mockupUrl = String(u); return true; } return false; }, this);
    return location.origin + raiz + 'cart/c/' + cart.token;
  };
  /* LA TARJETA DEL PRESUPUESTO, como imagen (Xavi: "hazlo muy visual"): la
     prenda con el diseño (una foto por cara), y debajo cuántas, de qué color
     y tallas, la impresión, el precio por unidad en grande, el total y el
     enlace. Es lo que se comparte; el texto va de acompañamiento. */
  Ropa.prototype.tarjetaPresupuesto = function (fotos, enlace) {
    this.tablaPorTecnica();
    var W = 1080, res = this.resumen, uds = res.unidades, desc = this.descuento(uds);
    var ahorro = desc ? Math.round(res.bruto * desc / 100) : 0;
    var ex = this.extras(uds);
    var prendas = res.bruto - ahorro, bruto = prendas + ex.total + this.totalRecargos(uds) + this.dorTotal();
    if (enlace && this._totalCarrito != null) bruto = this._totalCarrito;
    var porUd = uds ? Math.round(bruto / uds) : this.precioUnaLibre();
    var c = document.createElement('canvas'), ctx = c.getContext('2d');
    var pad = 56, y = 0;
    // alto: cabecera + fotos + bloque de datos
    var fw = fotos.length ? Math.min(460, (W - pad * 2 - 24 * (fotos.length - 1)) / fotos.length) : 0;
    var fh = fotos.length ? Math.round(fw * fotos[0].c.height / fotos[0].c.width) : 0;
    var H = 150 + (fotos.length ? fh + 70 : 0) + 560 + (enlace ? 90 : 0);
    c.width = W; c.height = H;
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, W, H);
    // cabecera verde
    ctx.fillStyle = '#1f8f2e'; ctx.fillRect(0, 0, W, 120);
    ctx.fillStyle = '#ffffff'; ctx.font = '700 44px Poppins, Arial, sans-serif'; ctx.textBaseline = 'middle';
    ctx.fillText('IMPRIMIRLO', pad, 60);
    ctx.font = '400 30px Poppins, Arial, sans-serif'; ctx.textAlign = 'right';
    ctx.fillText('Presupuesto', W - pad, 60); ctx.textAlign = 'left';
    y = 150;
    // fotos
    if (fotos.length) {
      var x = Math.round((W - (fw * fotos.length + 24 * (fotos.length - 1))) / 2);
      fotos.forEach(function (f) {
        ctx.save(); ctx.shadowColor = 'rgba(0,0,0,.15)'; ctx.shadowBlur = 18; ctx.shadowOffsetY = 6;
        ctx.fillStyle = '#fff'; ctx.fillRect(x, y, fw, fh); ctx.restore();
        ctx.drawImage(f.c, x, y, fw, fh);
        ctx.fillStyle = '#555'; ctx.font = '600 24px Poppins, Arial, sans-serif'; ctx.textAlign = 'center';
        ctx.fillText(f.nombre, x + fw / 2, y + fh + 32); ctx.textAlign = 'left';
        x += fw + 24;
      });
      y += fh + 70;
    }
    // datos
    var fila = function (izq, der, grande) {
      ctx.fillStyle = '#222'; ctx.font = (grande ? '700 40px' : '400 30px') + ' Poppins, Arial, sans-serif';
      ctx.fillText(izq, pad, y);
      ctx.textAlign = 'right'; ctx.font = (grande ? '700 52px' : '600 30px') + ' Poppins, Arial, sans-serif';
      if (grande) ctx.fillStyle = '#1f8f2e';
      ctx.fillText(der, W - pad, y); ctx.textAlign = 'left';
      y += grande ? 76 : 52;
    };
    var tallas = {};
    (res.lineas || []).forEach(function (l) { if (l.talla) tallas[l.talla] = (tallas[l.talla] || 0) + l.uds; });
    var tallasTxt = Object.keys(tallas).map(function (t) { return tallas[t] + ' ' + t; }).join(' · ');
    ctx.fillStyle = '#222'; ctx.font = '700 40px Poppins, Arial, sans-serif';
    ctx.fillText((uds || 1) + ' ' + this.sust(uds || 1) + (this.colorVista ? ' · ' + this.colorVista : ''), pad, y); y += 56;
    if (tallasTxt) { ctx.fillStyle = '#555'; ctx.font = '400 28px Poppins, Arial, sans-serif'; ctx.fillText(tallasTxt, pad, y); y += 54; }
    y += 10; ctx.fillStyle = '#e5e5e5'; ctx.fillRect(pad, y, W - pad * 2, 2); y += 40;
    var self = this;
    this.recargos().forEach(function (x) {
      var medida = !x.ocupado ? '' : x.ocupado.fondo ? ' · fondo entero' : ' · ' + fmt(x.ocupado.w, 1) + ' × ' + fmt(x.ocupado.h, 1) + ' cm';
      var neto = Math.round(x.precio * (1 - (uds && self._tramos ? desc : 0) / 100));
      fila('Impresión ' + sinMed(x.nombre).toLowerCase() + medida, x.precio ? money(neto) + ' / ud' : 'incluida');
    });
    if (ex.zonas && ex.banda) fila(ex.banda.serig ? (ex.zonas === 1 ? 'Color o zona extra' : ex.zonas + ' colores o zonas extra') : ex.zonas === 1 ? 'Segunda cara' : ex.zonas + ' caras más', money(ex.banda.precio) + ' / ud');
    var nd = this.dorValidos().length, bd = this.dorBanda();
    if (nd && bd) fila(nd + (nd === 1 ? ' dorsal' : ' dorsales') + ' (nombre y número)', money(bd.precio) + ' / ud');
    y += 10; ctx.fillStyle = '#e5e5e5'; ctx.fillRect(pad, y, W - pad * 2, 2); y += 56;
    if (porUd != null) fila('Por ' + this.sust(1), money(porUd), true);
    if (uds) fila('Total', money(bruto), true);
    ctx.fillStyle = '#777'; ctx.font = '400 24px Poppins, Arial, sans-serif';
    ctx.fillText('IVA incluido' + (desc && uds ? ' · con el ' + desc + ' % de descuento por cantidad' : ''), pad, y); y += 60;
    if (enlace) {
      ctx.fillStyle = '#eaf7ec'; ctx.fillRect(pad, y - 26, W - pad * 2, 80);
      ctx.fillStyle = '#1f5a2a'; ctx.font = '600 26px Poppins, Arial, sans-serif';
      ctx.fillText('Listo para pagar: abre el enlace del mensaje', pad + 24, y + 14);
    }
    return c;
  };
  Ropa.prototype.fotosDiseño = function () {
    var ed = this._editorLibre, fotos = [];
    if (!ed || !ed.mockup || !ed.hayDiseño()) return fotos;
    var antes = ed.vista().id, self = this;
    try {
      var vistas = this._tramos ? this.zonas().filter(function (z) { return z.libre; })
        : this.catalogo.filter(function (z) { return z.libre && z !== self._zonaSuperficie; }); // taza: los dos lados con foto
      vistas.forEach(function (z) {
        ed.cambiarVista(z.id);
        var m = ed.mockup(700);
        if (m) fotos.push({ nombre: z.nombre, c: m });
      });
    } catch (e) { /* nada */ }
    try { ed.cambiarVista(antes); } catch (e) { /* nada */ }
    return fotos;
  };
  // el nombre del producto tal cual (el título de la pestaña es el de Google, con precio y marca)
  Ropa.prototype.nombreProducto = function () {
    var h = document.querySelector('.product__title h1') || document.querySelector('h1');
    var t = h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
    return t || (document.title || '').split('|')[0].trim();
  };
  // lo que define el pedido preparado: si cambia, el enlace de pago ya no vale
  Ropa.prototype.firmaPedido = function () {
    return JSON.stringify([this.resumen.lineas, this.recargos().map(function (x) { return x.nombre; }), this.colorVista, this.dorValidos().length]);
  };
  /* PRESUPUESTO EDITABLE (Xavi, 19/10): tras crearlo, el botón pasa a «Editar presupuesto». Si el cliente cambia algo, el botón pasa a
     «Actualizar este presupuesto» (el MISMO enlace, con «Actualizado el …» en su página) y aparece «Enviar como presupuesto nuevo»
     (otro enlace; el anterior se queda como estaba). Solo vale mientras esta página siga abierta con el diseño. */
  Ropa.prototype.pintarBotonesPresupuesto = function () {
    var r = this.raiz, btn = $(r, '[data-presupuesto-wa]'), self = this;
    if (!btn || !this._presCod || this.busy || this._presOcupado) return;
    var alDia = this._presFirma === this.firmaPedido();
    var b2 = $(r, '[data-presupuesto-nuevo]');
    var texto = alDia ? 'Editar presupuesto' : 'Actualizar este presupuesto';
    if (btn.textContent !== texto) btn.textContent = texto;
    btn.classList.toggle('is-listo', alDia);
    if (alDia) { if (b2) b2.hidden = true; return; }
    if (!b2) {
      b2 = document.createElement('button'); b2.type = 'button'; b2.setAttribute('data-presupuesto-nuevo', '');
      b2.className = btn.className.replace(/\bis-listo\b/, '').trim();
      b2.style.marginTop = '8px'; b2.textContent = 'Enviar como presupuesto nuevo';
      b2.addEventListener('click', function () { self.presupuestoWhatsapp('nuevo'); });
      btn.parentNode.insertBefore(b2, btn.nextSibling);
    }
    b2.hidden = false; b2.disabled = btn.disabled;
  };
  Ropa.prototype.presupuestoWhatsapp = async function (modo) {
    var ed = this._editorLibre, btn = $(this.raiz, '[data-presupuesto-wa]');
    if (this._presOcupado) return;
    // «Editar presupuesto» (el presupuesto está al día): solo lleva al editor, no crea nada
    if (this._presCod && modo !== 'nuevo' && this._presFirma === this.firmaPedido()) {
      var hostE = document.querySelector('[data-libre-editor-host]') || this.raiz;
      if (hostE && hostE.scrollIntoView) hostE.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (this.flash) this.flash('Haz los cambios y pulsa «Actualizar este presupuesto».');
      return;
    }
    var actualizar = !!(this._presCod && modo !== 'nuevo');   // doble clic: ya se está preparando (antes caía al envío de siempre y se creaba otro)
    /* PRESUPUESTO LISTO PARA PAGAR, SIEMPRE (Xavi, 07/10): un pedido borrador con su propio enlace de pago (Worker de presupuestos),
       con las mismas líneas y archivos que irían al carrito. No usa ni vacía el carrito de quien lo prepara y no caduca. Si el
       Worker falla, se sigue con el envío de siempre (por el carrito). */
    if (this.cfg.presupuestoUrl && window.Presupuesto && !this._presOcupado) {
      var listoW = !!(this.resumen.unidades && !this.zonasSinArte().length && !this.sinResolver().length && !this.faltaDorsal());
      if (listoW) {
        this._presOcupado = true; this._presWorkerFalla = false;
        var antesW = btn ? btn.textContent : '';
        if (btn) btn.disabled = true;
        var creadoW = null;
        try { creadoW = await this.alCarrito({ presupuesto: true, actualizar: actualizar }); } catch (eW) { creadoW = false; }
        this._presOcupado = false;
        if (btn) { btn.disabled = false; btn.textContent = antesW; }
        if (creadoW && creadoW.url) {
          var notaW = $(this.raiz, '[data-presupuesto-nota]');
          if (!notaW && btn && btn.parentNode) {
            notaW = document.createElement('p'); notaW.setAttribute('data-presupuesto-nota', ''); notaW.className = 'rop-muted';
            notaW.style.cssText = 'margin:8px 0 0;font-size:1.4rem';
            btn.parentNode.insertBefore(notaW, btn.nextSibling);
          }
          var totalW = creadoW.total ? money(Math.round(parseFloat(creadoW.total) * 100)) : '';
          creadoW.totalTexto = totalW ? totalW + ' IVA incl.' : '';
          var lineaPrecio = (this.textoPresupuesto().split('\n').filter(function (l) { return /^Precio:/.test(l); })[0] || '');
          var textoW = 'Presupuesto de Imprimirlo · ' + this.nombreProducto() + '\n' +
            (totalW ? 'Precio: ' + totalW + ' IVA incl.' : lineaPrecio) + (creadoW.landing ? '\nMira el montaje y acepta el presupuesto aquí: ' + creadoW.landing : '\nAcepta el presupuesto aquí: ' + creadoW.url);
          var copiadoW = false;
          try { if (!Presupuesto.esMovil() && navigator.clipboard) { await navigator.clipboard.writeText(textoW); copiadoW = true; } } catch (eC) { /* se copia con el botón */ }
          Presupuesto.mostrar(notaW, creadoW, textoW, copiadoW);
          var mCod = /\/p\/([a-z0-9]+)/.exec(creadoW.landing || '');
          this._presCod = mCod ? mCod[1] : null; this._presFirma = this.firmaPedido(); this._presLanding = creadoW.landing || '';
          this.pintarBotonesPresupuesto();
          return;
        }
        // el presupuesto a actualizar ya estaba pagado o no existe: se crea uno nuevo
        if (actualizar && this._presWorkerFalla && /HTTP 409/.test(this._presMotivo || '')) {
          this._presWorkerFalla = false; this._presCod = null;
          await this.presupuestoWhatsapp('nuevo');
          return;
        }
        if (!this._presWorkerFalla) return;   // faltaba algo del diseño: el aviso ya lo ha dado alCarrito
        this._presWorkerFalla = false;
        /* A la vista, sin consola: por qué no salió el presupuesto nuevo (se sigue con el enlace de siempre). Pequeño y gris; con el motivo en claro para que un pantallazo ya lo lleve. */
        try {
          var notaF = $(this.raiz, '[data-presupuesto-aviso]');
          if (!notaF && btn && btn.parentNode) {
            notaF = document.createElement('p'); notaF.setAttribute('data-presupuesto-aviso', ''); notaF.className = 'rop-muted';
            notaF.style.cssText = 'margin:8px 0 0;font-size:1.2rem;word-break:break-word';
            btn.parentNode.insertBefore(notaF, btn.nextSibling);
          }
          if (notaF) notaF.textContent = 'Aviso técnico: el presupuesto con enlace corto no se ha podido crear (' + (this._presMotivo || 'sin respuesta') + '). Te preparamos el enlace de siempre.';
        } catch (eF) { /* sin aviso: sigue con el enlace de siempre */ }
      }
    }
    /* Con cantidades y diseño, primero al carrito (con archivos y mockup),
       igual que "Añadir al carrito" pero sin ir a la página del carrito, y
       de ahí sale el enlace de pago que viaja con el presupuesto.
       EN DOS TOQUES: subir tarda unos segundos y después el móvil ya no
       deja abrir la hoja de compartir con la imagen (hace falta un toque
       reciente). El primero prepara y el botón pasa a "Listo: enviar"; el
       segundo comparte. */
    var listo = !!(this.resumen.unidades && !this.zonasSinArte().length && !this.sinResolver().length && !this.faltaDorsal());
    if (listo && !this._enlacePago) {
      /* El enlace de pago es de TODO el carrito: si ya había otras cosas,
         el otro vería un total que no es el del presupuesto (Xavi). Se
         avisa y, si acepta, se vacía antes. */
      var raizC = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      try {
        var cartAntes = await (await fetch(raizC + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        if (cartAntes && cartAntes.item_count) {
          if (!window.confirm('Tu carrito ya tiene otros artículos. Para que el enlace lleve solo este presupuesto los quitamos del carrito. ¿Seguimos?')) return;
          await fetch(raizC + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
        }
      } catch (e) { /* sin carrito legible: se sigue */ }
      if (btn && window.Cargando) Cargando.ocupar(btn, 'Preparando el pedido…');
      var ok = await this.alCarrito({ sinIr: true });
      var enlace = null;
      if (ok) { try { enlace = await this.enlaceCarrito(); } catch (e) { enlace = null; } }
      if (btn && window.Cargando) Cargando.libre(btn);
      if (ok && enlace) {
        this._enlacePago = enlace; this._firmaEnlace = this.firmaPedido();
        if (btn) { btn.textContent = 'Listo: enviar el presupuesto'; btn.classList.add('is-listo'); }
        return;
      }
      if (!ok) return; // el aviso ya lo ha dado alCarrito
    }
    var texto = this.textoPresupuesto();
    if (this._enlacePago) {
      /* Con el pedido ya preparado, el mensaje lleva un enlace a la landing del
         presupuesto (pages/presupuesto), con el resumen dentro del enlace. */
      var landing = this.enlaceLanding(texto);
      texto = landing
        ? 'Presupuesto de Imprimirlo · ' + this.nombreProducto() + '\n' + (texto.split('\n').filter(function (l) { return /^Precio:/.test(l); })[0] || '') +
          '\nMíralo y acepta el presupuesto aquí: ' + landing
        : texto + '\nYa está preparado: para aceptarlo, abre ' + this._enlacePago;
    }
    /* La hoja de compartir SOLO en móvil: en Windows/Chrome de PC abre una ventana
       "Compartir" vacía (sin WhatsApp) que se queda cargando (Xavi, 29/09). */
    var movilTactil = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '') ||
      !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches && (navigator.maxTouchPoints || 0) > 1);
    if (movilTactil) {
      // la tarjeta con la foto del diseño y el precio, como imagen, por la hoja de compartir del móvil
      var tarjeta = null;
      try { tarjeta = this.tarjetaPresupuesto(this.fotosDiseño(), enlace); } catch (e) { tarjeta = null; }
      var blob = tarjeta ? await new Promise(function (ok) { tarjeta.toBlob(ok, 'image/jpeg', 0.9); }) : null;
      if (blob && navigator.share && navigator.canShare) {
        try {
          var f = new File([blob], 'presupuesto-imprimirlo.jpg', { type: 'image/jpeg' });
          if (navigator.canShare({ files: [f] })) {
            await navigator.share({ files: [f], title: 'Presupuesto de Imprimirlo', text: texto });
            return;
          }
        } catch (e) { if (e && e.name === 'AbortError') return; /* cancelado; otro fallo: al texto */ }
      }
      window.open('https://wa.me/?text=' + encodeURIComponent(texto), '_blank', 'noopener');
      return;
    }
    /* PC (Xavi, 29/09, opción 3): se COPIA el mensaje y se avisa en el propio botón; se pega
       en el chat que se quiera (WhatsApp, correo…). Sin JPG ni ventanas intermedias. */
    var copiado = false;
    try { await navigator.clipboard.writeText(texto); copiado = true; } catch (e) {
      try {
        var ta = document.createElement('textarea'); ta.value = texto; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select(); copiado = document.execCommand('copy'); ta.remove();
      } catch (e2) { copiado = false; }
    }
    if (copiado) {
      if (btn) {
        var antes = btn.textContent;
        btn.textContent = '✓ Mensaje copiado: pégalo en el chat';
        setTimeout(function () { btn.textContent = antes; }, 4000);
      }
      return;
    }
    window.open('https://wa.me/?text=' + encodeURIComponent(texto), '_blank', 'noopener');
  };

  /* STOCK DE MIDOCEAN EN LA FICHA (24/10/2026, idea de sulema.es): el Worker de stock (cfg.stockUrl, metacampo de tienda imprimirlo.stock_url) da las
     unidades que tiene MidOcean de cada referencia. Se enseña «En stock» con las unidades del color que se mira y, si el pedido pide más de lo que
     hay, un aviso de que el plazo puede ser mayor. Solo en productos con etiqueta MidOcean; si el Worker no contesta, no se enseña nada. */
  Ropa.prototype.cargarStock = function () {
    var vs = this.cfg.variantes || [];
    if (this._stockPedido || !this.cfg.stockUrl || this.cfg.imprime !== 'midocean' || !window.fetch) return;
    var fam = {};
    vs.forEach(function (v) { var f = String(v.sku || '').split('-')[0]; if (/^[A-Za-z0-9]{3,12}$/.test(f)) fam[f.toUpperCase()] = 1; });
    var lista = Object.keys(fam).slice(0, 12);
    if (!lista.length) return;
    this._stockPedido = true;
    var self = this;
    fetch(this.cfg.stockUrl.replace(/\/$/, '') + '/stock?p=' + lista.join(',')).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j || !j.stock) return;
      self._stock = j.stock; self._stockMin = j.minimo || 10;
      if (self.resumen && self.pintarResumenActual) self.pintarResumenActual();
      else if (self.actualizar) self.actualizar();
    }).catch(function () {});
  };
  Ropa.prototype.stockDeVariante = function (color, talla) {
    var st = this._stock, vs = this.cfg.variantes || [];
    if (!st) return null;
    var cand = vs.filter(function (v) { return (!color || v.color === color) && (!talla || v.talla === talla) && v.sku && st[v.sku] != null; });
    return cand.length ? st[cand[0].sku] : null;
  };
  Ropa.prototype.htmlStock = function (uds) {
    if (!this._stock) return '';
    var self = this, min = this._stockMin || 10, aviso = [], cv = this.colorVista || '';
    var fmtN = function (n) { return n >= 10000 ? 'más de 10.000' : n.toLocaleString('es-ES'); };
    (this.resumen && this.resumen.lineas || []).forEach(function (l) {
      var q = self.stockDeVariante(l.color, l.talla);
      if (q != null && l.uds > q) aviso.push((l.color ? l.color + ': ' : '') + 'hay ' + (q >= min ? q.toLocaleString('es-ES') : 'muy pocas') + ' uds y pides ' + l.uds);
    });
    var q0 = this.stockDeVariante(cv, null);
    if (q0 == null && !aviso.length) return '';
    var ok = q0 != null && q0 >= min;
    var h = '<div class="rop-stock' + (aviso.length ? ' rop-stock--aviso' : '') + '">';
    if (q0 != null) h += '<div class="rop-stock__l">' + (ok ? '<b>✓ En stock</b> · ' + fmtN(q0) + ' uds' + (cv ? ' en ' + esc(cv) : '') : '<b>Sin stock</b>' + (cv ? ' en ' + esc(cv) : '')) + '</div>';
    if (aviso.length) h += '<div class="rop-stock__a">Pides más de lo que hay ahora mismo (' + esc(aviso.join(' · ')) + '). El plazo puede ser mayor: escríbenos por WhatsApp y te lo confirmamos.</div>';
    return h + '</div>';
  };

  /* TU PRESUPUESTO (24/10/2026, idea de la caja de sulema.es): bajo el precio, el desglose sin IVA / IVA / envío y un PDF para enseñárselo a quien
     decide. El envío es el de la tienda en la Península: gratis desde 60 €, si no 6,95 € (ajustes de envío de Shopify). */
  var ENVIO_GRATIS = 6000, ENVIO_PRECIO = 695;
  Ropa.prototype.bloquePresupuesto = function (bruto, uds) {
    if (!uds || !bruto) return '';
    var sin = Math.round(bruto / 1.21), iva = bruto - sin, gratis = bruto >= ENVIO_GRATIS;
    this._pres = { uds: uds, bruto: bruto, sin: sin, iva: iva, gratis: gratis };
    var f = function (a, b, fuerte) { return '<div class="rop-pres__f' + (fuerte ? ' rop-pres__f--t' : '') + '"><span>' + a + '</span><b>' + b + '</b></div>'; };
    return '<div class="rop-pres"><div class="rop-pres__t">Tu presupuesto</div>' +
      f('Total sin IVA', money(sin)) + f('IVA (21 %)', money(iva)) + f('Total con IVA', money(bruto), true) +
      f('Envío (Península)', gratis ? 'gratis' : money(ENVIO_PRECIO)) +
      (gratis ? '' : '<p class="rop-pres__n">Envío gratis desde ' + money(ENVIO_GRATIS) + '.</p>') +
      '<button type="button" class="rop-pres__pdf" data-pres-pdf>⬇ Descargar presupuesto en PDF</button></div>';
  };
  /* PDF sin librerías (A4, Helvetica, rectángulos de color, líneas, texto y JPEG). Latin-1 + «€» (0x80 en WinAnsi). */
  function pdfCrear() {
    var cont = '', imgs = [], enl = [];
    var cod = function (t) {
      var o = '';
      String(t).split('').forEach(function (ch) {
        var c = ch.charCodeAt(0);
        if (ch === '€') c = 0x80; else if (c > 255) c = 63;
        if (ch === '(' || ch === ')' || ch === '\\') o += '\\' + ch; else o += String.fromCharCode(c);
      });
      return o;
    };
    var col = function (c) { return (c[0] / 255).toFixed(3) + ' ' + (c[1] / 255).toFixed(3) + ' ' + (c[2] / 255).toFixed(3); };
    var ancho = function (t, s, b) {   // anchura aproximada de Helvetica (para alinear a la derecha)
      var w = 0;
      String(t).split('').forEach(function (ch) {
        w += /[0-9€]/.test(ch) ? 0.556 : /[ ,.:;·|!]/.test(ch) ? 0.28 : /[A-ZÁÉÍÓÚÑ]/.test(ch) ? 0.68 : /[ilItfj()]/.test(ch) ? 0.27 : /[mwMW]/.test(ch) ? 0.8 : 0.52;
      });
      return w * s * (b ? 1.06 : 1);
    };
    var d = {
      ancho: ancho,
      rect: function (x, y, w, h, c) { cont += col(c) + ' rg ' + x + ' ' + y + ' ' + w + ' ' + h + ' re f\n'; },
      borde: function (x, y, w, h, c) { cont += col(c) + ' RG 0.8 w ' + x + ' ' + y + ' ' + w + ' ' + h + ' re S\n'; },
      linea: function (x1, y1, x2, y2, c, g) { cont += col(c) + ' RG ' + (g || 0.6) + ' w ' + x1 + ' ' + y1 + ' m ' + x2 + ' ' + y2 + ' l S\n'; },
      texto: function (t, x, y, s, o) {
        o = o || {};
        var xx = o.der ? x - ancho(t, s, o.b) : o.centro ? x - ancho(t, s, o.b) / 2 : x;
        cont += 'BT /' + (o.b ? 'F2' : 'F1') + ' ' + s + ' Tf ' + col(o.c || [0, 0, 0]) + ' rg ' + xx.toFixed(1) + ' ' + y + ' Td (' + cod(t) + ') Tj ET\n';
      },
      enlace: function (x, y, w, h, url) { enl.push({ x: x, y: y, w: w, h: h, url: url }); },
      imagen: function (im, x, y, w, h) { imgs.push(im); cont += 'q ' + w + ' 0 0 ' + h + ' ' + x + ' ' + y + ' cm /Im' + imgs.length + ' Do Q\n'; },
      blob: function () {
        var xo = imgs.map(function (_m, k) { return '/Im' + (k + 1) + ' ' + (7 + k) + ' 0 R'; }).join(' ');
        var objs = ['<< /Type /Catalog /Pages 2 0 R >>', '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
          '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595 842] /Contents 6 0 R /Resources << /Font << /F1 4 0 R /F2 5 0 R >>' + (xo ? ' /XObject << ' + xo + ' >>' : '') + ' >>' +
            (enl.length ? ' /Annots [' + enl.map(function (_e, k) { return (7 + imgs.length + k) + ' 0 R'; }).join(' ') + ']' : '') + ' >>',
          '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>',
          '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>',
          '<< /Length ' + cont.length + ' >>\nstream\n' + cont + 'endstream'];
        imgs.forEach(function (m) {
          objs.push('<< /Type /XObject /Subtype /Image /Width ' + m.w + ' /Height ' + m.h + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + m.bin.length + ' >>\nstream\n' + m.bin + '\nendstream');
        });
        enl.forEach(function (e) {
          objs.push('<< /Type /Annot /Subtype /Link /Rect [' + [e.x, e.y, e.x + e.w, e.y + e.h].join(' ') + '] /Border [0 0 0] /A << /S /URI /URI (' + cod(e.url) + ') >> >>');
        });
        var out = '%PDF-1.4\n', pos = [];
        objs.forEach(function (o, k) { pos.push(out.length); out += (k + 1) + ' 0 obj\n' + o + '\nendobj\n'; });
        var xr = out.length;
        out += 'xref\n0 ' + (objs.length + 1) + '\n0000000000 65535 f \n' + pos.map(function (q) { return ('0000000000' + q).slice(-10) + ' 00000 n \n'; }).join('') +
          'trailer\n<< /Size ' + (objs.length + 1) + ' /Root 1 0 R >>\nstartxref\n' + xr + '\n%%EOF';
        var b = new Uint8Array(out.length);
        for (var k = 0; k < out.length; k++) b[k] = out.charCodeAt(k) & 255;
        return new Blob([b], { type: 'application/pdf' });
      }
    };
    return d;
  }
  /* El presupuesto, maquetado: banda de marca, montaje del producto (si hay diseño puesto), tabla y totales. */
  function pdfPresupuesto(dt) {
    var VERDE = [31, 111, 15], GRIS = [96, 96, 96], CLARO = [243, 244, 247], LINEA = [210, 210, 214], NEG = [20, 20, 20];
    var p = pdfCrear(), L = 40, R = 555, y;
    p.rect(0, 770, 595, 72, VERDE);
    if (dt.banda) p.imagen(dt.banda, 0, 770, 595, 72);       // el logo de Imprimirlo ya compuesto sobre el verde
    else p.texto('IMPRIMIRLO', L, 805, 28, { b: 1, c: [255, 255, 255] });
    p.texto('Presupuesto', L, 779, 12, { c: [220, 236, 216] });
    p.texto(dt.fecha, R, 805, 13, { der: 1, b: 1, c: [255, 255, 255] });
    p.texto('imprimirlo.com', R, 784, 11, { der: 1, c: [220, 236, 216] });
    y = 742;
    var tit = []; (function (t) { var cur = ''; t.split(' ').forEach(function (w) { if ((cur + ' ' + w).length > 52 && cur) { tit.push(cur); cur = w; } else cur = cur ? cur + ' ' + w : w; }); if (cur) tit.push(cur); })(dt.titulo);
    tit.slice(0, 2).forEach(function (t) { p.texto(t, L, y, 17, { b: 1, c: NEG }); y -= 21; });
    if (dt.impresion) { p.texto(dt.impresion.slice(0, 95), L, y, 10.5, { c: GRIS }); y -= 15; }
    y -= 6;
    if (dt.imagenes.length) {                         // el montaje: hasta 2 vistas, una al lado de la otra
      var n = dt.imagenes.length, ancho = n === 1 ? 250 : (R - L - 14) / 2, alto = 0, x0 = L + (R - L - (n * ancho + (n - 1) * 14)) / 2;
      dt.imagenes.forEach(function (m) { alto = Math.max(alto, Math.min(215, ancho * m.h / m.w)); });
      dt.imagenes.forEach(function (m, k) {
        var h = Math.min(alto, ancho * m.h / m.w), w = h * m.w / m.h, x = x0 + k * (ancho + 14) + (ancho - w) / 2;
        p.rect(x0 + k * (ancho + 14), y - alto, ancho, alto, [250, 250, 251]); p.borde(x0 + k * (ancho + 14), y - alto, ancho, alto, LINEA);
        p.imagen(m, x, y - alto + (alto - h) / 2, w, h);
        if (m.nombre) p.texto(m.nombre, x0 + k * (ancho + 14) + 6, y - alto + 6, 9, { c: GRIS });
      });
      y -= alto + 22;
    }
    p.rect(L, y - 6, R - L, 22, CLARO);                // tabla
    p.texto('CONCEPTO', L + 8, y, 9.5, { b: 1, c: GRIS }); p.texto('UDS', 372, y, 9.5, { b: 1, c: GRIS, der: 1 });
    p.texto('PRECIO UD', 455, y, 9.5, { b: 1, c: GRIS, der: 1 }); p.texto('IMPORTE', R - 8, y, 9.5, { b: 1, c: GRIS, der: 1 });
    y -= 26;
    var desc = []; (function (t) { var cur = ''; t.split(' ').forEach(function (w) { if ((cur + ' ' + w).length > 46 && cur) { desc.push(cur); cur = w; } else cur = cur ? cur + ' ' + w : w; }); if (cur) desc.push(cur); })(dt.concepto);
    desc.slice(0, 3).forEach(function (t, k) { p.texto(t, L + 8, y - k * 14, 11, { c: NEG }); });
    p.texto(String(dt.uds), 372, y, 11, { der: 1, c: NEG }); p.texto(dt.precioUd, 455, y, 11, { der: 1, c: NEG }); p.texto(dt.total, R - 8, y, 11, { der: 1, b: 1, c: NEG });
    var nDesc = Math.max(1, Math.min(3, desc.length));
    if (dt.incluida) { p.texto(dt.incluida, L + 8, y - nDesc * 14, 10, { c: [31, 111, 15] }); nDesc++; }   // la impresión que va incluida no tiene línea de precio: se dice aquí
    y -= nDesc * 14 + 6;
    p.linea(L, y, R, y, LINEA); y -= 24;
    var fila = function (a, b, o) { o = o || {}; p.texto(a, 360, y, o.s || 11, { c: o.c || GRIS, b: o.b }); p.texto(b, R - 8, y, o.s || 11, { der: 1, c: o.c || NEG, b: o.b }); y -= (o.s || 11) + 9; };
    fila('Base imponible', dt.sin); fila('IVA (21 %)', dt.iva);
    y -= 6;
    p.rect(350, y - 9, R - 350, 30, VERDE);
    p.texto('TOTAL (IVA incl.)', 360, y + 2, 11, { b: 1, c: [255, 255, 255] }); p.texto(dt.total, R - 8, y + 1, 14, { der: 1, b: 1, c: [255, 255, 255] });
    y -= 26;
    p.texto('Precio por unidad con personalización (IVA incl.)', R - 8 - 70, y, 10, { der: 1, b: 1, c: NEG }); p.texto(dt.precioUd, R - 8, y - 1, 14, { der: 1, b: 1, c: VERDE });
    y -= 30;
    p.texto('Envío (Península): ' + dt.envio, L, y, 10.5, { c: GRIS }); y -= 16;
    if (dt.entrega) {                                  // el plazo, partido en líneas de ~88 caracteres para que no se salga de la hoja
      var lin = [], cur = ''; dt.entrega.split(' ').forEach(function (w) { if ((cur + ' ' + w).length > 88 && cur) { lin.push(cur); cur = w; } else cur = cur ? cur + ' ' + w : w; }); if (cur) lin.push(cur);
      lin.slice(0, 3).forEach(function (t) { p.texto(t, L, y, 10.5, { c: GRIS }); y -= 14; }); y -= 2;
    }
    y -= 14;
    if (dt.enlace) {                                   // botón para aceptar: lleva al presupuesto en la web (con el montaje) y de ahí al pago
      p.rect(L, y - 30, 300, 38, VERDE);
      p.texto('ACEPTAR PRESUPUESTO', L + 150, y - 17, 12, { b: 1, c: [255, 255, 255], centro: 1 });
      p.enlace(L, y - 30, 300, 38, dt.enlace);
      p.texto('Verás el montaje de tu diseño y podrás confirmar tu pedido. Enlace: ' + dt.enlace, L, y - 46, 8.5, { c: GRIS });
      y -= 70;
    }
    p.texto('Presupuesto con los precios de la web a fecha de hoy, que pueden cambiar.', L, y, 9.5, { c: GRIS }); y -= 13;
    p.texto(dt.enlace ? '¿Dudas? Escríbenos por WhatsApp: 934 35 82 57.' : 'Para pedirlo, añade el producto al carrito en imprimirlo.com o escríbenos por WhatsApp.', L, y, 9.5, { c: GRIS });
    p.rect(0, 0, 595, 54, CLARO);
    p.texto('Imprimirlo · Carrer d\'Altimira 1, Cerdanyola del Vallès', L, 30, 10, { b: 1, c: NEG });
    p.texto('imprimirlo.com · WhatsApp 934 35 82 57', L, 16, 10, { c: GRIS });
    return p.blob();
  }
  function jpegDe(canvas, maxLado) {                  // canvas -> {w, h, bin} (JPEG en cadena binaria) o null
    try {
      var c = canvas, k = Math.min(1, maxLado / Math.max(canvas.width, canvas.height));
      if (k < 1) { c = document.createElement('canvas'); c.width = Math.round(canvas.width * k); c.height = Math.round(canvas.height * k);
        var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height); x.drawImage(canvas, 0, 0, c.width, c.height); }
      return { w: c.width, h: c.height, bin: atob(c.toDataURL('image/jpeg', 0.85).split(',')[1]) };
    } catch (e) { return null; }
  }
  /* El logo de Imprimirlo (el de la cabecera de la tienda) compuesto sobre el verde de la banda del PDF, como JPEG (así no hace falta transparencia en el PDF). */
  function bandaConLogo() {
    return new Promise(function (ok) {
      var fin = false, listo = function (v) { if (!fin) { fin = true; ok(v); } };
      setTimeout(function () { listo(null); }, 3500);
      try {
        var img = new Image(), h = document.querySelector('img[src*="LOGO_IMPRIMIRLO"]');
        var src = '/cdn/shop/files/LOGO_IMPRIMIRLO.png?width=900';
        if (h && /^(https?:)?\/\/imprimirlo\.com|^\//.test(h.getAttribute('src') || '')) src = (h.getAttribute('src') || src).replace(/width=\d+/, 'width=900');
        img.onload = function () {
          try {
            var c = document.createElement('canvas'); c.width = 1190; c.height = 144;
            var x = c.getContext('2d'); x.fillStyle = 'rgb(31,111,15)'; x.fillRect(0, 0, c.width, c.height);
            var alto = 80, ancho = alto * img.naturalWidth / img.naturalHeight;
            x.drawImage(img, 80, 14, ancho, alto);
            listo({ w: c.width, h: c.height, bin: atob(c.toDataURL('image/jpeg', 0.9).split(',')[1]) });
          } catch (e) { listo(null); }
        };
        img.onerror = function () { listo(null); };
        img.src = src;
      } catch (e) { listo(null); }
    });
  }
  /* El enlace para aceptar y pagar (Xavi, 24/10: «el de Sulema te lleva de vuelta al carrito para pagar»): el mismo presupuesto del Worker que se
     manda por WhatsApp (pedido borrador con montaje y archivos). Si ya está creado y al día se reutiliza; si no, se crea (o se actualiza). Sin enlace
     (diseño incompleto o el Worker falla) el PDF sale igual, sin botón. */
  Ropa.prototype.enlacePresupuesto = async function () {
    try {
      if (this._presCod && this._presLanding && this._presFirma === this.firmaPedido()) return this._presLanding;
      if (!this.cfg.presupuestoUrl || !window.Presupuesto || this._presOcupado) return '';
      var listo = !!(this.resumen.unidades && !this.zonasSinArte().length && !this.sinResolver().length && !this.faltaDorsal());
      if (!listo) return '';
      this._presOcupado = true;
      var cr = null;
      try { cr = await this.alCarrito({ presupuesto: true, actualizar: !!this._presCod }); } catch (e) { cr = null; }
      this._presOcupado = false;
      if (cr && cr.landing) {
        var m = /\/p\/([a-z0-9]+)/.exec(cr.landing);
        this._presCod = m ? m[1] : this._presCod; this._presFirma = this.firmaPedido(); this._presLanding = cr.landing;
        this.pintarBotonesPresupuesto();
        return cr.landing;
      }
    } catch (e) { this._presOcupado = false; }
    return '';
  };
  Ropa.prototype.descargarPresupuesto = function () {
    var self = this, b = $(this.raiz, '[data-pres-pdf]'), antes = b ? b.textContent : '';
    if (this._pdfOcupado) return;
    this._pdfOcupado = true;
    if (b) { b.disabled = true; b.textContent = 'Preparando el PDF…'; }
    Promise.all([bandaConLogo(), this.enlacePresupuesto()]).then(function (r) { self._descargarPresupuesto(r[0], r[1]); })
      .catch(function () { /* sin PDF: el botón vuelve a estar disponible */ })
      .then(function () { self._pdfOcupado = false; if (b) { b.disabled = false; b.textContent = antes; } });
  };
  Ropa.prototype._descargarPresupuesto = function (banda, enlace) {
    var q = this._pres, ed = this._editorLibre;
    if (!q) return;
    var titulo = this.nombreProducto ? this.nombreProducto() : document.title;
    var cols = []; try { cols = this.coloresPedido() || []; } catch (e) { cols = []; }
    cols = cols.filter(function (c) { return c && c !== '—'; });
    var tz = ed && ed.tecnicasPorZona ? ed.tecnicasPorZona() : [];
    var imagenes = [];
    try { (this.fotosDiseño ? this.fotosDiseño() : []).slice(0, 2).forEach(function (f) { var m = jpegDe(f.c, 720); if (m) { m.nombre = f.nombre; imagenes.push(m); } }); } catch (e) { imagenes = []; }
    /* el plazo en días desde la aprobación del boceto (no una fecha): se pide al mismo cálculo que la ficha */
    var plazo = '';
    try {
      var cfgEl = this.raiz.querySelector('[data-ropa-config]'), cfgE = cfgEl && (JSON.parse(cfgEl.textContent) || {}).entrega;
      if (cfgE && window.Entrega && Entrega.textoDias) plazo = Entrega.textoDias(cfgE, !!this.urgente, q.uds * Math.max(1, (this.elegidas || []).length), q.uds);
    } catch (e) { plazo = ''; }
    /* la impresión incluida en el precio de la prenda (la zona que `recargos()` deja a 0 y sin variante), como en el carrito */
    var incluida = '';
    try {
      var self = this, zi = this.recargos().filter(function (x) { return !x.variante; }).map(function (x) { var z = self.zonaDe(x.zona); return ((z && z.nombre) || String(x.nombre || '').replace(/\s*\d.*$/, '')).toLowerCase(); }).filter(Boolean);
      if (this._tramos && zi.length) incluida = 'Impresión en ' + zi.join(' y ') + ': incluida en el precio de la prenda';
    } catch (eI) { incluida = ''; }
    var blob = pdfPresupuesto({
      banda: banda, fecha: new Date().toLocaleDateString('es-ES'), titulo: titulo,
      impresion: tz.length ? 'Impresión: ' + tz.map(function (t) { return (tz.length > 1 ? t.zona + ': ' : '') + t.nombre; }).join(' · ') : '',
      imagenes: imagenes,
      concepto: titulo + (cols.length ? ' · ' + cols.join(' + ') : ''), uds: q.uds,
      precioUd: money(Math.round(q.bruto / q.uds)), total: money(q.bruto), sin: money(q.sin), iva: money(q.iva),
      envio: q.gratis ? 'gratis' : money(ENVIO_PRECIO) + ' (gratis desde ' + money(ENVIO_GRATIS) + ')',
      entrega: plazo, enlace: enlace || '',
      incluida: incluida
    });
    var url = URL.createObjectURL(blob), a = document.createElement('a');
    a.href = url; a.download = 'presupuesto-imprimirlo.pdf'; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  };

  /* EL RESUMEN DEL PRECIO, en una tarjeta (Xavi: "¿esto no puede ser más
     visual?"): la prenda con su precio tachado y el rebajado, cada impresión
     igual, los dorsales, lo que sale por camiseta en grande, el total y una
     barra hacia el siguiente descuento. Solo en la ficha con tramos; sustituye
     a las tres líneas de texto de antes (cuenta, escalón y zonas). */
  Ropa.prototype.pintarResumen = function (uds, desc, res, prendas, bruto, sig) {
    var caja = $(this.raiz, '[data-resumen]');
    if (!caja) return;
    if (!this._tramos) { caja.hidden = true; return; }
    var self = this, uno = this.sust(1), muchas = this.sust(2);
    var n = uds || 1, d = uds ? desc : 0;
    // precio de la prenda: con cantidades, el de las líneas; sin ellas, la variante del color de la vista
    var base = uds ? Math.round(res.bruto / uds) : (function () {
      /* con precio por tramos (botellas, vaso…) y sin cantidades, el de UNA unidad de la técnica elegida: el transfer y la serigrafía no cuestan lo mismo */
      var sg = self.cfg.serigrafia, t0 = sg && sg.tramos && sg.tramos[0];
      if (t0 && t0.precio) return t0.precio;
      var cv = self.colorVista, vs = self.cfg.variantes || [];
      var v = vs.filter(function (x) { return x.color === cv && x.disponible; })[0] || vs.filter(function (x) { return x.color === cv; })[0] || vs[0];
      return v ? v.precio : 0;
    })();
    var baseNeto = Math.round(base * (1 - d / 100));
    var fila = function (nombre, sub, precioLista, precioNeto, total) {
      return '<div class="rop-res__f"><div class="rop-res__n">' + nombre + (sub ? '<span class="rop-res__s">' + sub + '</span>' : '') + '</div>' +
        '<div class="rop-res__p">' + (precioLista !== precioNeto ? '<s>' + money(precioLista) + '</s> ' : '') +
        '<b>' + money(precioNeto) + '</b>' + (uds ? '<span class="rop-res__t">' + money(total) + '</span>' : '') + '</div></div>';
    };
    var html = '<div class="rop-res__cab"><b>' + (uds ? uds + ' ' + (uds === 1 ? uno : muchas) : (this.masculino() ? 'Un ' : 'Una ') + uno) + '</b>' +
      (function () {
        /* el color que se compra es el de las unidades puestas, no el que se está mirando en el editor */
        var cp = self.coloresPedido(), cn = cp.length ? cp.join(' + ') : self.colorVista, ch = cp.length ? cp[0] : self.colorVista;
        return cn ? '<span class="rop-res__color"><i style="background:' + esc(self.hexDe(ch) || '#e9e9ee') + '"></i>' + esc(cn) + '</span>' : '';
      })() +
      '<span class="rop-res__s">' + (uds ? 'IVA incluido' : 'precio por unidad, IVA incluido') + '</span></div>';
    /* Sin información repetida (Xavi, 29/09): la línea de la prenda solo si
       hay algo más con precio (impresión, dorsales) o un descuento que
       enseñar; si no, "Por bidón" y "Total" ya lo dicen todo. El precio de
       la ficha de Shopify se esconde por CSS cuando esta tarjeta se ve. */
    var filaPrenda = fila(esc(uno.charAt(0).toUpperCase() + uno.slice(1)), '', base, baseNeto, uds ? prendas : baseNeto);
    var otras = '', conPrecio = 0;
    var impresionUd = 0;
    this.recargos().forEach(function (x) {
      var neto = Math.round(x.precio * (1 - d / 100));
      impresionUd += neto;
      var medida = x.ocupado && !x.ocupado.fondo ? fmt(x.ocupado.w, 1) + ' × ' + fmt(x.ocupado.h, 1) + ' cm' : 'fondo entero';
      if (x.precio) conPrecio++;
      otras += x.precio
        ? fila('Impresión ' + esc(sinMed(x.nombre).toLowerCase()), medida, x.precio, neto, Math.round(x.precio * n * (1 - d / 100)))
        : '<div class="rop-res__f"><div class="rop-res__n">Impresión ' + esc(sinMed(x.nombre).toLowerCase()) + '<span class="rop-res__s">' + medida + '</span></div><div class="rop-res__p"><b class="rop-res__inc">incluida</b></div></div>';
    });
    // serigrafía por tramos: los colores o zonas de más, con lo que suman (van dentro del precio de la línea del carrito)
    var exS = this.extras(uds);
    if (exS.zonas && exS.banda && exS.banda.serig) {
      conPrecio++;
      otras += fila(exS.zonas === 1 ? 'Color o zona extra' : exS.zonas + ' colores o zonas extra', '+' + money(exS.ud) + ' por prenda', exS.ud, exS.ud, exS.total);
      impresionUd += exS.ud;
    }
    var bd = this.dorBanda(), nd = this.dorValidos().length;
    if (bd && nd) { conPrecio++; otras += fila(nd + (nd === 1 ? ' dorsal' : ' dorsales'), 'nombre y número', bd.precio, bd.precio, bd.precio * nd); }
    if (conPrecio || base !== baseNeto) html += filaPrenda;
    html += otras;
    var porUd = uds ? bruto / uds : baseNeto + impresionUd;
    html += '<div class="rop-res__ud"><span>Por ' + esc(uno) + '</span><b>' + money(Math.round(porUd)) + '</b></div>';
    if (uds) html += '<div class="rop-res__total"><span>Total</span><b>' + money(bruto) + '</b></div>';
    /* la barra hacia el siguiente descuento: lo que llevas conseguido y cuánto falta */
    if (uds && (d || sig)) {
      var meta = sig ? sig[0] : uds, pct = Math.min(100, Math.round(uds / meta * 100));
      html += '<div class="rop-res__desc"><div class="rop-res__barra"><i style="width:' + pct + '%"></i></div>' +
        '<div class="rop-res__desc__t">' + (d ? '<b>' + Math.round(d) + ' % de descuento</b>' : 'Sin descuento aún') +
        (sig ? ' · ' + (sig[0] - uds) + ' más y <b>' + Math.round(sig[1]) + ' %</b>' : ' · el máximo') + '</div></div>';
    }
    if (this.cfg.serigrafia) {   // serigrafía por tramos: una línea (precio por unidad y qué pasa con más) en vez de la tarjeta, la barra y la franja
      var tsg = sig ? this.cfg.serigrafia.tramos.filter(function (t) { return t.min === sig[0]; })[0] : null;
      html = '<div class="rop-res__ud"><span>' + (uds ? uds + ' ' + (uds === 1 ? uno : muchas) + ' · ' : '') + 'IVA incluido</span><b>' + money(Math.round(porUd)) + ' / ' + esc(uno) + '</b></div>' +
        (uds && tsg ? '<p class="rop-res__s" style="margin:6px 0 0">Con <b>' + (sig[0] - uds) + ' más</b>: <b>' + money(this.precioSer(tsg, this.zonasSer())) + '</b> / ' + esc(uno) + '</p>' : '') +
        (exS.zonas && exS.banda && exS.banda.serig ? '<p class="rop-res__s" style="margin:6px 0 0">Incluye ' + (exS.zonas === 1 ? 'un color o zona extra' : exS.zonas + ' colores o zonas extra') + '.</p>' : '');
    }
    /* La escalera de precios (Xavi, 13/10): «más unidades, menos precio por unidad», siempre a la vista para empujar pedidos mayores.
       El descuento por cantidad baja la prenda y la impresión; los colores extra y los dorsales no lo llevan. */
    var escs = this._escalones();
    if (!this.cfg.serigrafia && escs.length) {
      var lista = escs.slice().sort(function (a, b) { return a[0] - b[0]; });
      var descontable = base + this.recargos().reduce(function (m, x) { return m + x.precio; }, 0);
      var fijo = (exS.zonas && exS.banda && exS.banda.serig ? exS.ud : 0) + ((bd && nd && uds) ? bd.precio * nd / uds : 0);
      var tramos = [[1, 0]].concat(lista), uEf = uds || (this.rep && this.rep.total) || 0;
      var filas = tramos.map(function (t, i) {
        var sigMin = tramos[i + 1] ? tramos[i + 1][0] : null;
        var rango = sigMin == null ? t[0] + ' o más' : (sigMin - 1 === t[0] ? String(t[0]) : t[0] + ' a ' + (sigMin - 1));
        var activo = uEf && uEf >= t[0] && (sigMin == null || uEf < sigMin);
        var ud = Math.round(descontable * (1 - t[1] / 100) + fijo);
        return '<div class="rop-esc__f' + (activo ? ' rop-esc__f--on' : '') + '" data-esc-min="' + t[0] + '"><span class="rop-esc__n">' + rango + ' ' + (t[0] === 1 && sigMin === 2 ? esc(uno) : 'uds') + '</span>' +
          '<span class="rop-esc__d">' + (t[1] ? '−' + (t[1] % 1 ? (Math.round(t[1] * 10) / 10).toString().replace('.', ',') : Math.round(t[1])) + ' %' : '') + '</span><b class="rop-esc__p">' + money(ud) + '</b></div>';
      }).join('');
      html += '<div class="rop-esc"><div class="rop-esc__t">DESCUENTOS POR CANTIDAD</div>' + filas + '</div>';
    }
    html += this.htmlStock(uds);
    this.cargarStock();
    if (uds) html += this.bloquePresupuesto(bruto, uds);
    caja.innerHTML = html;
    caja.hidden = false;
    if (!caja._pdfClick) {
      caja._pdfClick = true;
      caja.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-pres-pdf]')) self.descargarPresupuesto(); });
    }
    if (!caja._escClick) {   // tocar una fila de la escalera pone ese total
      caja._escClick = true;
      caja.addEventListener('click', function (e) {
        var f = e.target.closest && e.target.closest('[data-esc-min]');
        if (f && self.rep && self.rep.totalPrimero) self.rep.ponerTotal(parseInt(f.getAttribute('data-esc-min'), 10));
      });
    }
    /* La misma barra, gruesa y pegada abajo en la ventana de tallas del
       móvil (Xavi): mientras cambia cantidades ve cuánto le falta para el
       siguiente descuento sin bajar a la tarjeta. */
    var flot = $(this.raiz, '[data-desc-flotante]');
    /* el aviso de tallas por repartir viaja con la barra verde (Xavi, 14/10: «¿y si pones la barra verde y el texto rojo juntos?») */
    var faltaHtml = '';
    if (this.rep && this.rep.totalPrimero && this.rep.total) {
      var pend = this.rep.pendiente();
      faltaHtml = pend > 0 ? '<div class="rop-flot__falta">Faltan <b>' + pend + '</b> de <b>' + this.rep.total + '</b></div>'
                           : '<div class="rop-flot__falta is-ok">✓ Repartidas las <b>' + this.rep.total + '</b> ' + this.sust(this.rep.total) + '</div>';
    }
    if (flot) {
      if (this.cfg.serigrafia) flot.hidden = true;
      else if (uds && (d || sig)) {
        var meta2 = sig ? sig[0] : uds, pct2 = Math.min(100, Math.round(uds / meta2 * 100));
        // el texto va DENTRO de la barra (Xavi): descuento y lo que falta a la izquierda, el precio a la derecha
        /* Solo lo que falta para el siguiente descuento y a qué precio por unidad
           queda (Xavi, 29/09: "no pongas el %, pon el precio unidad"). El precio del
           siguiente tramo: lo descontable (prenda e impresiones) baja al nuevo %;
           los dorsales no llevan descuento. */
        var dorUd = (bd && nd) ? bd.precio * nd / uds : 0;
        var sigUd = sig ? Math.round(dorUd + (porUd - dorUd) * (1 - sig[1] / 100) / (1 - d / 100)) : Math.round(porUd);
        if (this.cfg.serigrafia && sig) {   // serigrafía por tramos: el precio del tramo siguiente, con las mismas pantallas
          var ts = this.cfg.serigrafia.tramos.filter(function (t) { return t.min === sig[0]; })[0];
          if (ts) sigUd = this.precioSer(ts, this.zonasSer());
        }
        var txt = '<span class="rop-flot__t">' + (sig
          ? '<b>' + (sig[0] - uds) + ' más</b> → <b>' + money(sigUd) + '</b> / ' + esc(uno)
          : 'Mejor precio · <b>' + money(sigUd) + '</b> / ' + esc(uno)) + '</span>';
        /* El mismo texto dos veces: en oscuro sobre la parte clara y, dentro
           del relleno verde (que lo recorta), en blanco (Xavi). */
        flot.innerHTML = faltaHtml + '<div class="rop-flot__b">' + txt +
          '<i style="width:' + pct2 + '%"><span class="rop-flot__in" style="width:' + (pct2 ? Math.round(10000 / pct2) : 100) + '%">' + txt + '</span></i></div>';
        flot.hidden = false;
      } else if (faltaHtml) { flot.innerHTML = faltaHtml; flot.hidden = false; }   // total elegido y aún sin tallas: solo el aviso
      else flot.hidden = true;
    }
    // las tres líneas de texto de antes se apartan: la tarjeta las sustituye
    ['[data-cuenta]', '[data-escalon]', '[data-zonas-precio]'].forEach(function (sel) { var e = $(self.raiz, sel); if (e) e.hidden = true; });
  };

  /* HASTA QUE NO DICE CUÁNTAS, NO SE PUEDE TOCAR NADA MÁS.
     Los pasos 2, 3 y 4 salen de la cantidad: las filas de dorsales son una por
     prenda, el precio de la zona extra depende de cuántas lleve y la urgencia
     tiene tope. Dejarlos tocar antes no adelanta nada y sí despista — Xavi marcó
     el dorsal sin cantidades, le salió la caja vacía y pensó que estaba roto.
     Se apagan, no se esconden: así se ve que están y en qué orden van. */
  Ropa.prototype.pintarBloqueo = function (uds) {
    var pasos = $$(this.raiz, '.rop-paso');
    pasos.forEach(function (p, i) {
      var fuera = i > 0 && !uds;
      p.classList.toggle('is-bloqueado', fuera);
      // inert quita también el teclado y el lector de pantalla; si el navegador
      // no lo conoce, la clase de arriba ya ha hecho lo suyo
      try { p.inert = fuera; } catch (e) { /* navegador viejo */ }
    });
    var urg = $(this.raiz, '[data-urgente]');
    if (urg) {
      urg.classList.toggle('is-bloqueado', !uds);
      try { urg.inert = !uds; } catch (e) { /* igual */ }
    }
  };

  /* La guía de tallas. Va en el paso 1, que es donde se decide, y no en una
     pestaña al final de la ficha que nadie abre.
     Se dibuja UNA vez con las tallas que el producto tiene a la venta; en cada
     repintado solo se marca la fila de las tallas que ha pedido, para que al
     abrirla vea de un vistazo lo que lleva en el carrito. */
  Ropa.prototype.pintarGuia = function () {
    var caja = $(this.raiz, '[data-guia]');
    if (!caja || !window.Colocacion) return;
    var tabla = Colocacion.tallasDe(this.cfg.modelo);
    var filas = (this.cfg.tallas || []).filter(function (t) { return tabla && tabla[t]; });
    if (!filas.length) { caja.hidden = true; return; }

    if (!caja.dataset.hecho) {
      caja.innerHTML = '<details class="rop-guia">' +
        '<summary class="rop-guia__b">Guía de tallas</summary>' +
        '<div class="rop-guia__c">' +
        '<p class="rop-muted">Medidas de la prenda en plano, en centímetros. ' +
        'La forma más fiable de acertar: coge una camiseta que te vaya bien, ' +
        'estírala en la mesa y mídela de costura a costura justo por debajo de ' +
        'las mangas. Ese número es el <b>ancho</b>.</p>' +
        '<table class="rop-tallas"><thead><tr><th>Talla</th><th>Ancho</th><th>Largo</th></tr></thead><tbody>' +
        filas.map(function (t) {
          var m = tabla[t];
          return '<tr data-talla-fila="' + esc(t) + '"><th>' + esc(t) + '</th>' +
            '<td>' + fmt(m[0], 0) + ' cm</td><td>' + fmt(m[1], 0) + ' cm</td></tr>';
        }).join('') +
        '</tbody></table>' +
        '<p class="rop-muted">Corte unisex. Si dudas entre dos, tira de la grande: ' +
        'la prenda encoge algo en el primer lavado.</p>' +
        '</div></details>';
      caja.dataset.hecho = '1';
    }
    caja.hidden = false;

    var pedidas = {};
    (this.resumen.lineas || []).forEach(function (l) { pedidas[l.talla] = true; });
    $$(caja, '[data-talla-fila]').forEach(function (tr) {
      tr.classList.toggle('is-puesta', !!pedidas[tr.dataset.tallaFila]);
    });
  };

  Ropa.prototype.pintarColores = function () {
    var r = this.raiz, self = this, caja = $(r, '[data-colores]');
    if (!caja) return;
    var elegidos = this.coloresElegidos();

    /* La vista arranca en el color MÁS COMPROMETIDO. Si el logo se va a perder
       en la negra, que lo vea antes de comprar, no al abrir la caja. */
    if (!this.colorFijado && (!this.colorVista || elegidos.indexOf(this.colorVista) === -1)) {
      var peor = elegidos[0] || null, peorR = -1;
      elegidos.forEach(function (c) {
        var x = 0;
        self.elegidas.forEach(function (id) {
          x = Math.max(x, self.riesgo(self.artePara(id, c), c));
        });
        if (x > peorR) { peorR = x; peor = c; }
      });
      this.colorVista = peor;
    }
    if (elegidos.length < 2) { caja.hidden = true; return; }

    caja.innerHTML = elegidos.map(function (c) {
      var hex = self.hexDe(c) || self.hexPorDefecto();
      var malo = self.elegidas.some(function (id) {
        return self.riesgo(self.artePara(id, c), c) >= CAMUFLAJE;
      });
      return '<button type="button" class="rop-color' + (c === self.colorVista ? ' is-puesta' : '') +
        '" data-color="' + esc(c) + '" title="Ver en ' + esc(c) + '">' +
        '<span class="rop-color__m" style="background:' + esc(hex) + '"></span>' +
        '<span class="rop-color__n">' + esc(c) + '</span>' +
        (malo ? '<span class="rop-color__x" aria-hidden="true">!</span>' : '') + '</button>';
    }).join('');
    caja.hidden = false;
  };

  /* Paso 2 · las zonas que admite la prenda, con el ÁREA de impresión dibujada.
     Sin archivo todavía: es un recuadro a trazos con su medida máxima, que es
     justo lo que hace falta para elegir. */
  Ropa.prototype.pintarZonas = function () {
    var r = this.raiz, self = this, caja = $(r, '[data-zonas-lista]');
    if (!caja || !window.Colocacion) return;
    if (!caja.dataset.hecho) {
      caja.innerHTML = this.catalogo.map(function (z) {
        return '<button type="button" class="rop-pos" data-zona-id="' + esc(z.id) + '" aria-pressed="false">' +
          '<canvas data-zona-lienzo="' + esc(z.id) + '"></canvas>' +
          '<span class="rop-pos__n">' + esc(z.nombre) + '</span>' +
          '<span class="rop-pos__m" data-zona-cm="' + esc(z.id) + '"></span>' +
          '<span class="rop-pos__e" data-zona-e="' + esc(z.id) + '"></span></button>';
      }).join('');
      caja.dataset.hecho = '1';
    }
    var banda = this.bandaZona(this.resumen.unidades);
    var hex = this.hexDe(this.colorVista) || this.hexPorDefecto();
    this.catalogo.forEach(function (z) {
      var orden = self.elegidas.indexOf(z.id);
      var b = caja.querySelector('[data-zona-id="' + z.id + '"]');
      if (b) {
        b.classList.toggle('is-puesta', orden >= 0);
        b.setAttribute('aria-pressed', orden >= 0 ? 'true' : 'false');
      }
      var et = caja.querySelector('[data-zona-e="' + z.id + '"]');
      if (et) {
        /* Lo que cuesta ESTA zona: lo que se cobra por ser la segunda, más su
           recargo propio si lo tiene. La panorámica de la taza cuesta 2 €
           aunque sea la primera, así que no vale con mirar el orden.
           El dorsal va por su cuenta: se cobra por dorsal escrito, no por
           prenda, y baja según cuántos lleve el pedido. */
        if (self.esDorsal(z.id)) {
          var bd = self.dorBanda() || Dorsales.banda(self.cfgDor(), 1);
          et.textContent = orden < 0 ? ''
            : bd ? '+ ' + fmt(bd.precio / 100, 2) + ' € por dorsal' : '';
        } else {
          var pos = self.zonasPago().indexOf(z.id);
          var rec = (self.cfg.recargos || {})[z.id];
          var mas = (pos > 0 && banda ? banda.precio : 0) + (rec ? rec.precio : 0);
          et.textContent = orden < 0 ? ''
            : mas ? '+ ' + fmt(mas / 100, 2) + ' € por ' + self.sust(1)
            : 'incluida';
        }
      }
      var lienzo = caja.querySelector('[data-zona-lienzo="' + z.id + '"]');
      if (!lienzo) return;
      var medida = caja.querySelector('[data-zona-cm="' + z.id + '"]');
      /* En una zona libre el diseño vive en el lienzo grande de arriba, no
         aquí: dibujar esta miniatura además de esa (y encima desactualizada,
         porque no lee el estado del editor) era enseñar dos tazas que no
         se correspondían entre sí. Aquí solo se elige la zona. */
      if (z.libre) {
        lienzo.hidden = true;
        var cmL = Colocacion.area(z);
        if (medida) medida.textContent = 'hasta ' + fmt(cmL[0], 1) + ' × ' + fmt(cmL[1], 1) + ' cm';
        return;
      }
      /* Si ya hay archivo para esa zona se enseña el logo puesto; si no, el
         área. Así el paso 2 se va llenando a medida que sube archivos. */
      var d = self.artePara(z.id, self.colorVista);
      var res = Colocacion.dibujar(lienzo, self.prenda, z, {
        ancho: 120, color: hex, area: !d, arte: d && d.thumb, px: d && d.px
      });
      if (medida) {
        medida.textContent = res
          ? (res.area ? 'hasta ' : '') + fmt(res.cm[0], 1) + ' × ' + fmt(res.cm[1], 1) + ' cm'
          : '';
      }
    });
  };

  /* Paso 3 · una caja por zona elegida, con su archivo. */
  Ropa.prototype.pintarArtes = function () {
    var r = this.raiz, self = this, caja = $(r, '[data-artes]');
    if (!caja) return;
    // mientras se teclean los dorsales solo se refresca el pie, no la tabla
    if (this._quieto && caja.dataset.pintada) return this.pintarDorPie();
    var disponibles = this.archivos();
    var color = this.colorVista;
    var pago = this.zonasPago();

    caja.innerHTML = this.elegidas.map(function (id) {
      var z = self.zonaDe(id);
      if (!z) return '';
      if (self._tramos && self.esDorsal(id)) return ''; // con editor va en su caja (pintarDorLibre)
      var propio = color ? self.arteColor[id + '·' + color] : null;
      var d = propio || self.arte[id];
      var cab = '<p class="rop-art__t">' + esc(z.nombre) +
        (pago.length > 1 && pago[0] === id ? ' <span class="rop-art__inc">incluida</span>' : '') +
        '</p>';

      /* EDITOR LIBRE: el diseño se hace en el lienzo grande de arriba (donde
         antes iba la foto del producto), no aquí. Esta caja solo recuerda
         que esa zona ya no pide archivo. */
      if (z.libre) {
        return '<div class="rop-art" data-caja="' + esc(id) + '">' + cab +
          '<p class="rop-muted">El diseño se hace en la foto grande de arriba.</p></div>';
      }

      /* EL DORSAL NO PIDE UN ARCHIVO, pide una lista de nombres. Su caja es la
         tabla que monta dorsales.js, con una fila por prenda. */
      if (self.esDorsal(id) && window.Dorsales) return self.htmlDorsal(id, cab);

      /* Si se está escribiendo un texto para esta zona, la caja ES el
         formulario: no tiene sentido enseñar a la vez el sitio para soltar un
         archivo y el sitio para escribir. */
      if (self.form && self.form.zona === id) {
        return '<div class="rop-art is-escribiendo" data-caja="' + esc(id) + '">' +
          cab + self.htmlTexto(z) + '</div>';
      }

      if (!d) {
        // reutilizar un archivo que ya está en la ficha: un clic y ya
        var chips = disponibles.map(function (x, i) {
          return '<button type="button" class="rop-mismo" data-mismo="' + i +
            '" data-mismo-zona="' + esc(id) + '">' +
            '<span class="rop-mismo__th" data-th="' + i + '"></span>' +
            '<span>' + esc(etiqueta(x)) + '</span></button>';
        }).join('');
        return '<div class="rop-art" data-caja="' + esc(id) + '">' + cab +
          (chips ? '<div class="rop-mismos"><span class="rop-muted">Usar el mismo:</span>' + chips + '</div>' : '') +
          '<div class="rop-drop" data-pide="' + esc(id) + '" tabindex="0" role="button">' +
          '<span class="rop-drop__i" aria-hidden="true">+</span>' +
          '<span class="rop-drop__t">Sube el logo de ' + esc(z.nombre.toLowerCase()) + '</span>' +
          '<span class="rop-muted">PNG con fondo transparente es lo ideal, pero vale cualquier cosa: ya lo dejamos bien nosotros.</span>' +
          '</div>' +
          /* Uno o dos pedidos de cada diez no traen logo, traen una frase. Va
             como segunda opción y no como pestaña: el logo sigue siendo lo
             normal, pero el que viene a poner un texto tiene que ENCONTRARLO.
             Empezó siendo un enlace pequeño debajo y no se veía. */
          (window.Texto ? '<p class="rop-o">o</p>' +
            '<button type="button" class="rop-otra" data-texto="' + esc(id) + '">' +
            '<span class="rop-otra__i" aria-hidden="true">T</span>' +
            'Escribe un texto</button>' : '') +
          '</div>';
      }

      var m = (d.px && window.Colocacion) ? Colocacion.medida(z, d.px) : null;
      return '<div class="rop-art is-llena" data-caja="' + esc(id) + '">' + cab +
        '<div class="rop-art__fila">' +
        '<div class="rop-art__th" data-th-zona="' + esc(id) + '"></div>' +
        /* En un texto el nombre del fichero no le dice nada a nadie: lo que
           quiere comprobar es lo que ha escrito. */
        '<div class="rop-art__d"><p class="rop-art__n">' + esc(etiqueta(d)) + '</p>' +
        (m ? '<p class="rop-muted">Se imprime a ' + fmt(m[0], 1) + ' × ' + fmt(m[1], 1) + ' cm</p>' : '') +
        (d.texto ? '<button type="button" class="rop-fix rop-fix--gris" data-texto="' + esc(id) + '"' +
          (propio ? ' data-texto-color="' + esc(color) + '"' : '') + '>Cambiar el texto</button>' : '') +
        '</div>' +
        '<button type="button" class="rop-archivo__x" data-quita="' + esc(id) + '"' +
        (propio ? ' data-quita-color="' + esc(color) + '"' : '') +
        ' aria-label="Quitar este logo">×</button></div>' +
        '<div class="rop-arreglos" data-arreglos="' + esc(id) + '"></div>' +
        '<div class="rop-aviso" data-camu="' + esc(id) + '" hidden role="alert"></div>' +
        '</div>';
    }).join('');

    // miniaturas: son canvas, hay que meterlos a mano
    $$(caja, '[data-th-zona]').forEach(function (el) {
      var d = self.artePara(el.dataset.thZona, color);
      if (d && d.thumb) el.appendChild(d.thumb.cloneNode ? clonarLienzo(d.thumb) : d.thumb);
      else if (d) el.textContent = (d.name.split('.').pop() || '?').toUpperCase();
    });
    $$(caja, '[data-th]').forEach(function (el) {
      var d = disponibles[Number(el.dataset.th)];
      if (d && d.thumb) el.appendChild(clonarLienzo(d.thumb));
    });

    this.elegidas.forEach(function (id) {
      if (self.esDorsal(id)) return;
      self.pintarArreglos(id); self.pintarCamuflaje(id);
    });
    // la previa del texto se dibuja después de existir la caja, como las miniaturas
    if (this.form) this.refrescarTexto();
    this.pintarDorPie();
    caja.dataset.pintada = '1';
    this.pintarDorLibre();
  };

  /* La tabla de dorsales de la ficha con editor (Xavi: "con un botón de
     añadir nuevo añade otra línea y ya defines talla, nombre y número"):
     la misma tabla de dorsales.js, pero cada fila lleva un desplegable de
     talla en vez del rótulo, una cruz para quitarla, y debajo "+ Añadir
     camiseta". Una fila ES una camiseta: cambiar la talla o quitar la fila
     mueve la cantidad en la tabla de tallas. */
  Ropa.prototype.htmlDorsalLibre = function () {
    var self = this, html = this.htmlDorsal(Dorsales.ZONA, '');
    var tallas = this.cfg.tallas || [], color = this.dorColorLibre();
    if (!this.rep || !this.rep.sumar || !tallas.length) {
      // sin tallas (taza, cojín…) la ventana ya dice que falta la cantidad: sobra el aviso de la tabla
      return html.replace(/<p class="rop-escalon">[\s\S]*?<\/p>/, '');
    }
    // el aviso "sube al paso 1" de la tabla sobra aquí: la ventana ya lo dice con su botón de tallas
    html = html.replace(/<p class="rop-escalon">[\s\S]*?<\/p>/, '');
    var partes = html.split('<div class="dor-fila">');
    html = partes.map(function (trozo, i) {
      if (!i) return trozo;
      var m = /data-dor-nombre="([^"]+)"/.exec(trozo);
      var clave = m ? m[1] : '', talla = clave.split('|')[1] || '';
      var sel = '<select class="dor-fila__t dor-fila__sel" data-dor-talla="' + esc(clave) + '" aria-label="Talla">' +
        tallas.map(function (t) {
          var v = (self.cfg.variantes || []).filter(function (x) { return x.color === color && x.talla === t; })[0];
          return '<option value="' + esc(t) + '"' + (t === talla ? ' selected' : '') + ((v && !v.disponible) ? ' disabled' : '') + '>' + esc(t) + '</option>';
        }).join('') + '</select>';
      trozo = trozo.replace(/<span class="dor-fila__t"[^>]*>(?:<span[^>]*><\/span>)?[^<]*<\/span>/, sel);
      trozo = trozo.replace('</div>', '<button type="button" class="dor-fila__q" data-dor-quitar="' + esc(clave) + '" aria-label="Quitar esta ' + esc(self.sust(1)) + '">×</button></div>');
      return '<div class="dor-fila dor-fila--libre">' + trozo;
    }).join('');
    return html + '<p class="rop-dor-anadir"><button type="button" class="rop-fix" data-dor-anadir>+ Añadir ' + esc(this.sust(1)) + '</button></p>';
  };
  Ropa.prototype.dorColorLibre = function () { return this.colorVista || (this.cfg.colores || [])[0] || ''; };
  // la talla con la que nace una fila nueva: la de la última fila, o la primera que haya
  Ropa.prototype.dorTallaNueva = function () {
    var fs = this.dorFilas(), tallas = this.cfg.tallas || [], color = this.dorColorLibre(), self = this;
    if (fs.length) return fs[fs.length - 1].talla;
    return tallas.filter(function (t) {
      var v = (self.cfg.variantes || []).filter(function (x) { return x.color === color && x.talla === t; })[0];
      return !v || v.disponible;
    })[0] || tallas[0];
  };
  /* Cambiar la talla de una fila: lo escrito se lleva a la fila nueva. Se
     baja la cantidad de la talla vieja y se sube la de la nueva. */
  Ropa.prototype.dorCambiarTalla = function (clave, nueva) {
    var d = this.dorsales[clave], partes = clave.split('|'), color = partes[0], vieja = partes[1];
    if (vieja === nueva) return;
    delete this.dorsales[clave];
    this.rep.sumar(color, vieja, -1);
    this.rep.sumar(color, nueva, 1);
    if (d && (d.nombre || d.numero)) {
      var k = color + '|' + nueva + '|' + (this.rep.cantidad(color, nueva) - 1);
      this.dorsales[k] = d;
      this.actualizar();
    }
  };

  /* La caja del dorsal: la tabla que monta dorsales.js, con una fila por prenda.
     Las tipografías se piden AQUÍ, la primera vez que alguien abre la tabla, y
     no al entrar en la ficha: la mayoría de los pedidos no llevan dorsal y no
     tienen por qué pagar la descarga. Al llegar se repinta, porque hasta
     entonces se ha medido con la de repuesto y la medida es justo lo que el
     cliente está decidiendo. */
  Ropa.prototype.htmlDorsal = function (id, cab) {
    var self = this;
    if (!this._dorPide) {
      this._dorPide = true;
      Dorsales.cargar().then(function () { self._dorCache = null; self.actualizar(); });
      /* Y otra vez cuando el navegador dé por cargadas las tipografías: en el
         móvil llegan tarde y las muestras "23" salían todas iguales (Xavi). */
      if (document.fonts && document.fonts.addEventListener) {
        document.fonts.addEventListener('loadingdone', function () { self._dorCache = null; self.actualizar(); });
      }
    }
    return '<div class="rop-art rop-art--dor" data-caja="' + esc(id) + '">' + (cab || '') +
      Dorsales.html(this.dorFilas(), this.dorsales, this.dorTinta, this.cfgDor(),
        this.dorFuente, this.cfg.coloresHex) +
      '<div class="rop-aviso" data-dor-aviso hidden role="alert"></div></div>';
  };

  /* Con editor (camiseta): el dorsal se ofrece en su propia caja del paso 1,
     con una casilla para activarlo; activado, sale la tabla. Mientras se
     teclea no se repinta (la tabla perdería el cursor). */
  Ropa.prototype.pintarDorLibre = function () {
    var caja = $(this.raiz, '[data-dor-libre]');
    if (!caja || !window.Dorsales) return;
    if (this._quieto && caja.dataset.pintada) return;
    if (!this.hayDorsal()) { caja.hidden = true; caja.innerHTML = ''; delete caja.dataset.pintada; return; }
    caja.hidden = false;
    var sinUds = !(this.resumen && this.resumen.unidades);
    caja.innerHTML = '<p class="rop-dor-libre__act"><b>Nombres y números</b> <span class="rop-muted">(cada ' + esc(this.sust(1)) + ' lleva el suyo, en el dorsal que has colocado)</span></p>' +
      (sinUds
        ? '<p class="rop-muted rop-dor-libre__sin">Un nombre por ' + this.sust(1) + ': primero di cuántas quieres' +
          ((this.cfg.tallas || []).length
            ? ' y de qué tallas. <button type="button" class="rop-fix" data-libre-ir-tallas>Elegir tallas</button>'
            : '.') + '</p>'
        : '') +
      this.htmlDorsalLibre();
    caja.dataset.pintada = '1';
  };

  /* El pie de la tabla de dorsales: cuántos llevas, a cuánto sale cada uno y qué
     te falta para el siguiente tramo. Va aparte del resto de la caja porque se
     refresca mientras el cliente escribe. */
  Ropa.prototype.pintarDorPie = function () {
    if (!window.Dorsales) return;
    var pie = $(this.raiz, '[data-dor-pie]'), puestos = this.dorValidos();
    if (pie) pie.innerHTML = Dorsales.pie(this.cfgDor(), puestos.length, puestos, this.dorFuente);
    var av = $(this.raiz, '[data-dor-aviso]');
    if (av) {
      var malos = this.dorInvisible();
      av.hidden = !malos;
      if (malos) {
        av.innerHTML = 'La letra en <b>' + esc(Dorsales.tintaDe(this.dorTinta).nombre.toLowerCase()) +
          '</b> no se vería sobre ' + esc(lista(malos).toLowerCase()) +
          '. Déjalo en «el que contraste» y cada prenda lleva el suyo.';
      }
    }
  };

  // el thumb es un canvas y solo puede estar en un sitio; para las fichas se copia
  function clonarLienzo(c) {
    var n = document.createElement('canvas');
    n.width = c.width; n.height = c.height;
    n.style.width = c.style.width; n.style.height = c.style.height;
    n.getContext('2d').drawImage(c, 0, 0);
    return n;
  }

  /* ---------- el texto ----------
   *
   * Un texto no es una rama nueva del configurador: es otra forma de fabricar
   * un ARTE. Cuando se pulsa "Poner el texto", texto.js lo dibuja a 300 ppp con
   * la medida de la zona y devuelve un dato idéntico al de un archivo subido.
   * De ahí para adelante, todo lo que ya estaba probado —la vista, el mockup,
   * el aviso de camuflaje, el carrito— funciona sin enterarse. */
  Ropa.prototype.cfgT = function () { return this.cfg.texto || {}; };
  Ropa.prototype.fuentes = function () {
    var f = this.cfgT().fuentes;
    return (f && f.length) ? f : (window.Texto ? Texto.FUENTES : []);
  };

  Ropa.prototype.htmlTexto = function (z) {
    var f = this.form, area = window.Colocacion ? Colocacion.area(z) : [0, 0];
    var tope = this.cfgT().maxLineas || 3;
    var chips = this.fuentes().map(function (x) {
      return '<button type="button" class="rop-fuente' + (x.id === f.fuente ? ' is-puesta' : '') +
        '" data-texto-fuente="' + esc(x.id) + '" style="font:' +
        esc((x.peso || '400') + ' 15px ' + x.css) + '">' + esc(x.nombre) + '</button>';
    }).join('');
    return '<div class="rop-texto">' +
      '<textarea class="rop-texto__c" data-texto-campo rows="' + tope + '" ' +
      'placeholder="Ej.: PEÑA EL BARRIL">' + esc(f.texto) + '</textarea>' +
      '<p class="rop-muted">Un renglón por línea, hasta ' + tope + '. Lo hacemos tan grande ' +
      'como quepa en la zona, que aquí son ' + fmt(area[0], 1) + ' × ' + fmt(area[1], 1) + ' cm.</p>' +
      '<div class="rop-texto__fs">' + chips + '</div>' +
      '<div class="rop-texto__t"><span class="rop-muted">Color de la tinta</span>' +
      '<button type="button" class="rop-tinta" data-texto-tinta="#ffffff" ' +
      'style="background:#fff;color:#111">Blanco</button>' +
      '<button type="button" class="rop-tinta" data-texto-tinta="#000000" ' +
      'style="background:#111;color:#fff">Negro</button>' +
      '<label class="rop-tinta rop-tinta--otro">Otro' +
      '<input type="color" data-texto-color value="' + esc(f.tinta) + '"></label></div>' +
      '<div class="rop-texto__p"><canvas data-texto-previa></canvas>' +
      '<span class="rop-muted" data-texto-cm></span></div>' +
      '<div class="rop-fix__b">' +
      '<button type="button" class="rop-fix" data-texto-ok>Poner el texto</button>' +
      '<button type="button" class="rop-fix rop-fix--gris" data-texto-no>Cancelar</button>' +
      '</div></div>';
  };

  /* Refresca la previa SIN repintar la caja. Es la diferencia entre poder
     escribir y perder el cursor a cada letra. */
  Ropa.prototype.refrescarTexto = function () {
    var f = this.form;
    if (!f || !window.Texto || !window.Colocacion) return;
    var caja = $(this.raiz, '[data-caja="' + f.zona + '"]');
    var z = this.zonaDe(f.zona);
    if (!caja || !z) return;
    var campo = $(caja, '[data-texto-campo]');
    if (campo) f.texto = campo.value;
    $$(caja, '[data-texto-fuente]').forEach(function (b) {
      b.classList.toggle('is-puesta', b.dataset.textoFuente === f.fuente);
    });
    $$(caja, '[data-texto-tinta]').forEach(function (b) {
      b.classList.toggle('is-puesta',
        b.dataset.textoTinta.toLowerCase() === String(f.tinta).toLowerCase());
    });
    var pick = $(caja, '[data-texto-color]');
    if (pick && pick.value.toLowerCase() !== String(f.tinta).toLowerCase()) pick.value = f.tinta;

    var lienzo = $(caja, '[data-texto-previa]'), ok = $(caja, '[data-texto-ok]');
    var med = $(caja, '[data-texto-cm]');
    var r = Texto.pinta(f.texto, {
      fuente: f.fuente, fuentes: this.fuentes(), color: f.tinta,
      cajaCm: Colocacion.area(z), maxLineas: this.cfgT().maxLineas, ppp: this.cfgT().ppp
    });
    if (ok) ok.disabled = !r;
    if (!lienzo) return;
    if (!r) {
      lienzo.getContext('2d').clearRect(0, 0, lienzo.width, lienzo.height);
      if (med) med.textContent = '';
      return;
    }
    /* La previa es la prenda entera, no el texto suelto: lo que hay que decidir
       es si se lee y si el tamaño es el que quiere, y eso solo se ve encima de
       la camiseta. */
    var hex = this.hexDe(f.colorPrenda || this.colorVista) || this.hexPorDefecto();
    var res = Colocacion.dibujar(lienzo, this.prenda, z, {
      ancho: 170, color: hex, arte: r.lienzo, px: [r.lienzo.width, r.lienzo.height]
    });
    if (med && res) med.textContent = fmt(res.cm[0], 1) + ' × ' + fmt(res.cm[1], 1) + ' cm';
  };

  Ropa.prototype.abrirTexto = function (zonaId, colorPrenda) {
    if (!window.Texto) return;
    var propio = colorPrenda ? this.arteColor[zonaId + '·' + colorPrenda] : null;
    var base = propio || this.arte[zonaId];
    var t = base && base.texto;
    // la tinta del texto contrasta con lo que hay DEBAJO: en la taza, el blanco
    var hex = this.hexImpresion(colorPrenda || this.colorVista);
    var oscura = hex && window.Colocacion && Colocacion.luz(hex) < 0.5;
    this.form = {
      zona: zonaId, colorPrenda: colorPrenda || null,
      texto: t ? t.texto : '',
      fuente: t ? t.fuente : ((this.fuentes()[0] || {}).id || 'gruesa'),
      /* Si se abre para un color concreto que aún no tenía su propio texto, la
         tinta arranca CONTRARIA a la prenda: se abre justo porque el texto no
         se veía sobre ese color, así que proponer el mismo negro otra vez sería
         hacerle el viaje en balde. */
      tinta: (t && (propio || !colorPrenda)) ? t.color : (oscura ? '#ffffff' : '#000000')
    };
    this.actualizar();
    var campo = $(this.raiz, '[data-caja="' + zonaId + '"] [data-texto-campo]');
    if (campo) { campo.focus(); campo.selectionStart = campo.selectionEnd = campo.value.length; }
    /* Las tipografías se descargan AQUÍ, la primera vez que alguien abre el
       formulario, y no al cargar la ficha: nueve de cada diez suben un logo y no
       tienen por qué pagar esa descarga. Cuando llegan, se repinta la previa
       para que se vea con la letra de verdad. */
    var self = this;
    Texto.cargar(this.fuentes()).then(function () { self.refrescarTexto(); });
  };

  Ropa.prototype.ponerTexto = async function () {
    var f = this.form;
    if (!f || !window.Texto || this.ocupado) return;
    var z = this.zonaDe(f.zona);
    if (!z) return;
    if (!Texto.lineas(f.texto, this.cfgT().maxLineas).length) {
      return this.flash('Escribe lo que quieres imprimir.');
    }
    // "rotulo" y no "etiqueta": etiqueta() es la función de arriba y taparla aquí
    // dentro es de las cosas que se pagan tres meses después
    var btn = $(this.raiz, '[data-caja="' + f.zona + '"] [data-texto-ok]');
    var rotulo = btn ? btn.textContent : '';
    this.ocupado = true;
    if (window.Cargando && btn) { Cargando.ocupar(btn, 'Montando el texto…'); await Cargando.pinta(); }
    var d = null;
    try {
      d = await Texto.dato(f.texto, {
        fuente: f.fuente, fuentes: this.fuentes(), color: f.tinta,
        cajaCm: Colocacion.area(z), maxLineas: this.cfgT().maxLineas, ppp: this.cfgT().ppp
      });
    } catch (e) { d = null; }
    this.ocupado = false;
    if (window.Cargando && btn) Cargando.libre(btn, rotulo);
    if (!d) return this.flash('No hemos podido montar el texto. Prueba con menos letras o menos líneas.');
    d._id = 'a' + (++seq);
    var viejo = f.colorPrenda ? this.arteColor[f.zona + '·' + f.colorPrenda] : this.arte[f.zona];
    this.form = null;
    /* Si ese mismo texto estaba puesto en varias zonas, se cambia en todas: es
       el mismo criterio que con los arreglos de un logo. */
    if (viejo && viejo.texto) this.sustituir(viejo, d);
    this.poner(d, f.zona, f.colorPrenda);
  };

  Ropa.prototype.pintarArreglos = function (zonaId) {
    var caja = $(this.raiz, '[data-arreglos="' + zonaId + '"]');
    if (!caja) return;
    var d = this.artePara(zonaId, this.colorVista), z = this.zonaDe(zonaId);
    if (!d || !d.px || !z || !window.Archivo || !window.ImgArreglo) { caja.hidden = true; return; }
    var anchoCm = Colocacion.medida(z, d.px)[0];
    /* «Afinar los bordes» mejora el archivo que se imprime, pero en esta
       vista previa (el dibujo de la prenda, siempre pequeño) no se nota
       nada: Xavi, 28/09, «en el previo no sirve de nada». Se quita de
       aquí; sigue ofreciéndose donde sí hay una vista grande del archivo
       (tarjetas, subida DTF, pack de empresa). */
    var sug = Archivo.sugerencias(d, anchoCm, 250).filter(function (s) { return s !== 'bordes'; });
    var btns = sug.map(function (s) {
      return '<button type="button" class="rop-fix" data-fix="' + s + '" data-fix-zona="' + esc(zonaId) + '">' +
        Archivo.boton(s) + '</button>';
    });
    if (d.anterior) {
      btns.push('<button type="button" class="rop-fix rop-fix--gris" data-fix="deshacer" data-fix-zona="' +
        esc(zonaId) + '">Deshacer</button>');
    }
    var nota = '';
    if (d.mockup && !(d.arreglos || []).length) {
      nota = '<b>Parece una foto de la prenda con el diseño puesto.</b> Así se imprimiría la foto ' +
        'entera, con la tela y el fondo. Necesitamos solo el dibujo. Si lo has hecho con ChatGPT, ' +
        'pídele: «dame solo el diseño, sin la camiseta, en PNG con fondo transparente», y súbelo aquí.';
    } else if (sug.indexOf('negro') !== -1) {
      /* Se explica en lo que el cliente ve y toca, no en jerga de imprenta. */
      /* PRIMERO EL RESULTADO, LUEGO EL MOTIVO. Esto empezaba explicando la
         mecánica —«ese negro pasa a ser la tela»— y quien lo leía no sabía qué
         iba a recibir. Ahora arranca por lo que va a ver en la camiseta. */
      /* 26/09: el semitono se vende como ventaja, sin técnica (Xavi). */
      nota = '<b>El semitono es solo si va sobre prenda negra</b> (u oscura): tu logo queda más ligero, más suave al tacto, ' +
        'transpira mejor y no hace parche. En prenda clara no lo uses: ' +
        'lo negro quedaría del color de la prenda.';
    } else if (d.transparente === false && sug.indexOf('fondo') !== -1) {
      nota = 'Tu logo tiene fondo. Si lo quitas ahora lo ves antes de comprar; si no, lo recortamos nosotros.';
    } else if ((d.arreglos || []).slice(-1)[0] === 'negro') {
      nota = '<b>Listo, con semitono.</b> Más ligero, más suave y transpira mejor. ' +
        'Aquí abajo ves cómo queda de cerca. Si no te convence, deshazlo.';
    } else if ((d.arreglos || []).length) {
      nota = '<b>Listo.</b> Si no te convence, deshaz el cambio.';
    }
    caja.innerHTML = (nota ? '<p class="rop-fix__t">' + nota + '</p>' : '') +
      (btns.length ? '<div class="rop-fix__b">' + btns.join('') + '</div>' : '');
    /* LA VISTA DEL SEMITONO: «Tal cual / Con semitono», a escala de lo que
       mide en esta zona y sobre el color de la prenda que está mirando. Si la
       zona mide otra cosa (el mismo logo en otra zona), se rehace. */
    var cv = d.comparativa;
    if (cv && cv.semitono && window.ImgArreglo && ImgArreglo.vistaSemitono) {
      var mmZ = anchoCm * 10;
      if (Math.abs(mmZ - cv.mm) > 0.5) {
        try { cv = ImgArreglo.vistaSemitono(cv.origen, cv.resultado, mmZ, cv.w, cv.h, cv.tramaMm); } catch (e) { cv = null; }
      }
      if (cv) {
        var fig = document.createElement('div');
        fig.className = 'rop-compara';
        fig.innerHTML = '<figure><figcaption>Tal cual</figcaption><div class="rop-compara__img" data-a></div></figure>' +
          '<figure><figcaption>Con semitono</figcaption><div class="rop-compara__img" data-b></div></figure>' +
          '<p class="rop-compara__nota">Así se verá de cerca sobre la prenda.</p>';
        fig.querySelector('[data-a]').appendChild(clonarLienzo(cv.antes));
        var bb = fig.querySelector('[data-b]');
        bb.style.background = this.hexDe(this.colorVista) || '#111';
        bb.appendChild(clonarLienzo(cv.despues));
        caja.appendChild(fig);
      }
    }
    caja.hidden = !(nota || btns.length);
  };

  /* El DTF lleva blanco de base, así que un logo de colores sobre prenda oscura
     sale bien. Esto solo salta cuando la tinta del logo ES del color de la
     prenda, y entonces no se arregla: se le pide el logo bueno para ese color. */
  Ropa.prototype.pintarCamuflaje = function (zonaId) {
    var self = this, caja = $(this.raiz, '[data-camu="' + zonaId + '"]');
    if (!caja) return;
    var malos = this.coloresElegidos().filter(function (c) {
      return self.riesgo(self.artePara(zonaId, c), c) >= CAMUFLAJE;
    });
    var propios = this.coloresElegidos().filter(function (c) {
      return !!self.arteColor[zonaId + '·' + c];
    });
    /* Un diseño al que se le ha quitado el fondo negro está pensado para prenda
       OSCURA: sobre una clara se queda sin la mitad del dibujo. No se bloquea
       —igual lo quiere así— pero se avisa antes de pagar, porque una devolución
       de diez camisetas la paga el taller. */
    var d0 = this.artePara(zonaId, this.colorVista);
    var claros = (((d0 && d0.arreglos) || []).indexOf('negro') === -1 || !window.Colocacion)
      ? [] : this.coloresElegidos().filter(function (c) {
        var h = self.hexDe(c);
        return h && Colocacion.luz(h) > 0.62;
      });
    if (!malos.length && !propios.length && !claros.length) { caja.hidden = true; return; }

    var html = '';
    if (claros.length) {
      html += '<p class="rop-aviso__t"><b>Este diseño estaba hecho sobre negro.</b> ' +
        'Al quitarle el fondo, en ' + esc(lista(claros)) + ' se ve solo el dibujo, ' +
        'sin el negro que lo rodeaba. Sobre prenda oscura queda como el original. ' +
        'Míralo arriba y decide.</p>';
    }
    if (malos.length) {
      /* Si lo que no se ve es un TEXTO, la salida no es subir otro archivo: es
         cambiarle la tinta para ese color de prenda. Pedirle un logo a quien ha
         escrito una frase sería mandarlo a un sitio donde no tiene nada. */
      var esT = !!(d0 && d0.texto) && !!window.Texto;
      html += '<p class="rop-aviso__t"><b>Este ' + (esT ? 'texto' : 'logo') + ' no se ve sobre ' +
        esc(lista(malos)) + '.</b> Es casi del mismo color que la prenda. ' +
        (esT
          ? 'Cámbiale la tinta para ' + (malos.length === 1 ? 'ese color' : 'esos colores') + ', o quíta' +
            (malos.length === 1 ? 'lo' : 'los') + ' del pedido.'
          : 'Súbenos la versión que uses para ' + (malos.length === 1 ? 'ese fondo' : 'esos fondos') +
            ', o quita ' + (malos.length === 1 ? 'ese color' : 'esos colores') + ' del pedido.') +
        '</p><div class="rop-aviso__b">' + malos.map(function (c) {
          return esT
            ? '<button type="button" class="rop-fix" data-texto="' + esc(zonaId) +
              '" data-texto-color="' + esc(c) + '">Cambiar la tinta para ' + esc(c) + '</button>'
            : '<button type="button" class="rop-fix" data-pide="' + esc(zonaId) +
              '" data-pide-color="' + esc(c) + '">Subir logo para ' + esc(c) + '</button>';
        }).join('') + '</div>';
    }
    if (propios.length) {
      html += '<p class="rop-aviso__ok">' + propios.map(function (c) {
        return '<span><b>' + esc(c) + ':</b> ' + esc(etiqueta(self.arteColor[zonaId + '·' + c])) +
          ' <button type="button" class="rop-aviso__x" data-quita="' + esc(zonaId) +
          '" data-quita-color="' + esc(c) + '" aria-label="Quitar el logo de ' + esc(c) + '">×</button></span>';
      }).join('') + '</p>';
    }
    caja.innerHTML = html;
    caja.className = 'rop-aviso' + ((malos.length || claros.length) ? '' : ' is-ok');
    caja.hidden = false;
  };

  // ¿algún archivo va justo de resolución o no se puede previsualizar?
  Ropa.prototype.floja = function () {
    var self = this, mal = false;
    // con editor, la calidad es la de las imágenes puestas (el archivo compuesto siempre sale a 300 ppp)
    if (this._editorLibre && this._editorLibre.pppMinimo) {
      var pm = this._editorLibre.pppMinimo();
      return pm != null && pm < (this.cfg.pppMin || this.cfg.pppPrueba || 80);
    }
    this.elegidas.forEach(function (id) {
      /* El dorsal no tiene resolución que valga: se corta de curvas, no se
         imprime de un mapa de píxeles. Su previa son 61 ppp y medirla aquí
         habría bloqueado todos los pedidos urgentes con dorsal. */
      if (self.esDorsal(id)) return;
      var d = self.artePara(id, self.colorVista), z = self.zonaDe(id);
      if (!d || !z) return;
      if (!d.px) { mal = true; return; }
      var ppp = pppDe(d, Colocacion.medida(z, d.px)[0]);
      if (ppp && ppp < (self.cfg.pppPrueba || 120)) mal = true;
    });
    return mal;
  };

  /* ¿Hace falta mandarle una prueba por correo antes de imprimir?
   *
   * Por defecto NO: ya ha visto su logo, en su sitio, a los centímetros de
   * verdad y sobre la prenda de su color, y ese mockup viaja dentro del
   * pedido. Mandar un correo en una camiseta de 13 € cuesta más en tiempo que
   * el propio pedido. Solo se manda cuando queda una duda de verdad.
   */
  Ropa.prototype.motivoPrueba = function () {
    var self = this;
    var notas = ($(this.raiz, '[data-notas]') || {}).value || '';
    if (notas.trim()) return 'nos has escrito una indicación y queremos confirmarla contigo';
    var sinVista = false, peor = 0;
    this.elegidas.forEach(function (id) {
      if (self.esDorsal(id)) return;   // mismo motivo que en floja()
      var d = self.artePara(id, self.colorVista), z = self.zonaDe(id);
      if (!d) return;
      if (!d.px) { sinVista = true; return; }
      var ppp = pppDe(d, Colocacion.medida(z, d.px)[0]);
      if (!peor || (ppp && ppp < peor)) peor = ppp;
    });
    if (sinVista) return 'uno de tus archivos no se puede previsualizar aquí y queremos enseñarte cómo queda';
    if (peor && peor < (this.cfg.pppPrueba || 120)) {
      return 'tu archivo va justo de resolución al tamaño que lo quieres';
    }
    return null;
  };

  Ropa.prototype.flash = function (msg) {
    if (window.Cargando) Cargando.aviso(msg, 8000);
  };
  /* Si el pedido no se puede añadir, bajo el botón sale un enlace de WhatsApp que ya lleva el informe (producto, navegador y los últimos pasos):
     el cliente solo pulsa enviar, no hay que pedirle direcciones raras ni capturas. */
  Ropa.prototype.informeError = function (motivo) {
    try {
      var btn = $(this.raiz, '[data-add]');
      if (!btn || !btn.parentNode) return;
      if (this._enlaceInforme && this._enlaceInforme.parentNode) this._enlaceInforme.parentNode.removeChild(this._enlaceInforme);
      var ult = (window.__diagLineas || []).slice(-14).join('\n');
      var txt = 'Hola, no he podido añadir mi diseño al carrito.\n' + location.href.split('?')[0] + '\n' + (motivo || '') + '\n\n— informe —\n' +
        navigator.userAgent.replace(/Mozilla\/5.0 /, '').slice(0, 90) + '\n' + ult;
      var a = document.createElement('a');
      a.href = 'https://wa.me/34934358257?text=' + encodeURIComponent(txt.slice(0, 1400));
      a.target = '_blank'; a.rel = 'noopener';
      a.textContent = '💬 Enviarnos el error por WhatsApp (ya va escrito, solo pulsa enviar)';
      a.style.cssText = 'display:block;margin:8px 0 0;text-align:center;font-size:1.3rem;font-weight:600;color:#1a7f37;text-decoration:underline';
      btn.parentNode.insertBefore(a, btn.nextSibling);
      this._enlaceInforme = a;
    } catch (e) { /* sin enlace, queda el aviso de siempre */ }
  };

  /* ---------- carrito ---------- */

  // el nombre de la propiedad del archivo de una zona, tal y como lo verá Xavi
  Ropa.prototype.nombreProp = function (z) {
    // con editor, el archivo de trabajo va oculto (empieza por _): el cliente ve el mockup
    if (this._editorLibre) return this.zonasPago().length === 1 ? '_Diseño' : '_Diseño · ' + z.nombre;
    return this.zonasPago().length === 1 ? 'Logo' : 'Logo · ' + z.nombre;
  };

  /* Las propiedades de línea de UN reparto de archivos por zona.
     reparto: [{ z: zona, d: dato }] */
  Ropa.prototype.propsDe = function (reparto) {
    var self = this;
    var notas = ($(this.raiz, '[data-notas]') || {}).value || '';
    var detalle = reparto.map(function (x) {
      // con editor: la zona que se cobra, y el archivo es la panorámica entera
      if (x.d && x.d.libre && self._tramos) {
        var r = self.tramoDe(x.z), a2 = Colocacion.area(x.z);
        return x.z.nombre + (r && !r.ocupado.fondo
          ? ' ' + fmt(r.ocupado.w, 1) + ' × ' + fmt(r.ocupado.h, 1) + ' cm' : ' fondo entero') +
          // 19/10 (Xavi): sin «(Pecho 20×25)»: el cliente solo ve la medida a la que se imprime de verdad (el nombre del tramo viaja en la línea de recargo: «Zona»)
          ' · archivo ' + fmt(a2[0], 1) + ' × ' + fmt(a2[1], 1) + ' cm';
      }
      if (x.d && x.d.libre && self._zonaSuperficie) {
        var a = Colocacion.area(self._zonaSuperficie);
        return x.z.nombre + ' · archivo panorámica ' + fmt(a[0], 1) + ' × ' + fmt(a[1], 1) + ' cm';
      }
      var m = Colocacion.medida(x.z, x.d.px || [1, 1]);
      return x.z.nombre + ' ' + fmt(m[0], 1) + ' × ' + fmt(m[1], 1) + ' cm';
    });
    // los dorsales también son «dónde va»: «Dorsal (nombre y número) en espalda»
    if (this._editorLibre && this._editorLibre.dorsalInfo && this.dorValidos().length) {
      var vistas = {};
      this._editorLibre.dorsalInfo().forEach(function (x) { (vistas[x.cara || x.vista] = vistas[x.cara || x.vista] || []).push(x.tipo === 'nombre' ? 'nombre' : 'número'); });
      Object.keys(vistas).forEach(function (c) { detalle.push('Dorsal (' + vistas[c].join(' y ') + ') en ' + c); });
    }
    var props = [['properties[Dónde va]', detalle.join(' · ')]];
    /* La impresión que va INCLUIDA en el precio de la prenda (a 0 y sin variante en `recargos()`) no tiene línea propia en el carrito: se anota aquí para que el
       carrito la enseñe («✔ Impresión en pecho: incluida en el precio de la prenda») y no parezca que falta (Xavi, 24/10: «queda raro que no desglose el pecho»). */
    try {
      if (this._tramos) {
        var incl = this.recargos().filter(function (x) { return !x.variante; }).map(function (x) { var z = self.zonaDe(x.zona); return (z && z.nombre) || String(x.nombre || '').replace(/\s*\d.*$/, ''); }).filter(Boolean);   // solo la zona («Pecho»): la medida real ya va en «Dónde va»
        if (incl.length) props.push(['properties[_incluida]', incl.join(' · ')]);
      }
    } catch (eInc) { /* sin la nota: el carrito sigue igual */ }
    /* Para el panel de producción (lo lee pedidosdtf.py): una entrada por zona con archivo,
       con su medida de impresión en cm y el NOMBRE de la propiedad donde viaja su archivo
       (la URL se rellena después, al subirlo, así que aquí solo va la clave). Nada de texto
       libre que interpretar. `w`/`h` = lo que se estampa; `aw`/`ah` = el archivo entero. */
    var dtf = [];
    // la técnica de cada zona (la Regent mezcla transfer digital delante y serigrafía detrás): el panel solo monta en DTF lo que es DTF
    var tzsD = (this._editorLibre && this._editorLibre.tecnicasPorZona) ? this._editorLibre.tecnicasPorZona() : [];
    reparto.forEach(function (x) {
      if (!x.d || (x.d.dorsal && !x.d.sinArchivo)) return;
      var e = { zona: x.z.nombre, archivo: self.nombreProp(x.z) };
      var tz = tzsD.filter(function (t) { return t.vista === x.z.id; })[0];
      if (tz) e.tec = /serigraf/i.test(tz.nombre || '') ? 'serigrafia' : 'dtf';
      if (x.d.libre && self._tramos) {
        var r = self.tramoDe(x.z), a2 = Colocacion.area(x.z);
        if (r && r.ocupado && !r.ocupado.fondo) { e.w = +r.ocupado.w.toFixed(1); e.h = +r.ocupado.h.toFixed(1); }
        else { e.w = +a2[0].toFixed(1); e.h = +a2[1].toFixed(1); }
        e.aw = +a2[0].toFixed(1); e.ah = +a2[1].toFixed(1);
      } else if (x.d.px) {
        var m2 = Colocacion.medida(x.z, x.d.px);
        e.w = +m2[0].toFixed(1); e.h = +m2[1].toFixed(1);
      } else return;
      dtf.push(e);
    });
    if (dtf.length) props.push(['properties[_dtf]', JSON.stringify(dtf)]);
    // lo de MidOcean (etiqueta MidOcean en la ficha; antes, la serigrafía con tramos) lo imprime MidOcean: el panel no lo monta en el DTF
    /* Botellas (14/10, Xavi): de cara al público todo se hace «en nuestro taller»; como se organiza la producción es cosa interna. Los pedidos pequeños en
       digital a todo color (hasta cfg.serigrafia.taller uds) los imprime el taller en UV DTF y no van a MidOcean: `_imprime` = taller y `_produccion`
       lo explica en la hoja (propiedades con «_», que no ve el cliente). Lo demás, MidOcean. */
    var sg = this.cfg.serigrafia, tecId = this._editorLibre && this._editorLibre.tecnicaInfo && (this._editorLibre.tecnicaInfo() || {}).id;
    if (sg && sg.taller && tecId === 'tdt' && this.resumen.unidades <= sg.taller) {
      props.push(['properties[_imprime]', 'taller']);
      props.push(['properties[_produccion]', 'IMPRIMIR EN EL TALLER (UV DTF, ' + this.resumen.unidades + ' uds): no se pide a MidOcean']);
    } else if (this.cfg.imprime === 'midocean' || this.cfg.serigrafia) props.push(['properties[_imprime]', 'midocean']);
    // diseño sin archivo (modo rápido del móvil): el taller lo prepara con los originales y la vista previa
    var sinArch = reparto.filter(function (x) { return x.d && x.d.sinArchivo; }).map(function (x) { return x.z.nombre; });
    if (sinArch.length) {
      props.push(['properties[_Nota taller]', 'SIN ARCHIVO: se monta en el panel desde el proyecto (' + sinArch.join(' + ') + ')']);
      props.push(['properties[_sinarchivo]', '1']);
    }
    /* La referencia del proveedor (ts150st, swra290…) para el listado de ropa del panel. */
    if (this.cfg && this.cfg.modelo) props.push(['properties[_modelo]', String(this.cfg.modelo)]);
    /* Lo que ha escrito, tal cual, con su fuente y su tinta. El PNG ya viaja en
       la propiedad del logo y es lo que se imprime, pero con esto el taller
       puede rehacerlo si hace falta y el cliente ve en su pedido lo que pidió,
       que en un texto es justo lo que va a repasar letra por letra. */
    if (window.Texto) {
      var textos = reparto.filter(function (x) { return x.d && x.d.texto; }).map(function (x) {
        return (reparto.length > 1 ? x.z.nombre + ': ' : '') + Texto.pedido(x.d.texto);
      });
      if (textos.length) props.push(['properties[Texto]', textos.join(' · ')]);
    }
    if (notas.trim()) props.push(['properties[Indicaciones]', notas.trim()]);
    var tinfo = this._editorLibre && this._editorLibre.tecnicaInfo && this._editorLibre.tecnicaInfo();
    var tzs = this._editorLibre && this._editorLibre.tecnicasPorZona ? this._editorLibre.tecnicasPorZona() : [];
    function txtTec(t) {
      if (!t.colores) return t.nombre;
      if (t.colores > 1 && t.usados) return t.nombre + ' · ' + t.usados + (t.usados === 1 ? ' color' : ' colores');   // los que lleva el diseño (cada uno, una pantalla)
      return t.nombre + ' · máx. ' + t.colores + (t.colores === 1 ? ' color' : ' colores');
    }
    if (tzs.length > 1 && tzs.some(function (t) { return t.id !== tzs[0].id; })) {
      // técnicas distintas por zona: cada una con la suya («Delante: Serigrafía · máx. 1 color · Espalda: …»)
      props.push(['properties[Técnica de impresión]', tzs.map(function (t) { return t.zona + ': ' + txtTec(t); }).join(' · ')]);
    } else if (tzs.length) props.push(['properties[Técnica de impresión]', txtTec(tzs[0])]);
    else if (tinfo) props.push(['properties[Técnica de impresión]', txtTec(tinfo)]);

    var arreglos = [];
    reparto.forEach(function (x) {
      (x.d.arreglos || []).forEach(function (a) {
        arreglos.push(x.z.nombre + ': ' + Archivo.pedido(a));
      });
    });
    if (arreglos.length) props.push(['properties[_arreglos]', arreglos.join(' · ')]);

    /* La resolución se dice zona a zona: cada una lleva su archivo y su tamaño.
       El dorsal no: no hay archivo del cliente que medir —se corta de curvas— y
       anotar los ppp de una previa sería anotar un número que no significa nada. */
    var res = reparto.filter(function (x) { return !!x.d.px && !x.d.dorsal; }).map(function (x) {
      var ppp = Math.round(pppDe(x.d, Colocacion.medida(x.z, x.d.px)[0]));
      return x.z.nombre + ' ' + ppp + ' ppp';
    });
    if (res.length) props.push(['properties[_resolucion]', res.join(' · ')]);

    /* Para producción: los que ponen "no" se pueden montar en pliego sin que
       nadie los mire. Los que ponen "sí" llevan el motivo. */
    var motivo = this.motivoPrueba();
    props.push(['properties[_prueba]', motivo ? 'sí — ' + motivo : 'no']);
    if (this._idDiseño) props.push(['properties[_diseno]', this._idDiseño]);
    /* Dorsales (nombre y número por prenda): la lista para leerla en el albarán y el JSON para el script
       de corte, con la cara, la posición y el tamaño de cada objeto del editor (en cm, desde la esquina
       de arriba a la izquierda de la cara). */
    var dl = this._editorLibre ? this.dorValidos() : [];
    if (dl.length && this._editorLibre && this._editorLibre.dorsalInfo) {
      props.push(['properties[Dorsales]', Dorsales.texto(dl)]);
      props.push(['properties[Letra del dorsal]', Dorsales.fuenteDe(this.dorFuente).nombre]);
      try {
        var jd = JSON.parse(Dorsales.json(dl, this.dorTinta, this.dorFuente));
        jd.elementos = this._editorLibre.dorsalInfo();
        props.push(['properties[_dorsales]', JSON.stringify(jd)]);
      } catch (e) { /* sin JSON: queda la lista de texto */ }
    }
    return props;
  };

  /* El mockup que se guarda con el pedido: la prenda repetida, una vez por
     zona, cada una con SU archivo y su medida. Es exactamente lo que el cliente
     ha visto antes de pagar. */
  Ropa.prototype.mockupDe = async function (reparto, color) {
    /* Con editor: la foto de la taza del color de la línea con el diseño
       montado, lo que ve el cliente (Xavi). Si está en la panorámica se
       pasa un momento a un lado con foto y se vuelve. */
    if (this._editorLibre && reparto.some(function (x) { return x.d && x.d.libre; })) {
      var ed = this._editorLibre, antes = ed.vista().id, hexAntes = this.hexDe(this.colorVista) || this.hexPorDefecto();
      try {
        ed.setColor(this.hexDe(color) || this.hexPorDefecto());
        var c = null;
        if (this._tramos) {
          // camiseta: las caras usadas, una al lado de la otra
          var cs = [];
          this.zonas().filter(function (z) { return z.libre; }).forEach(function (z) {
            ed.cambiarVista(z.id);
            var m = ed.mockup(700);
            if (m) cs.push(m);
          });
          ed.cambiarVista(antes);
          if (cs.length === 1) c = cs[0];
          else if (cs.length > 1) {
            c = document.createElement('canvas');
            c.width = cs.reduce(function (n, m) { return n + m.width; }, 0);
            c.height = Math.max.apply(null, cs.map(function (m) { return m.height; }));
            var cx = c.getContext('2d'), x = 0;
            cx.fillStyle = '#fff'; cx.fillRect(0, 0, c.width, c.height);
            cs.forEach(function (m) { cx.drawImage(m, x, 0); x += m.width; });
          }
        } else c = ed.mockup(800);
        if (!c && !this._tramos) {
          var lado = this.catalogo.filter(function (z) { return z.libre && z.id !== antes; })[0];
          if (lado) { ed.cambiarVista(lado.id); c = ed.mockup(800); ed.cambiarVista(antes); }
        }
        ed.setColor(hexAntes);
        if (c) return await new Promise(function (ok) { c.toBlob(ok, 'image/jpeg', 0.88); });
      } catch (e) { ed.setColor(hexAntes); }
      return null;
    }
    if (!window.Colocacion || !Colocacion.mockup || !reparto.length) return null;
    if (!reparto.every(function (x) { return x.d && x.d.thumb; })) return null;
    /* El nombre de la zona lo pone el propio mockup, que agrupa por cara: aquí
       van la medida y el archivo, cada uno en su línea. */
    var pies = reparto.map(function (x) {
      var m = Colocacion.medida(x.z, x.d.px || [1, 1]);
      return [fmt(m[0], 1) + ' × ' + fmt(m[1], 1) + ' cm', x.d.name];
    });
    try {
      var c = Colocacion.mockup(this.prenda,
        reparto.map(function (x) { return x.z; }), {
          color: this.hexDe(color) || this.hexPorDefecto(),
          arte: reparto.map(function (x) { return x.d.thumb; }),
          px: reparto.map(function (x) { return x.d.px || [1, 1]; }),
          pies: pies, titulo: color || ''
        });
      return await new Promise(function (ok) { c.toBlob(ok, 'image/jpeg', 0.86); });
    } catch (e) { return null; }
  };

  /* El formulario de una línea; con mockup o sin él, por si Shopify no lo admite.
     Si `urls` trae los logos ya subidos (otro color del mismo grupo), se manda
     la URL que devolvió Shopify en vez del archivo: así por el segundo color
     solo viaja el mockup, que son unos kB, y no otra vez un PDF de 20 MB. */
  Ropa.prototype.formDe = function (linea, props, reparto, mk, urls, aparte) {
    var self = this, fd = new FormData();
    fd.append('id', linea.id);
    fd.append('quantity', linea.uds);
    props.forEach(function (p) { fd.append(p[0], p[1]); });
    (linea.extra || []).forEach(function (p) { fd.append(p[0], p[1]); });   // propiedades propias de la línea (serigrafía por tramos)
    /* Solo se adjunta lo que es un archivo de verdad: un adjunto raro (Xavi,
       29/09, en el bidón: "parameter 2 is not of type 'Blob'") no puede
       tirar el pedido entero. Si falta el ARCHIVO del diseño sí se para,
       porque sin él no hay nada que imprimir. */
    var esBlob = function (v) { return typeof Blob !== 'undefined' && v instanceof Blob; };
    if (mk && esBlob(mk)) fd.append('properties[_Mockup]', mk, 'mockup.jpg');
    reparto.forEach(function (x) {
      // el dorsal no sube nada: su lista viaja en su propia línea del pedido
      if (x.d.dorsal) return;
      if (aparte && aparte.indexOf(x.z.id) !== -1) return;   // su archivo viaja en la línea de su recargo
      var k = self.nombreProp(x.z);
      if (urls && urls[k]) fd.append('properties[' + k + ']', urls[k]);
      else if (x.taller) { if (esBlob(x.taller.file)) fd.append('properties[' + k + ']', x.taller.file, x.taller.name); else throw new Error('sin archivo: ' + k); }
      else { if (esBlob(x.d.file)) fd.append('properties[' + k + ']', x.d.file, x.d.name); else throw new Error('sin archivo: ' + k); }
    });
    // con editor: los archivos originales del cliente, una vez subidos se reutiliza su URL
    (this._extrasLibre || []).forEach(function (x) {
      if (urls && urls[x.k]) fd.append('properties[' + x.k + ']', urls[x.k]);
      else if (esBlob(x.file)) fd.append('properties[' + x.k + ']', x.file, x.name);
      else if (window.console) console.warn('Original no adjuntable, se omite:', x.k, x.file);
    });
    return fd;
  };

  /* El botón «Añadir al carrito» (06/10, Xavi: «a veces hay que darle dos veces y a veces no hace nada»). Dos causas:
     1) preparar el diseño (componer los archivos a 300 ppp) bloquea el móvil unos segundos SIN avisar: el botón parecía muerto,
        el cliente tocaba otra vez y los toques se acumulaban; y
     2) cualquier error antes del primer try se perdía en silencio (promesa rechazada, sin mensaje).
     Ahora: un solo envío en vuelo (los toques de más se ignoran), el botón avisa AL INSTANTE y cualquier fallo se cuenta. */
  /* DIAGNÓSTICO (?diag=1 en la dirección de la ficha): mide en ESTE móvil cuánto tarda en crear y codificar un lienzo de 1, 2 y 3 MP,
     para saber si lo lento es el PNG, el lienzo o la memoria, sin adivinar. Enseña el resultado en pantalla. */
  Ropa.prototype.diagnostico = async function () {
    var cuadro = document.createElement('pre');
    cuadro.style.cssText = 'position:fixed;left:0;right:0;top:0;z-index:200000;max-height:78px;overflow:hidden;background:rgba(0,0,0,.72);color:#9f9;font:9px/1.25 monospace;padding:3px 5px;white-space:pre-wrap;pointer-events:none;';
    document.body.appendChild(cuadro);
    window.__diagBox = cuadro; window.__diagT0 = performance.now();
    // botón pequeño para bajar TODO el registro como archivo de texto (o copiarlo si el navegador no deja descargar)
    var bajar = document.createElement('button');
    bajar.type = 'button'; bajar.textContent = '⬇ log';
    bajar.style.cssText = 'position:fixed;right:6px;top:82px;z-index:200001;font:12px sans-serif;padding:6px 10px;border-radius:0;border:0;background:#111;color:#9f9;opacity:.9;';
    bajar.addEventListener('click', function () {
      var txt = (window.__diagLineas || []).join('\n') + '\n\nUA: ' + navigator.userAgent;
      try {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(new Blob([txt], { type: 'text/plain' }));
        a.download = 'log-imprimirlo-' + new Date().toISOString().slice(11, 19).replace(/:/g, '') + '.txt';
        document.body.appendChild(a); a.click(); a.remove();
      } catch (e) { try { navigator.clipboard.writeText(txt); } catch (e2) { /* sin portapapeles */ } }
    });
    document.body.appendChild(bajar);
    var out = function (t) { T(t); };
    out('DIAGNÓSTICO · ' + new Date().toLocaleTimeString());
    out('memoria ' + (navigator.deviceMemory || '?') + ' GB · núcleos ' + (navigator.hardwareConcurrency || '?') + ' · táctil ' + (window.matchMedia && matchMedia('(pointer: coarse)').matches) + ' · pantalla ' + innerWidth + 'x' + innerHeight + ' dpr ' + devicePixelRatio);
    if (performance.memory) out('heap JS ' + Math.round(performance.memory.usedJSHeapSize / 1048576) + ' MB de ' + Math.round(performance.memory.jsHeapSizeLimit / 1048576));
    // la red: cuánto tarda en contestar cada servicio que usa la página (una oficina con filtro o proxy los frena o los bloquea)
    [['Shopify CDN', 'https://cdn.shopify.com/shopifycloud/storefront/assets/storefront/origin_trials-318ab40a.js'],
     ['Google Fonts', 'https://fonts.googleapis.com/css2?family=Anton'],
     ['Klaviyo', 'https://static.klaviyo.com/onsite/js/SyzEq7/klaviyo.js?company_id=SyzEq7'],
     ['Judge.me', 'https://cdn.shopify.com/extensions/01a11069-f27f-71be-8e5a-2afba368643e/judgeme-772/assets/loader.js'],
     ['imprimirlo.com', location.origin + '/cart.js']].forEach(function (h) {
      var t0 = performance.now();
      conLimite(fetch(h[1], { mode: 'no-cors', cache: 'no-store' }), 15000, 'sin respuesta en 15 s')
        .then(function () { out('red · ' + h[0] + ': ' + Math.round(performance.now() - t0) + ' ms'); },
              function (e) { out('red · ' + h[0] + ': FALLA (' + (e && e.message) + ') a los ' + Math.round(performance.now() - t0) + ' ms'); });
    });
    var lados = [1000, 1500, 1750, 2000, 2400];
    for (var i = 0; i < lados.length; i++) {
      var L = lados[i];
      try {
        var t0 = performance.now(), c = document.createElement('canvas'); c.width = c.height = L;
        var cx = c.getContext('2d');
        for (var k = 0; k < 40; k++) { cx.fillStyle = 'hsl(' + (k * 9) + ',70%,50%)'; cx.beginPath(); cx.arc(Math.random() * L, Math.random() * L, L / 6, 0, 7); cx.fill(); }
        var t1 = performance.now();
        var b = await conLimite(new Promise(function (ok) { c.toBlob(ok, 'image/png'); }), 30000, 'png >30 s');
        var t2 = performance.now();
        out(L + 'x' + L + ' (' + (L * L / 1e6).toFixed(1) + ' MP): dibujar ' + Math.round(t1 - t0) + ' ms · PNG ' + Math.round(t2 - t1) + ' ms · ' + (b ? Math.round(b.size / 1024) + ' KB' : 'SIN ARCHIVO'));
        c.width = c.height = 1;
      } catch (e) { out(L + 'x' + L + ': ERROR ' + (e && e.message)); break; }
    }
    /* qué bloquea el hilo: tareas largas del navegador y cualquier función del editor que tarde más de 250 ms */
    try {
      new PerformanceObserver(function (l) { l.getEntries().forEach(function (e) { if (e.duration > 400) T('TAREA LARGA ' + Math.round(e.duration) + ' ms (empezó ' + (e.startTime / 1000 - (window.__diagT0 || 0) / 1000).toFixed(1) + 's)'); }); }).observe({ entryTypes: ['longtask'] });
    } catch (eL) { out('longtask no disponible'); }
    /* Long Animation Frames: dice QUÉ script (el nuestro, Judge.me, Klaviyo, un píxel de Shopify…) ocupa cada fotograma largo */
    try {
      new PerformanceObserver(function (l) {
        l.getEntries().forEach(function (e) {
          if (e.duration < 400) return;
          var sc = (e.scripts || []).slice().sort(function (a, b) { return b.duration - a.duration; }).slice(0, 3).map(function (x) {
            return Math.round(x.duration) + 'ms ' + (x.invoker || x.type || '') + ' ' + String(x.sourceURL || '').replace(/^https?:\/\//, '').slice(-55) + (x.sourceFunctionName ? ' ' + x.sourceFunctionName : '');
          }).join(' | ');
          T('LoAF ' + Math.round(e.duration) + ' ms (bloqueo ' + Math.round(e.blockingDuration || 0) + ') · ' + (sc || 'sin script: render/estilo/capa'));
        });
      }).observe({ type: 'long-animation-frame', buffered: true });
    } catch (eF) { out('long-animation-frame no disponible'); }
    var selfD = this;
    setInterval(function () {
      var ed = selfD._editorLibre;
      if (!ed || ed.__medido) return;
      ed.__medido = true;
      Object.keys(ed).forEach(function (k) {
        var f = ed[k];
        if (typeof f !== 'function') return;
        ed[k] = function () {
          var t0 = performance.now(), r = f.apply(this, arguments);
          var dt = performance.now() - t0;
          if (dt > 250) T('editor.' + k + ' tardó ' + Math.round(dt) + ' ms');
          return r;
        };
      });
    }, 1000);
    // latido: si el hilo principal se bloquea o el navegador frena los temporizadores, se ve aquí (hueco máximo entre latidos)
    var ult = performance.now(), hueco = 0, frames = 0;
    setInterval(function () { var n = performance.now(); hueco = Math.max(hueco, n - ult - 250); ult = n; }, 250);
    (function raf() { frames++; requestAnimationFrame(raf); })();
    setInterval(function () {
      T('latido: hueco máx ' + Math.round(hueco) + ' ms · fotogramas ' + frames + ' · pestaña ' + document.visibilityState + (performance.memory ? ' · heap ' + Math.round(performance.memory.usedJSHeapSize / 1048576) + ' MB' : ''));
      hueco = 0; frames = 0;
    }, 4000);
    out('— prueba del móvil hecha. Ahora diseña con 2 caras, pulsa «Añadir al carrito» y hazme captura de esta caja.');
  };

  Ropa.prototype.alCarrito = async function (op) {
    if (this._enVuelo) return false;
    this._enVuelo = true;
    /* Mientras se prepara el archivo el editor no se pinta: en el móvil cada cambio del botón obligaba a repintar el visor
       (capas grandes con mezcla) y la página se quedaba 10-15 s sin responder (trazas del 06/10, sin tareas largas de JS). */
    /* mientras se prepara y se sube, salir de la página deja el pedido a medias (el cojín sin el recargo de su segunda cara, IMP#1960):
       el navegador avisa antes de dejar que se vaya. Se quita justo antes de ir al carrito. */
    window.onbeforeunload = function (e) { e.preventDefault(); e.returnValue = ''; return ''; };
    var tactilQ = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    if (tactilQ && /[?&]quieto=1/.test(location.search)) { document.documentElement.classList.add('crg-quieto'); T('botón quieto (sin animaciones)'); }
    var ocultos = this._editorLibre ? $$(document, '.edl') : [];
    /* EXPERIMENTO ?liberar=1: en vez de ocultar (visibility), el editor y la galería se QUITAN del diseño de la página (display:none) mientras se sube:
       el navegador libera sus capas y su memoria gráfica. Si el atasco de ~8 s tras pulsar desaparece, es el peso del editor en pantalla. */
    var liberar = /[?&]liberar=1/.test(location.search);
    var galeria = liberar ? $$(document, '.product__media-wrapper, .product__media-list, .rop-libre-main') : [];
    var estilosPrevios = [];
    if (liberar) {
      ocultos.concat(galeria).forEach(function (e) { estilosPrevios.push([e, e.style.display]); e.style.display = 'none'; });
      T('LIBERAR: editor y galería fuera de la página');
    }
    ocultos.forEach(function (e) { e.style.visibility = 'hidden'; });
    if (ocultos.length) T('editor oculto mientras se prepara');
    try {
      var okAdd = await this._alCarritoInterno(op);
      if (okAdd && this._diferido) { var dif = this._diferido; this._diferido = null; setTimeout(dif, 1500); }
      return okAdd;
    }
    catch (e) {
      this.busy = false;
      this.informeError((e && e.message) || 'error');
      if (window.console) console.error('alCarrito', e);
      this.flash('No se ha podido añadir al carrito. Inténtalo otra vez o escríbenos por WhatsApp.');
      this.actualizar();
      return false;
    }
    finally { this._enVuelo = false; if (liberar) estilosPrevios.forEach(function (x) { x[0].style.display = x[1]; }); document.documentElement.classList.remove('crg-quieto'); if (this._quitarAviso) { this._quitarAviso(); this._quitarAviso = null; } window.onbeforeunload = null; ocultos.forEach(function (e) { e.style.visibility = ''; }); }
  };
  function opts_sinReintento(op) { return !!(op && op.precalentar); }
  Ropa.prototype._alCarritoInterno = async function (op) {
    op = op || {};
    T('CLIC añadir (alCarrito)');
    var self = this, res = this.resumen;
    if (this.busy || !res.lineas.length || !this.elegidas.length) return false;
    if (this.rep && this.rep.pendiente && this.rep.pendiente() > 0) {   // eligió un total y le faltan tallas por repartir
      var fa = this.rep.pendiente();
      this.flash('Te ' + (fa === 1 ? 'falta 1 ' + this.sust(1) : 'faltan ' + fa + ' ' + this.sust(fa)) + ' por repartir en tallas.');
      if (this._editorLibre && this._editorLibre.abrirCantidad) this._editorLibre.abrirCantidad();
      return false;
    }
    // una foto o imagen de muchos colores no se puede hacer en serigrafía (1 a 4 tintas): que cambie la zona a Transfer a todo color
    // las paletas de colores tienen que estar calculadas antes de cobrar (agrupan los tonos y fijan cuántas pantallas son)
    this.tablaPorTecnica();
    if (this.cfg.serigrafia && this._editorLibre && this._editorLibre.esperarPaletas) { try { await this._editorLibre.esperarPaletas(2500); } catch (e00) { /* se sigue con lo que haya */ } }
    // una foto en serigrafía ya no se bloquea (07/10, Xavi): se simplifica a pocos colores planos y el cliente lo ve en la vista previa; la tienda avisa en «¿Cómo se imprime?»
    var vPrevios = [this.zonasSinArte().length, this.sinResolver().length, this.faltaDorsal()];
    T('comprobaciones previas hechas');
    if (vPrevios[0] || vPrevios[1] || vPrevios[2]) return false;
    var exceso = this.excesoTramo();
    if (exceso) { this.flash(exceso); return false; }
    if (this.cfg.serigrafia && this._editorLibre && this._editorLibre.tecnicasPorZona && this._editorLibre.tecnicasPorZona().length > 3) {
      alert('Tu diseño lleva ' + this._editorLibre.tecnicasPorZona().length + ' zonas de impresión y el máximo online son 3. Quita alguna zona o pídenos presupuesto por WhatsApp.');
      return false;
    }
    if (this.cfg.serigrafia && this.pantallas() > this.maxPantallas()) {
      alert('Tu diseño lleva ' + this.pantallas() + ' colores de impresión entre todas las zonas y el máximo online son ' + this.maxPantallas() +
        '. Quita algún color o zona, o pídenos presupuesto por WhatsApp.');
      return false;
    }
    var r = this.raiz, btn = $(r, '[data-add]');
    // un aviso bajo el botón mientras dura (en móvil son 10-15 s): que no parezca colgado y no se vaya
    var avisoEspera = null;
    if (btn && btn.parentNode) {
      avisoEspera = document.createElement('p');
      avisoEspera.setAttribute('role', 'status');
      avisoEspera.style.cssText = 'margin:8px 0 0;text-align:center;font-size:1.3rem;opacity:.8';
      avisoEspera.textContent = op.presupuesto
        ? 'Estamos preparando el presupuesto con tu diseño. Puede tardar un poco: no cierres ni toques nada.'
        : 'Estamos guardando tu diseño. En el móvil puede tardar hasta medio minuto: no cierres ni toques nada, vamos al carrito en cuanto termine.';
      btn.parentNode.insertBefore(avisoEspera, btn.nextSibling);
      var quitarAviso = function () { if (avisoEspera && avisoEspera.parentNode) avisoEspera.parentNode.removeChild(avisoEspera); avisoEspera = null; };
      this._quitarAviso = quitarAviso;
    }
    if (this._editorLibre) {
      // preparar el diseño es lo lento: se avisa ANTES de bloquear el hilo y se deja pintar la rueda
      this.busy = true;
      T('antes de pintar el botón');
      if (window.Cargando) { Cargando.ocupar(btn, 'Preparando tu diseño…', false); await Cargando.pinta(); }
      else if (btn) { btn.disabled = true; btn.textContent = 'Preparando tu diseño…'; }
      T('botón pintado');
      var listo = false;
      try { listo = await this.prepararLibre(); } catch (e) { listo = false; if (window.console) console.error('prepararLibre', e); }
      if (!listo) {
        /* La preparación completa ha fallado (en el móvil, al codificar): último recurso, una sola vez, modo rápido (solo manda el proyecto y las piezas). */
        if (!this._forzarRapido && !op._reintento && !opts_sinReintento(op)) {
          this._forzarRapido = true; this._cachePrep = null; this.busy = false;
          T('preparación fallida: reintento en modo rápido');
          try { return await this._alCarritoInterno(Object.assign({}, op, { _reintento: true })); }
          finally { this._forzarRapido = false; }
        }
        this.busy = false;
        if (window.Cargando) Cargando.libre(btn);
        this.actualizar();
        return false;
      }
    }
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var zonas = this.zonas();

    /* PRESUPUESTO (op.presupuesto): las MISMAS líneas y archivos que irían al carrito, pero en vez de añadirlos a `cart/add.js`
       (el carrito de quien prepara el presupuesto) se recogen aquí y se mandan al Worker, que crea un pedido borrador con su
       propio enlace de pago. `envio` hace de `fetch(cart/add.js)`: contesta como si fuera Shopify, con los archivos como «@fN». */
    var pres = op.presupuesto ? { lineas: [], ficheros: {}, n: 0 } : null;
    var envio = async function (cuerpo, comoJson) {
      if (!pres) return null;
      var props = {}, linea = null, esBlobP = function (v) { return typeof Blob !== 'undefined' && v instanceof Blob; };
      var nuevo = function (id, q) { linea = { id: id, quantity: q, properties: {}, archivos: {} }; pres.lineas.push(linea); return linea; };
      var poner = function (l, k, v, nombre) {
        if (esBlobP(v)) { var f = 'f' + (pres.n++); pres.ficheros[f] = [v, nombre || v.name || k]; l.archivos[k] = f; return '@' + f; }
        if (typeof v === 'string' && /^@f\d+$/.test(v) && pres.ficheros[v.slice(1)]) { l.archivos[k] = v.slice(1); return v; }
        l.properties[k] = String(v); return v;
      };
      var visto = {};
      if (comoJson) {
        (cuerpo.items || []).forEach(function (it) { var l = nuevo(it.id, it.quantity); Object.keys(it.properties || {}).forEach(function (k) { poner(l, k, it.properties[k]); }); });
      } else {
        var l0 = nuevo(null, 1);
        cuerpo.forEach(function (v, k) {
          if (k === 'id') l0.id = v; else if (k === 'quantity') l0.quantity = v;
          else { var m = /^properties\[(.*)\]$/.exec(k); if (m) visto[m[1]] = poner(l0, m[1], v, v && v.name); }
        });
      }
      return { ok: true, status: 200, json: { properties: visto } };
    };

    /* Las líneas se agrupan por el JUEGO DE ARCHIVOS que les toca. Casi todos
       los pedidos llevan uno solo; si ha subido un logo aparte para la negra,
       son dos grupos. Cada grupo sube sus archivos UNA vez y el resto de sus
       líneas reutilizan las URL que devuelve Shopify. */
    var grupos = [];
    res.lineas.forEach(function (l) {
      var reparto = zonas.map(function (z) { return { z: z, d: self.artePara(z.id, l.color) }; });
      var firma = reparto.map(function (x) { return x.d._id; }).join('|');
      var g = grupos.filter(function (x) { return x.firma === firma; })[0];
      if (!g) { g = { firma: firma, reparto: reparto, lineas: [] }; grupos.push(g); }
      g.lineas.push(l);
    });

    /* Serigrafía por tramos: cada DISEÑO (grupo de archivos) paga el tramo que le toca por sus unidades totales, y se pide como
       UNA línea por color (con la variante del tramo y la cantidad de ese color); las tallas viajan en la propiedad «Tallas».
       `_libre` fija la cantidad: si se cambiara en el carrito, el tramo ya no sería el que se ha cobrado. */
    if (this.cfg.serigrafia) {
      grupos.forEach(function (g) {
        var total = g.lineas.reduce(function (n, l) { return n + l.uds; }, 0), tr = self.tramoSerigrafia(total), nz = self.zonasSer();
        if (!tr) return;
        var porC = [];
        g.lineas.forEach(function (l) {
          var c = porC.filter(function (x) { return x.color === l.color; })[0];
          if (!c) { c = { color: l.color, uds: 0, tallas: [] }; porC.push(c); }
          c.uds += l.uds; c.tallas.push(l.talla + '×' + l.uds);
        });
        g.lineas = porC.map(function (c) {
          return { id: (tr.vzz && tr.vzz[nz + '-' + self.zonasDis()]) || (tr.vz && tr.vz[nz - 1]) || tr.v, uds: c.uds, color: c.color, talla: '', precio: self.precioSer(tr, nz), extra: [
            ['properties[Color]', c.color], ['properties[Tallas]', c.tallas.join(' · ')],
            ['properties[_producto]', location.pathname],   // el carrito enseña y enlaza este producto, no el auxiliar de los tramos
            ['properties[Tramo]', 'Desde ' + tr.min + ' uds · ' + money(self.precioSer(tr, nz)) + ' por prenda' + '' + ' (' + total + ' en el diseño)'],
            ['properties[_libre]', String(c.uds)]] };
        });
      });
    }

    this.busy = true;
    if (window.Cargando) Cargando.ocupar(btn, 'Subiendo tu diseño…', true);
    else { btn.disabled = true; btn.textContent = 'Subiendo tu diseño…'; }
    try {
      var items = [];
      var aparte = [], archivosAparte = {}; // zonas cuyo archivo va en la línea de su recargo (ver más abajo)
      var mockupPrimero = null; // el montaje del primer color, para la línea del recargo
      for (var i = 0; i < grupos.length; i++) {
        var g = grupos[i], props = this.propsDe(g.reparto);
        /* El archivo que va al taller, recortado y con su medida (archivo.js). */
        for (var t = 0; t < g.reparto.length; t++) {
          var xr = g.reparto[t];
          if (!xr.d || xr.d.dorsal || !xr.d.file || !Archivo.archivoTaller) continue;
          var mmT = xr.d.px ? Colocacion.medida(xr.z, xr.d.px)[0] * 10 : 0;
          xr.taller = await Archivo.archivoTaller(xr.d, mmT, this.cfg.maxFileMb);
        }

        /* Dentro del grupo se separa POR COLOR. El mockup es la prueba de lo
           que el cliente ha aprobado, así que tiene que enseñar la prenda del
           color de esa línea: una camiseta verde no se justifica con la foto de
           una negra. Los logos, en cambio, se suben una sola vez para todo el
           grupo y los demás colores reutilizan sus URL. */
        var porColor = [];
        g.lineas.forEach(function (l) {
          var c = porColor.filter(function (x) { return x.color === l.color; })[0];
          if (!c) { c = { color: l.color, lineas: [] }; porColor.push(c); }
          c.lineas.push(l);
        });
        var urls = null;

        for (var j = 0; j < porColor.length; j++) {
          var sub = porColor[j], subidas = urls;
          T('montando la vista previa (mockup)');
          /* modo rápido: sin vista previa. El mockup también son lienzos y un toBlob, justo lo que congela el móvil (probable parada en «Subiendo tus logos…»);
             el taller trabaja con el proyecto y las piezas */
          var mk = g.reparto.some(function (x) { return x.d && x.d.sinArchivo; }) ? null : await this.mockupDe(g.reparto, sub.color);
          T('mockup hecho; subiendo al carrito');
          var enviar = async function (conMockup, conUrls) {
            var fd = self.formDe(sub.lineas[0], props, g.reparto,
              conMockup ? mk : null, conUrls ? subidas : null, aparte);
            if (pres) return await envio(fd, false);
            return window.Cargando
              ? await Cargando.subir(raiz + 'cart/add.js', fd, function (p) {
                  if (p >= 100) Cargando.ocupar(btn, 'Guardando…');
                  else Cargando.pct(btn, p, 'Subiendo tu diseño');
                })
              : await fetch(raiz + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          };
          T('subiendo: cart/add.js (formulario con ' + (sub.lineas.length) + ' líneas)');
          var r1 = await enviar(!!mk, true);
          T('subida respondida: ' + (r1 && r1.status) + (r1 && r1.ok ? ' ok' : ' FALLO'));
          /* Si falla se va quitando ayuda, por orden de lo que menos duele:
             primero se vuelven a subir los archivos en vez de reutilizar su URL,
             y después sin mockup. El pedido tiene que entrar sí o sí. */
          if (!r1.ok && subidas) r1 = await enviar(!!mk, false);
          if (!r1.ok && mk) r1 = await enviar(false, false);
          /* Dos archivos de diseño grandes en la MISMA línea hacen que Shopify devuelva un 500 o un 413
             (cojín o taza con una foto en cada cara: «No se ha podido añadir al carrito», 05/10/2026;
             cada archivo por separado entra bien). Último recurso: el archivo de cada cara de pago
             viaja en la línea de su propio recargo, así cada petición lleva un solo archivo grande. */
          if (!r1.ok && !aparte.length) {
            var conRecargo = self.recargos().filter(function (x) { return x.variante; }).map(function (x) { return x.zona; });
            g.reparto.slice(1).forEach(function (x) {
              if (x.d.dorsal || conRecargo.indexOf(x.z.id) === -1) return;
              var f = x.taller ? x.taller.file : x.d.file, nm = x.taller ? x.taller.name : x.d.name;
              if (!f) return;
              aparte.push(x.z.id);
              archivosAparte[x.z.id] = { k: self.nombreProp(x.z), file: f, name: nm };
            });
            if (aparte.length) {
              r1 = await enviar(!!mk, false);
              if (!r1.ok && mk) r1 = await enviar(false, false);
            }
          }
          if (!r1.ok) throw new Error('carrito');
          var item = r1.json ? r1.json : await r1.json();

          var comunes = {}, mios = {};
          props.forEach(function (p) { comunes[p[0].replace(/^properties\[|\]$/g, '')] = p[1]; });
          g.reparto.forEach(function (x) {
            if (x.d.dorsal) return;
            var k = self.nombreProp(x.z);
            var url = (item && item.properties && item.properties[k]) ||
                      (subidas && subidas[k]);
            if (url) { comunes[k] = url; mios[k] = url; }
          });
          (self._extrasLibre || []).forEach(function (x) {
            var u = (item && item.properties && item.properties[x.k]) || (subidas && subidas[x.k]);
            if (u) { comunes[x.k] = u; mios[x.k] = u; }
          });
          if (!urls) urls = mios;

          /* Aquí estaba el fallo: el mockup se subía con la primera línea y a
             las demás se les copiaba solo el logo, así que se quedaban sin
             prueba visual. Ahora también viaja su URL. */
          var mkUrl = item && item.properties && item.properties._Mockup;
          if (mkUrl) { comunes._Mockup = mkUrl; if (!mockupPrimero) mockupPrimero = mkUrl; }

          sub.lineas.slice(1).forEach(function (l) {
            items.push({ id: l.id, quantity: l.uds, properties: comunes });
          });
        }
      }

      /* Una línea por zona extra, con la cantidad igual al número de prendas.
         Así en el pedido se lee "10 × zona extra · Espalda" y no hay que
         deducir nada. La primera zona va incluida en la prenda. */
      var ex = this.extras(res.unidades);
      if (ex.banda && ex.zonas && !ex.banda.serig) {
        // las de pago: el dorsal no es una zona extra, va en su propia línea
        this.zonasPago().map(function (id) { return self.zonaDe(id); })
          .filter(Boolean).slice(1).forEach(function (z) {
          var d = self.artePara(z.id, self.colorVista);
          var m = Colocacion.medida(z, (d && d.px) || [1, 1]);
          items.push({
            id: ex.banda.id, quantity: res.unidades,
            properties: {
              'Zona': z.nombre,
              'Medida': fmt(m[0], 1) + ' × ' + fmt(m[1], 1) + ' cm'
            }
          });
        });
      }

      /* Los recargos de zona van en su propia línea, con la cantidad igual al
         número de unidades. En el pedido se lee "10 × Impresión en la taza ·
         Panorámica" y no hay que deducir de dónde sale el importe. */
      var recargosConArchivo = [];
      self.recargos().forEach(function (x) {
        if (!x.variante) return;
        /* Va atada a la taza: con el id del diseño (para que "editar" la
           reemplace) y la marca _recargo (el carrito no deja borrarla ni
           cambiarle la cantidad a mano; sigue sola a la taza). Xavi: "he
           borrado los extras por imprimir el otro lado y me dejaba hacer el
           pedido igualmente". */
        var pr = { 'Zona': x.nombre, '_recargo': '1' };
        if (self._idDiseño) pr['_diseno'] = self._idDiseño;
        if (mockupPrimero) pr['_Mockup'] = mockupPrimero; // en el carrito: el montaje con la etiqueta de la zona encima
        var ap = archivosAparte[x.zona];
        if (ap && aparte.indexOf(x.zona) !== -1) { recargosConArchivo.push({ x: x, pr: pr, ap: ap }); return; }
        items.push({ id: x.variante, quantity: res.unidades, properties: pr });
      });
      for (var ra = 0; ra < recargosConArchivo.length; ra++) {
        var rc = recargosConArchivo[ra], fdR = new FormData();
        fdR.append('id', rc.x.variante); fdR.append('quantity', res.unidades);
        Object.keys(rc.pr).forEach(function (k) { fdR.append('properties[' + k + ']', rc.pr[k]); });
        fdR.append('properties[' + rc.ap.k + ']', rc.ap.file, rc.ap.name);
        if (window.Cargando) Cargando.ocupar(btn, 'Subiendo la otra cara…');
        var rr = pres ? await envio(fdR, false) : await fetch(raiz + 'cart/add.js', { method: 'POST', body: fdR, headers: { Accept: 'application/json' } });
        if (!rr.ok) throw new Error('No se ha podido añadir todo al carrito.');
      }

      /* LOS DORSALES: una línea con la variante del tramo y la cantidad igual al
         número de dorsales escritos, más la lista.
         Va dos veces a propósito. `Dorsales` es la que lee Xavi en el albarán
         para repartir las prendas; `_dorsales` es el mismo dato en JSON, que se
         guarda en un fichero y se le pasa tal cual a plotter/dorsales.py. Sin
         eso habría que volver a teclear quince apellidos, y ahí es donde se
         cuelan las erratas que no se pueden arreglar después de cortar. */
      var dorL = this.dorValidos(), dorB = this.dorBanda();
      /* El color va resuelto, no como "automático": lo que el taller necesita
         saber es qué vinilo poner en la máquina, y si el pedido mezcla prendas
         claras y oscuras son dos. */
      var dorColores = lista(dorL.map(function (x) { return x.tinta; })
        .filter(function (c, i, a) { return a.indexOf(c) === i; }));
      if (dorL.length && dorB && dorB.id) {
        items.push({
          id: dorB.id, quantity: dorL.length,
          properties: {
            'Color': dorColores,
            'Letra': Dorsales.fuenteDe(this.dorFuente).nombre,
            'Dorsales': Dorsales.texto(dorL),
            '_dorsales': Dorsales.json(dorL, this.dorTinta, this.dorFuente)
          }
        });
      }

      /* La urgencia es UNA línea por pedido, con la variante del tramo que le
         toque a la cantidad. Así en el albarán se lee "Producción urgente 24 h
         · 5 a 9 prendas" y no hay que deducir de dónde sale el importe. */
      var bUrg = (this.urgente && this.cabeUrgente() && window.Urgente)
        ? Urgente.banda(this.cfgUrg(), res.unidades) : null;
      if (bUrg) {
        items.push({ id: bUrg.id, quantity: 1,
          properties: { 'Servicio': 'Producción hoy, entrega en 24 h' } });
      }

      T('resto de líneas: ' + items.length);
      if (items.length) {
        if (window.Cargando) Cargando.ocupar(btn, 'Añadiendo el resto…');
        var r2 = pres ? await envio({ items: items }, true) : await fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!r2.ok) throw new Error('No se ha podido añadir todo al carrito.');
      }
      if (pres) {
        /* Se manda al Worker: como mucho 6 archivos (primero los diseños, luego las pruebas y al final los originales: el Worker tiene un tope de peticiones a Shopify). */
        var prioridad = function (k) { return /^_Mockup/i.test(k) ? 1 : /^_/.test(k) ? 2 : 0; };
        var pares = [];
        pres.lineas.forEach(function (l) { Object.keys(l.archivos).forEach(function (k) { pares.push({ l: l, k: k, f: l.archivos[k] }); }); });
        /* la «nota» de los originales es un .txt solo para el taller: Shopify Files no admite ese formato y tumbaba el presupuesto («formato no admitido nota.txt», 24/10). Fuera. */
        pares = pares.filter(function (x) { var nom = (pres.ficheros[x.f] && pres.ficheros[x.f][1]) || ''; if (/^_Nota/i.test(x.k) || /\.txt$/i.test(String(nom))) { delete x.l.archivos[x.k]; return false; } return true; });
        pares.sort(function (a, b) { return prioridad(a.k) - prioridad(b.k); });
        var vivos = {};
        pares.forEach(function (x) { if (Object.keys(vivos).length < 6 || vivos[x.f]) vivos[x.f] = true; else delete x.l.archivos[x.k]; });
        var ficherosP = {};
        Object.keys(vivos).forEach(function (f) { ficherosP[f] = pres.ficheros[f]; });
        if (window.Cargando) Cargando.ocupar(btn, 'Creando el presupuesto…');
        var creado;
        try {
          creado = await Presupuesto.crear(this.cfg.presupuestoUrl, {
            titulo: this.nombreProducto(), nota: (this.textoPresupuesto ? this.textoPresupuesto() : '').slice(0, 480),
            lineas: pres.lineas.filter(function (l) { return l.id; }), ficheros: ficherosP,
            codigo: op.actualizar ? this._presCod : '', modo: op.actualizar ? 'actualizar' : ''
          });
        } catch (eP) {
          this._presWorkerFalla = true;
          this._presMotivo = (eP && eP.estado ? 'HTTP ' + eP.estado + ' · ' : '') + ((eP && (eP.motivo || eP.message)) || 'sin respuesta');
          T('el Worker de presupuestos falló: ' + this._presMotivo); throw eP;
        }
        this.busy = false; this.actualizar();
        return creado;
      }
      if (this._editando) {
        // se estaba corrigiendo un diseño: fuera las líneas viejas del carrito
        if (window.Cargando) Cargando.ocupar(btn, 'Quitando lo anterior…');
        try { await this.quitarLineasDe(this._editando); } catch (e) { /* si falla, se quedan y el cliente las quita a mano */ }
        this._editando = null;
      }
      if (op.sinIr) { this.busy = false; this.actualizar(); return true; }
      if (window.Cargando) Cargando.ocupar(btn, 'Vamos al carrito…');
      T('redirigiendo al carrito');
      if (this._quitarAviso) this._quitarAviso();
      window.onbeforeunload = null;   // ya está todo en el carrito: ir sin aviso
      if (window.Montajes && window.Montajes.activo()) {   // producto comprado desde «Tu montaje»: se vuelve a la pantalla de montajes para pedir otro (Xavi, 26/10/2026)
        window.Montajes.compra(location.pathname.split('/').pop());
        window.location.href = raiz + 'pages/tu-montaje?anadido=1';
        return true;
      }
      window.location.href = raiz + 'cart';
      return true;
    } catch (e) {
      /* La subida con los archivos montados falló (Shopify rechaza peticiones grandes: un cojín de 2 caras con dos PNG y dos fotos originales, cliente 06/10,
         «No se ha podido añadir al carrito»). Último recurso, una sola vez: se reintenta en modo rápido, que solo manda el proyecto y las piezas (~1 MB). */
      if (e && e.message === 'carrito' && this._editorLibre && !this._forzarRapido && !op._reintento) {
        this._forzarRapido = true; this._cachePrep = null; this.busy = false;
        T('subida fallida: reintento en modo rápido');
        try { return await this._alCarritoInterno(Object.assign({}, op, { _reintento: true })); }
        finally { this._forzarRapido = false; }
      }
      this.busy = false;
      this.informeError((e && e.message) || 'error');
      this.flash((e && e.message && e.message !== 'carrito') ? e.message
        : 'No se ha podido añadir al carrito. Inténtalo otra vez o escríbenos por WhatsApp.');
      this.actualizar();
      return false;
    }
  };

  /* ---------- diseños guardados en el navegador (IndexedDB) ---------- */
  var Diseños = {
    abrir: function () {
      return new Promise(function (ok, ko) {
        if (!window.indexedDB) return ko(new Error('sin indexedDB'));
        var r = indexedDB.open('imprimirlo-disenos', 1);
        r.onupgradeneeded = function () { r.result.createObjectStore('disenos'); };
        r.onsuccess = function () { ok(r.result); };
        r.onerror = function () { ko(r.error); };
      });
    },
    guardar: function (id, valor) {
      return Diseños.abrir().then(function (db) {
        return new Promise(function (ok, ko) {
          var t = db.transaction('disenos', 'readwrite');
          t.objectStore('disenos').put({ v: valor, t: Date.now() }, id);
          t.oncomplete = function () { db.close(); ok(); };
          t.onerror = function () { db.close(); ko(t.error); };
        });
      });
    },
    borrar: function (id) {
      return Diseños.abrir().then(function (db) {
        return new Promise(function (ok) {
          var t = db.transaction('disenos', 'readwrite');
          t.objectStore('disenos').delete(id);
          t.oncomplete = function () { db.close(); ok(); };
          t.onerror = function () { db.close(); ok(); };
        });
      });
    },
    leer: function (id) {
      return Diseños.abrir().then(function (db) {
        return new Promise(function (ok, ko) {
          var r = db.transaction('disenos').objectStore('disenos').get(id);
          r.onsuccess = function () { db.close(); ok(r.result ? r.result.v : null); };
          r.onerror = function () { db.close(); ko(r.error); };
        });
      });
    }
  };

  /* Modo edición: la ficha se abre con ?editar=<id> desde "Editar diseño"
     del carrito. Se recupera el diseño guardado, las notas, el color de la
     vista y las cantidades de las líneas del carrito con ese id. */
  Ropa.prototype.cargarEdicion = async function () {
    var id = new URLSearchParams(location.search).get('editar');
    if (!id || !this._editorLibre) return;
    var ed = this._editorLibre, self = this;
    try {
      var est = await Diseños.leer(id);
      if (!est) { this.flash('No encontramos ese diseño en este navegador. Puedes hacerlo de nuevo.'); return; }
      // mismo producto: las posiciones son absolutas. Sin esto el editor las recoloca respecto a la zona que se está viendo y, con 2 caras, el diseño de la otra se desplazaba
      delete est.zonaCm;
      ed.cargarEstado(est);
      var notas = $(this.raiz, '[data-notas]');
      if (notas && est.notas) notas.value = est.notas;
      this._editando = id;
      var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var cart = await (await fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      var colores = this.cfg.colores || [];
      (cart.items || []).forEach(function (it) {
        if (!it.properties || it.properties['_diseno'] !== id || it.properties['_recargo']) return;
        // serigrafía por tramos: la línea no tiene opciones de talla; sus tallas y su color van en las propiedades
        if (it.properties['Tallas'] && it.properties['Color'] && self.rep && self.rep.poner) {
          String(it.properties['Tallas']).split('·').forEach(function (par) {
            var m = /^\s*(.+?)\s*×\s*(\d+)\s*$/.exec(par);
            if (m) self.rep.poner(it.properties['Color'], m[1], parseInt(m[2], 10));
          });
          return;
        }
        var color = (it.variant_options || []).filter(function (v) { return colores.indexOf(v) !== -1; })[0] || '';
        // la talla de esa línea (antes se pasaba vacía y las tallas volvían todas a 0)
        var tallas = self.cfg.tallas || [];
        var talla = (it.variant_options || []).filter(function (v) { return tallas.indexOf(v) !== -1; })[0] || '';
        if (self.rep && self.rep.poner) self.rep.poner(color, talla, it.quantity);
      });
      if (est.colorVista) { this.colorFijado = true; this.colorVista = est.colorVista; }
      this.recalcularLibre();
      this.actualizar();
      this.flash('Tu diseño está cargado: cambia lo que quieras y vuelve a añadirlo al carrito.');
    } catch (e) {
      this.flash('No se ha podido recuperar el diseño.');
    }
  };

  /* PÁGINA DE COMPRA APARTE (móvil, serigrafía; Xavi, 07/10): al pulsar «Comprar» el diseño se guarda en el navegador y la ficha se
     recarga con ?comprar=id, con la memoria limpia de la edición. Allí se recupera el diseño y se abre el panel de compra (tallas,
     colores, precio y «Añadir al carrito»). Si algo falla al guardar, se abre el panel aquí mismo. ?completo=1 lo desactiva. */
  Ropa.prototype.irACompra = async function () {
    var ed = this._editorLibre, self = this;
    if (!ed || !this.cfg.serigrafia || !ed.estado || !window.indexedDB || /[?&](completo|comprar)=/.test(location.search)) return false;
    if (!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches)) return false;
    if (!ed.hayDiseno || !ed.hayDiseno()) return false;
    try {
      var est = await conLimite(ed.estado(), 8000, 'estado');
      est.notas = (($(this.raiz, '[data-notas]') || {}).value || '');
      est.colorVista = this.colorVista || null;
      /* las cantidades que ya había puesto (color, talla, unidades): la página se recarga y, sin esto, el panel de compra salía con todo a 0 */
      try { est.reparto = (self.rep && self.rep.lineas ? self.rep.lineas() : []).map(function (l) { return [l.color, l.talla, l.uds]; }); } catch (eR) { est.reparto = []; }
      var id = 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      await conLimite(Diseños.guardar(id, est), 6000, 'guardado');
      window.onbeforeunload = null;
      location.href = location.pathname + '?comprar=' + encodeURIComponent(id);
      return true;
    } catch (e) { return false; }
  };
  Ropa.prototype.cargarCompra = async function () {
    var id = new URLSearchParams(location.search).get('comprar');
    if (!id || !this._editorLibre) return;
    var ed = this._editorLibre;
    try {
      var est = await Diseños.leer(id);
      if (!est) { this.flash('No encontramos ese diseño en este navegador. Puedes hacerlo de nuevo.'); return; }
      delete est.zonaCm;   // mismo producto: posiciones absolutas (ver cargarEdicion)
      ed.cargarEstado(est);
      var notas = $(this.raiz, '[data-notas]');
      if (notas && est.notas) notas.value = est.notas;
      if (est.colorVista) { this.colorFijado = true; this.colorVista = est.colorVista; }
      var yoC = this;   // devuelve las cantidades que llevaba antes de pulsar «Comprar»
      (est.reparto || []).forEach(function (r) { if (yoC.rep && yoC.rep.poner) yoC.rep.poner(r[0], r[1], r[2]); });
      /* si lo que se pidió es de otro color que el que estaba mirando (miró el azul y pidió 100 negras), la vista pasa al color pedido:
         el editor, la previa y el carrito enseñan el mismo color */
      var cpC = this.coloresPedido ? this.coloresPedido()[0] : null;
      if (cpC && this.colorVista !== cpC) { this.colorVista = cpC; this.colorFijado = false; }
      this.recalcularLibre();
      this.actualizar();
      if (ed.abrirCompra) ed.abrirCompra();
      // las imágenes se decodifican un instante después: la vista previa se repinta cuando ya están
      [700, 1800].forEach(function (ms) { setTimeout(function () { if (ed.pedirPrevia) ed.pedirPrevia(); }, ms); });
    } catch (e) {
      this.flash('No se ha podido recuperar el diseño.');
    }
  };

  /* ---------- Mis diseños (guardados en el navegador) ----------
     Para clientes que repiten pedido (Xavi, 06/10/2026): dos iconos flotantes sobre el editor, «Guardar» y «Mis diseños».
     Se guarda solo el diseño y su composición (capas, textos, imágenes, posiciones), en el IndexedDB del navegador, compartido
     por todos los productos de la tienda: un diseño guardado en la camiseta se puede usar en la taza. Al cargarlo en otro
     producto el editor lo recoloca y lo reduce para que quepa en su zona. */
  var PREF_LIB = 'lib-', MAX_LIB = 30;
  Diseños.listar = function () {
    return Diseños.abrir().then(function (db) {
      return new Promise(function (ok, ko) {
        var out = [], r = db.transaction('disenos').objectStore('disenos').openCursor(IDBKeyRange.bound(PREF_LIB, PREF_LIB + '￿'));
        r.onsuccess = function () { var c = r.result; if (c) { out.push({ id: c.key, v: c.value.v, t: c.value.t }); c.continue(); } else ok(out.sort(function (a, b) { return b.t - a.t; })); };
        r.onerror = function () { ko(r.error); };
      });
    });
  };
  Diseños.borrar = function (id) {
    return Diseños.abrir().then(function (db) {
      return new Promise(function (ok, ko) { var t = db.transaction('disenos', 'readwrite'); t.objectStore('disenos').delete(id); t.oncomplete = function () { ok(); }; t.onerror = function () { ko(t.error); }; });
    });
  };
  Ropa.prototype.montarGuardarCargar = function (host) {
    var self = this, ed = this._editorLibre;
    if (!ed || !ed.estado || !ed.cargarEstado || !window.indexedDB || host.querySelector('.rop-gc')) return;
    var handle = location.pathname.split('/').filter(Boolean).pop() || '';
    var fila = document.createElement('div');
    fila.className = 'rop-gc';
    fila.innerHTML = '<button type="button" class="rop-gc__b" data-gc="guardar" title="Guardar este diseño" aria-label="Guardar este diseño">💾</button>' +
      '<button type="button" class="rop-gc__b" data-gc="cargar" title="Mis diseños guardados" aria-label="Mis diseños guardados">📂</button>';
    /* móvil (Xavi, 21/10: «los botones que no tapen, ponlos arriba»): 💾 y 📂 van en la barra de herramientas de arriba, no flotando sobre la taza */
    var barraArriba = host.closest('.rop-libre-wrap') && host.closest('.rop-libre-wrap').querySelector('.rop-libre-top');
    if (barraArriba && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) barraArriba.appendChild(fila); else host.appendChild(fila);
    fila.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-gc]');
      if (b) self.abrirMisDiseños(b.dataset.gc, handle);
    });
  };
  Ropa.prototype.abrirMisDiseños = async function (modo, handle) {
    var self = this, ed = this._editorLibre, previo = document.querySelector('.rop-lib'); if (previo) previo.remove();
    var vel = document.createElement('div'); vel.className = 'rop-lib';
    var hoja = document.createElement('div'); hoja.className = 'rop-lib__hoja'; vel.appendChild(hoja);
    function cerrar() { vel.remove(); if (ed.historialCerrar) ed.historialCerrar('misdisenos'); }
    vel.addEventListener('click', function (e) { if (e.target === vel) cerrar(); });
    function mk(tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; }
    function miniatura() {
      try {
        var d = ed.disenoZona && ed.disenoZona(40); if (!d || !d.canvas) return null;
        var c = d.canvas, k = Math.min(1, 220 / Math.max(c.width, c.height)), o = document.createElement('canvas');
        o.width = Math.max(1, Math.round(c.width * k)); o.height = Math.max(1, Math.round(c.height * k));
        var x = o.getContext('2d'); x.fillStyle = '#e9e9ee'; x.fillRect(0, 0, o.width, o.height); x.drawImage(c, 0, 0, o.width, o.height);
        return o.toDataURL('image/jpeg', 0.8);
      } catch (e) { return null; }
    }
    function bonito(h) { return (h || '').replace(/-/g, ' ').replace(/\s+/g, ' ').trim(); }
    async function pintar() {
      hoja.innerHTML = '';
      var cab = mk('div', 'rop-lib__cab');
      cab.appendChild(mk('b', '', modo === 'guardar' ? 'Guardar este diseño' : 'Mis diseños'));
      var x = mk('button', 'rop-lib__x', '×'); x.type = 'button'; x.setAttribute('aria-label', 'Cerrar'); x.addEventListener('click', cerrar); cab.appendChild(x); hoja.appendChild(cab);
      if (modo === 'guardar') {
        var inp = mk('input', 'rop-lib__nombre'); inp.type = 'text'; inp.maxLength = 40; inp.placeholder = 'Nombre (opcional), p. ej. Logo del club';
        var g = mk('button', 'rop-lib__guardar', '💾 Guardar en mis diseños'); g.type = 'button';
        g.addEventListener('click', async function () {
          g.disabled = true;
          try {
            var est = await ed.estado();
            if (!est.elementos || !est.elementos.length) { self.flash('Todavía no hay nada que guardar: añade una imagen o un texto.'); g.disabled = false; return; }
            var id = PREF_LIB + Date.now().toString(36) + Math.random().toString(36).slice(2, 5);
            await conLimite(Diseños.guardar(id, { est: est, mini: miniatura(), nombre: inp.value.trim(), producto: handle }), 8000, 'guardado');
            var lista = await Diseños.listar();
            for (var i = MAX_LIB; i < lista.length; i++) await Diseños.borrar(lista[i].id);   // se conservan los últimos 30
            cerrar();
            self.flash('Diseño guardado en este navegador. Lo tienes en «Mis diseños» (📂) para usarlo cuando quieras, en este o en otro producto.');
          } catch (e) { g.disabled = false; self.flash('No se ha podido guardar el diseño en este navegador.'); }
        });
        hoja.appendChild(inp); hoja.appendChild(g);
        hoja.appendChild(mk('h3', 'rop-lib__sub', 'Guardados'));
      }
      var lista = [];
      try { lista = await Diseños.listar(); } catch (e) { /* navegador sin almacenamiento */ }
      if (!lista.length) { hoja.appendChild(mk('p', 'rop-lib__vacio', 'Todavía no has guardado ningún diseño. Con el icono 💾 guardas el que estás haciendo y luego lo puedes usar en cualquier producto.')); return; }
      var ul = mk('div', 'rop-lib__lista');
      lista.forEach(function (it) {
        var d = it.v || {};
        var f = mk('div', 'rop-lib__it');
        var im = mk('div', 'rop-lib__mini'); if (d.mini) im.style.backgroundImage = 'url(' + d.mini + ')'; f.appendChild(im);
        var tx = mk('div', 'rop-lib__tx');
        tx.appendChild(mk('b', '', d.nombre || 'Diseño sin nombre'));
        var fecha = new Date(it.t).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
        tx.appendChild(mk('span', '', fecha + (d.producto && d.producto !== handle ? ' · de ' + bonito(d.producto) : '')));
        f.appendChild(tx);
        var u = mk('button', 'rop-lib__usar', 'Usar'); u.type = 'button';
        u.addEventListener('click', function (ev) {
          ev.stopPropagation();   // el clic de la fila entera no debe repetirlo
          if (ed.hayDiseno && ed.hayDiseno() && !window.confirm('Se sustituirá el diseño que tienes ahora en el editor. ¿Seguir?')) return;
          /* Primero se cierra la hoja y se deja que el historial del móvil asiente; luego se carga el diseño. Si se cargaba antes,
             el editor apuntaba su paso de guardia en el historial justo mientras la hoja retiraba el suyo, y el «atrás» interno
             hacía saltar «¿Salir sin añadir al carrito?». */
          cerrar();
          setTimeout(function () {
            try { ed.cargarEstado(d.est); self.flash('Diseño cargado. Puedes moverlo y cambiarlo como quieras.'); }
            catch (e) { self.flash('No se ha podido cargar ese diseño.'); }
          }, 250);
        });
        var del = mk('button', 'rop-lib__del', '🗑'); del.type = 'button'; del.setAttribute('aria-label', 'Borrar este diseño');
        del.addEventListener('click', async function () { if (window.confirm('¿Borrar este diseño guardado?')) { await Diseños.borrar(it.id); pintar(); } });
        f.addEventListener('click', function (e) { if (!e.target.closest('.rop-lib__del')) u.click(); });   // la fila entera es «Usar»
        f.appendChild(u); f.appendChild(del); ul.appendChild(f);
      });
      hoja.appendChild(ul);
    }
    document.body.appendChild(vel);
    if (ed.historialAbrir) ed.historialAbrir('misdisenos', function () { vel.remove(); });   // «atrás» en el móvil cierra la hoja, no pregunta si se sale
    pintar();
  };

  // quita del carrito las líneas que llevan ese id de diseño
  Ropa.prototype.quitarLineasDe = async function (id) {
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var cart = await (await fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    var updates = {};
    (cart.items || []).forEach(function (it) {
      if (it.properties && it.properties['_diseno'] === id) updates[it.key] = 0;
    });
    if (!Object.keys(updates).length) return;
    await fetch(raiz + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  };

  function init() {
    document.querySelectorAll('[data-ropa]').forEach(function (el) {
      if (!el._ropa) el._ropa = new Ropa(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
